module.exports = {
  "Gattaran_optimization_yGvp_jOAe": "Confirm",
  "Gattaran_form_tLLN_yhWQ": "Information on a frequently-used contact person will be filled in automatically. You can tap to edit the information.",
  "Gattaran_V1__YaIb": "Online",
  "FoodB_management_ncmO_lEBH": "Failed to Issue",
  "FoodB_2_Please_select_Mixz": "Please select",
  "Internal_Tools_0523_GtzK_ZoJh": "No eligible events joined. Ask store to join the auto promo event",
  "FoodOpB_Translation_Maestra_Accounts_ktyA": "Maestra account",
  "FoodB_0617_DewC_iPTt": "Daily orders completed with the competitor - R",
  "FoodOpB_management_Special_rules_PdhA": "Special Rules",
  "FoodB_up20241218_aEPD_NaLf": "Select Item(s)",
  "FoodB_Commision_Add_MPEf": "Add",
  "FoodC_202408_wten_GUVt": "Select Delivery Address",
  "FoodB_calculator_CXvv_RJgQ": "Receivable Amount Before Tax and Commission",
  "FoodB_tagging_You_chose_OMGB": "You chose to invalidate this lead for the following reason: “Store does not exist.” To do this, you must upload a photo.",
  "FoodB_calculator_gRHL_Sgok": "Profit Margin",
  "FoodB_collection_11_digits_QhYs": "Must contain 11 digits without space",
  "FoodOpB_management104_Coordinator_endx": "Coordinator account",
  "Help_V4_Enter_the_xqlm": "Please enter a valid mobile number",
  "Internal_Tools_CRM_afvI_xcXS": "Required image size: 750*360px",
  "Gattaran_transformation__TnQQ": "Associate new signatory",
  "Gattaran_merchantfee2_sTmZ_koaw": "Entered value cannot be less than {{min}}",
  "FoodB_0_Please_upload_ziBz": "Please upload a screenshot of the call history",
  "FoodB_phrase__NpWx": "Showing only sales promos ended in past {{number}} months",
  "FoodOpB_1_Expired_rTXx": "Expired",
  "FoodB_202303_YWUL_hwNF": "OK",
  "FoodB_page_aMFR_fMYY": "Recording Upload Failed",
  "FoodC_Storefront_iOFy_aaef": "This store is not participating in this promotion",
  "FoodB_0617_pLtb_hIQz": "Daily orders completed with the competitor - U",
  "Gattaran_0_Clerk_tends_QpMA": "Employee’s Preferred Contact Method",
  "FoodB_Show_Store_Direct_GuJM": "B-App Contract",
  "FoodOpB_Management_Appeals_foxk": "Appeal",
  "FoodB_optimization__bdZL": "Image must be in JPG or PNG format, under 5MB, and at least 200*200 pixels.",
  "Gattaran_management_NjMN_zyWQ": "Planned · {{date}}",
  "soda-c-i18n---个人中心的“优惠券”": " Account > Coupons.",
  "FoodB_1106_FGdT_UxXY": "Generating AI Summary",
  "Gattaran_opt_swMT_sNcV": "Promo-Combo",
  "Gattaran_20240401_rbqe_PoaI": "This survey is mandatory",
  "FoodC_sales_Confirmation_mTGd": "Got It",
  "FoodOpB_v2_Data_update_YmPK": "Data Updated Time",
  "FoodB_v1_Sources_of_DsXR": "Source of Info",
  "Gattaran_transformation__LMJQ": "Contract has been signed by signatory. Please add the store in Gattaran.",
  "soda-c-i18n---现金": "Cash",
  "FoodB_202502_ldlj_sqzT": "Submit",
  "Internal_Tools_App2_HwDq_KOci": "Tue",
  "FoodB_20260130_bbxn_DGDm": "Total Score",
  "Internal_Tools_App_Bruh_XLwk": "Week-on-week",
  "Internal_Tools_App2_wNPW_VZxE": "Market Pump Price",
  "FoodB_1__gcdX": "Event Data",
  "FoodD_payout_Account_Type_YmVW": "Account type",
  "Gattaran_statusbar2_eoSG_yEDD": "Approved",
  "Gattaran_record_IcKI_Jklz": "Edit Visit",
  "Gattaran_84_iOCg_cQuB": "Violation Details",
  "FoodB_email_CBNM_cSdr": "Email Address",
  "FoodB_V2_Illegal_companies_pXwb": "Missing corporate by laws",
  "FoodOpB_1_New_visits_HXsz": "Create Visit",
  "FoodB_opencheck_LMsZ_xcHH": "Completed",
  "FoodB_accompanyvisit_WSQI_ySkV": "Did the BD clearly understand weekly goals and work priorities?",
  "FoodC_sidebar_Use_the_huoZ": "Get the app to order anytime, anywhere",
  "CS_Aftersale_Wrong_meal_gNCe": "Wrong item(s)",
  "FoodB_management_Automatic_Switching_ghJS": "Auto-Open/Close Store",
  "FoodC_education_3_If_wduh": "3. If a delivery dispute is caused by reasons other than human factors, such as a product issue or bad weather, we’ll take responsibility",
  "FoodB_opencheck_RrIx_AlOc": "Please ensure the cover photo is appropriate and displays correctly on Customer app",
  "FoodB_scenario_UTGm_CSqz": "Store delivery delayed",
  "Gattaran_202406_eUIt_lfFS": "Completed",
  "Gattaran_url_nvGh_CcGr": "The URL must start with http:// or https://",
  "Gattaran_feedback_pIVP_WMGv": "Submitted successfully",
  "Gattaran_0__Yqcw": "There are no stores in the current area",
  "FoodB_Translation_fqel_jrJX": "Supporting Images (Optional)",
  "FoodB_communications_nVMa_oikA": "New Store Boost",
  "FoodB_opencheck_elIB_jhlk": "Please ensure the address information and location match the actual store location",
  "FoodB_audit_Store_Information_ryuV": "Edited store information review",
  "Gattaran_form_xrZg_zpSi": "Result",
  "Fintech_Credit_part__mMjm": "Filters",
  "FoodC_202410_ZHQi_kNsP": "Edit",
  "FoodC_c_Completed_djPp": "Ended",
  "Gattaran_0516_AZMU_LSZh": "Signed Stores",
  "FoodB_page_Zytk_sRrm": "Uploading Recording",
  "FoodB_list_Recently_launched_IWDa": "Last time online",
  "Gattaran_add_vitO_CCPh": "Picture coverage >= 60%",
  "FoodB_Contract_CqnW_XWkx": "Commission reward in the agreement",
  "FoodOpB_1_Seven_days'_LZwW": "Within Next 7 Days",
  "FoodB_v4_Ofdy_csVK": "Menu Item Photo Coverage",
  "FoodC_202408_qXNe_iBNs": "Unable to get current location",
  "更多": "More",
  "FoodB_APP_cmsF_AWtY": "Upcoming Events",
  "Gattaran_202406_lujp_fWRq": "Task Description",
  "FoodB_1__IhgO": "Last updated: {{time}}",
  "FoodB_management_vyNi_SrTR": "Supplies Management",
  "FoodB_0617_EuIs_mugQ": "How many home delivery orders does the restaurant handle each day?",
  "Gattaran_0__VRqN": "All stores have been loaded",
  "FoodOpB_1_Close_visit_ttxh": "Close Visit Confirmation",
  "Gattaran_side__MIpl": "Friday",
  "FoodC_Website_From_shop_Jatv": "Place an order from [shop name] | DiDi Food",
  "Gattaran_optimization_oRge_RkDM": "Visit Tasks Completed · {{month}}",
  "Gattaran_Optimization_zZhD_VHmE": "Tap to view the store address and enable navigation",
  "FoodB_SMS__promotion_EKZy": "Free Delivery Promo",
  "FoodB_V1_oOpd_aRtv": "Not Completed",
  "FoodB_up250108_BLxC_rIzf": "Check Later",
  "Internal_Tools_App_CwAV_dUXQ": "Feedback",
  "FoodC_202412_DMKw_kWMA": "Try searching by building, street & house number",
  "FoodB_1106_fJJY_Hpvo": "Record Again",
  "Gattaran_visit_zdKK_wwRk": "Visit Result",
  "Gattaran_opt_cWad_xQOF": "Imperfect Orders",
  "FoodB_audit_Review_process_vGtV": "review process. Are you sure you want to continue?",
  "FoodB_page_hrsd_hBdh": "Are you sure you want to exit? If you exit, your upload will not be saved.",
  "Gattaran_84_fQos_Hkqg": "Reminder",
  "FoodB_page_bkdh_cEvr": "Record",
  "FoodB_in_WoaK_VhQt": "Confirm",
  "FoodB_management_tchR_fhJi": "To Be Issued",
  "FoodC_20240607_ffiX_wNQG": "WhatsApp",
  "FoodB_20250122_FReB_KjrR": "Task Completer",
  "Gattaran_Gattaran__OuWt": "Total hours online",
  "Gattaran_20250610_NTRi_nVIB": "Complete RTBO",
  "FoodB_collection_idCIF_qqcc": "idCIF",
  "FoodB_IGV_iopU_urly": "IGV Rate",
  "FoodB_calculator_vEpj_lLGl": "Total Discount",
  "FoodB_feedback_mdHs_sFsm": "Feedback Details",
  "FoodB_0_WhatsApp_dmMD": "WhatsApp",
  "FoodD_Name_October_WGkU": "Oct",
  "FoodC_202412_QJMa_Qkwg": "Enter a new delivery address to add",
  "Gattaran_opt_RltV_fDyM": "Sales item (non-combo)",
  "FoodB_document_vGTm_pEcu": "The file to be uploaded cannot exceed {{limit}} MB. Please re-upload",
  "Internal_Tools_App_wlIb_LduM": "Gas Station Phone Number",
  "FoodB_Show_Tax_payment_xfxh": "National tax payment method",
  "Gattaran_Visit_Visiting_Process_KFJZ": "GRADE FOR THE VISIT",
  "FoodB_V1_uXrr_bWox": "You can manage or reset filters here",
  "FoodB_opencheck_gjbJ_NUmG": "Business Hours",
  "FoodB_indicator_jKXT_ctMP": "Metric Definition",
  "确认": "OK",
  "FoodB_communications_HAnw_bYAw": "Store(s) have incomplete tasks",
  "FoodC_education_3_Customers_Zoec": "3. You should have access to your phone during delivery to ensure the courier can get in touch with you if needed.",
  "Gattaran_KPI4_Sjnd_VzaZ": "Store Alert",
  "FoodB_1106_tawV_utGy": "Next Steps",
  "Gattaran_function__iTSm": "Version",
  "FoodB_list_B_Burn_LIiU": "B2C burn / GMV",
  "FoodC_202412_kamX_bNUi": "Please select an address to add",
  "FoodC_20240607_fIqe_iMtS": "Accept",
  "FoodB_questionnaire_gISQ_iumh": "Sales Tasks",
  "FoodB_2_Store_XkLQ": "Store",
  "FoodB_0622_Select_up_QXDl": "Select up to 2 stores",
  "FoodB_revamp_PrgK_BFoj": "For specific steps, please refer to:",
  "FoodB_1106_isfE_qwXl": "Uploading Voice File. Don't Leave This Page",
  "Gattaran_promo_MrxG_Yufr": "Smart Promotion Budget",
  "FoodC_edit_NDmM_lEJY": "Meet at door",
  "FoodC_202408_HfXO_xbcw": "View",
  "Gattaran_202406_jhpc_QSnv": "Reference Information",
  "FoodB_tagging_You_chose_aZCG": "You chose to invalidate this lead for the following reason: “Ceased operation.” To do this, you must be within {{distance}} from the store. Please verify and try again.",
  "Internal_Tools_App_zuDQ_HAZF": "Please enter a number (up to two decimal places)",
  "FoodB_in_RMIn_GztT": "Checkout Failed",
  "FoodB_accompanyvisit_xZuc_foEH": "Please describe how the BD positioned themselves during the engagement: Did they demonstrate empathy, practice active listening, and build genuine connections with the client?",
  "FoodC_education__1_vwgm": "(1) Deliver to door",
  "Gattaran_management_sGBh_ExWD": "Business Hours",
  "FoodB_resivion_Feedback_to_QmQU": "Please report it to your supervisor to update",
  "FoodB_task_BFBu_ONmI": "Task Not Executed",
  "FoodB_0926__Jfhv": "No promotions with this status",
  "Internal_Tools_App_vLxA_pkbn": "Add Image",
  "FoodB_0617_qpbP_bnWv": "Daily orders completed - Store delivery",
  "FoodC_perception_Tips_hZWk": "Tip",
  "Gattaran_0410_hDTJ_vhKk": "Click here to view the detailed performance information.",
  "FoodB_0907__jtsj": "No diagnostics data",
  "FoodB_20260130_aGfa_zSww": "Deepen Active Listening",
  "Gattaran_status_jQaO_nxvn": "Follow-up Status",
  "FoodB_20250122_IbZs_wRcg": "Resend task if it remains incomplete after X days since creation",
  "Gattaran_0_Need_to_uMbb": "Will check with DM",
  "FoodB_group0901_tZIs_QwiK": "Nominated",
  "Gattaran_Visit_Evaluation_eRDU": "Self-assessment",
  "Gattaran_V2_TPLj_miRJ": "Store List",
  "FoodC_optimization_rmLx_bSmk": "Please search for your meeting address to add it",
  "Gattaran_optimization_mtXy_iWsc": "Select at least 2 options",
  "Internal_Tools_App_qYbb_MgvG": "System error. Please try again later",
  "Gattaran_0_Salesmen_tend_hFQf": "Employee’s Best Contact Time",
  "FoodB_Show_Foreign_DIMEX_LKxF": "DIMEX",
  "FoodC_education_Meal_picking_ziun": "Delivery Rules",
  "Gattaran_subsidy_wnTI_MvfU": "Unable to add. This entity has had an exclusivity contract with a commission reward.",
  "FoodB_management_sgrl_Drgj": "Other",
  "Gattaran_0_Agree_gCQO": "Agreed",
  "FoodC_revision_Contact_customer_XbFk": "Contact Us",
  "Internal_Tools_App_mZpF_DDAl": "Price Trend",
  "FoodB_in_zsVG_TNBT": "This store has already checked in today. Check in again anyway?",
  "FoodB_1106_UJYm_mRFD": "You can edit the AI-generated content and submit the final record after confirmation.",
  "FoodC_shop__hSnf": "Only {{num}} left",
  "Internal_Tools_App_vFxG_UzcO": "Lead Status",
  "FoodOpB_Management_High_similarity_lnFn": "Similar Store Already Exists",
  "FoodB_Launch_DR_Passport_JChW": "Pasaporte",
  "Gattaran_Visit_Change_1_LYvR": "SHIFT 1",
  "FoodC_202410_mjfG_DDhf": "Add",
  "FoodB_opencheck_hHbN_hIdN": "Please confirm that the merchant's menu is complete: categories are correct, prices align with platform standards, and the display on the Customer app is accurate",
  "FoodB_0905__yxOa": "No change from last period",
  "FoodC_improvement_Rgol_abYw": "Your cancellation request was submitted and will be processed by the store within {{XminYs}}. Thank you for your patience.",
  "FoodB_survey_IQBT_jfZq": "Expiration date of the exclusivity contract with the competitor – P",
  "Gattaran_v1_Whrf_ZdCg": "Not registered. Please register on the Merchant App.",
  "Gattaran_0_Is_the_dYmK": "Menu experience",
  "FoodB_feedback_LZDo_DoVn": "Feedback",
  "Internal_Tools_App_qWbF_LiGR": "Calibrate Coordinates",
  "Internal_Tools_App_kqPi_MVIx": "Attention",
  "Gattaran_Homepage__bYLT": "Home Page",
  "Gattaran_0_The_end_KvBf": "End time must be after the start time",
  "FoodB_B86_bcPL_fkRh": "Past Issues",
  "Gattaran_visit_Wpaf_mvuG": "BD successfully reached an agreement",
  "Gattaran_Top_Qwud_sgUf": "2. Store’s DiDi Top tag is refreshed on the 2nd and 17th day of each month",
  "Internal_Tools_App2_VFPY_BWgZ": "Sun",
  "Gattaran_84_RhFf_bZsT": "Violation Type",
  "Groceries_shop2_Fwyu_yymq": "Sorry, you can only add up to {{num}} items to your cart",
  "FoodB_page_kKLt_Kkxo": "Visit Method",
  "FoodB_1106_vPRw_ajcX": "Are you sure you want to delete the recording?",
  "Gattaran_AlertV1_ADYi_okAH": "Got It",
  "Gattaran_V1_DJia_IZfI": "Completion",
  "FoodB_in_pytn_Fsdo": "You’re over {{distance}} meters away from {{storename}} and cannot check out. Take a photo with the store sign to complete it.",
  "FoodB_indicator_tnUG_juLY": "Rate of Orders with Missing/Wrong Item(s)",
  "FoodB_indicator_WkbT_GJnu": "Scoring Rules",
  "FoodB_scenario_ShEY_kNaS": "Major accident or utility outage (e.g., water/power loss)",
  "FoodB_20260130_lYVk_IIJb": "Improve Objection Handling",
  "FoodB_0_SMS_yOMB": "SMS",
  "Gattaran_0_KP_Tendency_hgOB": "Store Rep’s Best Contact Time",
  "FoodB_opencheck_jhOc_eZOf": "This store has business hours of less than 2 hours in a single day. Please confirm if this is correct to proceed with submission.",
  "FoodB_20260130_Lbce_revt": "Previous business knowledge",
  "FoodB_opencheck_TrQs_xHIv": "You have completed all open check confirmations for this store. All information will now go through manual review. Any fraudulent activity found will impact your performance.",
  "FoodC_payment_eCqh_ogxh": "Online payment is not available yet. Stay tuned!",
  "FoodB_survey_xyMR_sTst": "Exclusive with a competitor? – P",
  "Gattaran_subsidy_tyxq_WwhG": "Add Commission Reward",
  "FoodD_Name_February_bMVM": "Feb",
  "Gattaran_addded_wrMT_Smyq": "Quit Promo",
  "FoodC_202410_Ejdi_makf": "Select a Store",
  "FoodB_list_Name_of_dxYm": "DiDi Rep Name",
  "Internal_Tools_App_wjZO_XKBK": "Last {{week}} weeks",
  "Gattaran_REGULAR_UodO_bJVP": "Value cannot exceed 100",
  "FoodC_202408_Jvou_Cqor": "Nearby Places",
  "Internal_Tools_App_OMWw_QlWM": "Engaging",
  "Gattaran_V1__ZtqD": "View Promotion Tutorial",
  "soda-c-i18n---送您1张%s优惠券；": "we’ll give you a %s off coupon;",
  "Gattaran_202406_WOhb_WMrp": "You have received a high-priority task. Please view the task now.",
  "FoodB_20250122_aETX_fsRi": "day(s)",
  "Internal_Tools_App_MIpi_aqcx": "My Gas Stations",
  "FoodB_Contract_QbrO_gJzi": "The commission reward in the agreement is {{unit}} {{number}}%",
  "Gattaran_opt_ZoVs_IpEA": "Initiate contract signing, view the signing status and reasons for failure, and more here",
  "FoodOpB_management_Indicators_BzjD": "KPI",
  "Gattaran_visit_CRcg_FwpW": "No",
  "Gattaran_management_wjiE_tOBX": "Hi, {{name}}. Attached you will find the summary of the agreements reached during the visit:",
  "FoodB_20250414_zXUI_rXee": "Store Rewards",
  "FoodB_process_FzSw_LUcq": "RTBO Progress",
  "Internal_Tools_App_cuEn_PzWj": "Edit Navigation Address",
  "FoodB_accompanyvisit_yiVS_jbCk": "Please describe the BD’s attitude throughout the accompanying visit: Did they remain focused, proactive, and professional even when facing challenges?",
  "FoodD_AccountInfoCollection_Got_it_QvNt": "Got It",
  "Gattaran_Visit_Formula_pre_iaaI": "Formula = (Beginning of the Day Score + Meeting with the Customer Score + End of the Day Score) / 3 * 100%",
  "FoodB_Dimension_UVvy_UnnT": "Average Order Value",
  "Gattaran_Top_pXow_LHcq": "1. When a store’s “Completed orders,” “B cancel rate” and “Customer rating” meet certain standards, which vary from city to city and are detailed on the Store Details page, the store will be identified as a DiDi Top store",
  "Gattaran_Optimization_WwkH_amBP": "Tap to view more contact persons and make calls",
  "FoodC_optimization_GUGp_fDxe": "Back to Previous Page",
  "FoodB_Launch_DR_Temporary_BQFH": "Permiso residencia temporal",
  "FoodB_0830__BIGT": "Store visits this month",
  "FoodB_time_No_permission_Xxyy": "No permissions",
  "Internal_Tools_App_Rmvn_wSCd": "Gas Station ID",
  "FoodC_remark_Thank_you_ENoY": "Thanks for choosing {{brand_name}}",
  "FoodOpB_1_Information_gathering_pIHo": "Information collection",
  "FoodB_v108_jDaE_FNvH": "Store Name / ID",
  "Gattaran_V2_mEQa_FFuE": "Task Details",
  "FoodC_dish_Current_activity_Iyrv": "This promo ends in {{arrived_time}}. After that, new user deals will be unavailable",
  "FoodB_in_Nxye_qBAZ": "Back",
  "FoodB_20250414_uqsI_JhAj": "P1",
  "FoodB_email_mlcn_NvDS": "Preferred Contact Method",
  "soda-c-i18n---晚间：%s-%s": "Evenings: %s-%s",
  "FoodB_Validation2_UJDi_eBej": "Leading and trailing spaces are not allowed",
  "FoodB_2_Online_visit_OLuR": "In person",
  "Internal_Tools_0510_EoqC_dJrN": "Business hours not set",
  "FoodC_202410_YFVb_hzJK": "No address. Add now",
  "Gattaran_V1__WcTv": "Qualified Item Rate",
  "FoodB_model20250116_iVfy_zMbV": "Check-in successful",
  "FoodOpB_1_Visit_Details_fMYD": "Details of Visit",
  "FoodOpB_results_No_key_kUbv": "No KP's contact",
  "Gattaran_opt_ybdn_zFnD": "Please complete missing phone information",
  "FoodB_0919__flip": "Items Available",
  "FoodB_0617_Blon_MRMe": "Daily orders completed - In-store pickup",
  "FoodB_audit_Audit_process_asoS": "review process. You won’t be able to request a signature until the review is complete. Are you sure you want to continue?",
  "FoodB_20260130_pFZl_PAxD": "Sometimes",
  "FoodB_accompanyvisit_KOZp_Nkwc": "Was the BD able to identify the key pain points and guide the proposal accordingly?",
  "FoodB_calculator_dsiQ_vhFJ": "Receivable Amount",
  "Internal_Tools_App_pFzG_uAQv": "This lead has expired",
  "FoodC_202409_dTTH_bjFQ": "This order has been completed or does not exist, and cannot be viewed",
  "FoodB_V1_tdXj_tAvG": "Store Tasks",
  "Gattaran_202406_JcEF_NsbI": "Store Name",
  "FoodB_1106_qUmr_XNmN": "Recording Upload Failed",
  "Gattaran_visit_PQZP_gcOK": "Yes",
  "Internal_Tools_App2_xWJN_ZxWx": "Once deleted, the plan cannot be recovered",
  "Gattaran_Collection__cRDE": "Recent Searches",
  "FoodC_Website_At_present_XpFw": "Unable to redeem on web at this time. Please redeem promo code in the app",
  "FoodB_202204_Number_of_yYUn": "Negatively Rated Orders",
  "Gattaran_0_Add_Image_xyvl": "Increase picture coverage",
  "Gattaran_MSGCenter__JYjL": "Please enter",
  "FoodC_edit_bZFb_ghVG": "Meet outside hotel building",
  "FoodB_email_KYaO_tHVJ": "App Operator",
  "FoodB_Show_Savings_uvSS": "Savings account",
  "Gattaran_opt_aDBh_QgeX": "RTBO",
  "FoodB_Sales_NPeL_QUgG": "Show less",
  "Gattaran_subsidy_rKRR_cLtu": "A commission reward already exists for this entity. Do you want to replace it?",
  "Gattaran_form_hRvn_xomV": "Phone number is required",
  "FoodOpB_1_Visiting_hours_yAJS": "Time of Visit",
  "Gattaran_84_FlDC_sTHq": "Online Time on Other Platforms:",
  "FoodB_leads_Artificial_labcategory_UNzu": "Manual Tag Category",
  "FoodD_supplement_Small_time_ycjv": "hour(s)",
  "Internal_Tools_App_csEG_rLit": "Gas Station Tax ID",
  "FoodB_management_BWhh_FPtG": "Yes",
  "FoodB_opencheck_LSiU_XQss": "Store’s Turnaround Time",
  "FoodB_list_Store_ID_GNUR": "Store ID",
  "Gattaran_0__EDtg": "Enable Now",
  "Internal_Tools_App2_PcSB_DsIH": "Wed",
  "Gattaran_0_App_Opertends_voML": "App Operator’s Preferred Contact Method",
  "FoodB_system_offline_revV": "Offline",
  "FoodB_address_Submission_cfyI": "Submit",
  "Gattaran_promo_UFOX_VCXc": "Sale Items",
  "FoodOpC_Notifications_Are_you_DIlk": "Are you sure you want to delete this?",
  "FoodOpB_manage_Details_IfVh": "Details",
  "FoodB_0926__bEjZ": "No promotions not started",
  "FoodB_Side_HjnR_pape": "Sales",
  "FoodB_CL_Individuals_VUHt": "Individual",
  "FoodB_reason_Contact_Courier_Fqog": "Contact Courier",
  "Gattaran_202406_REeT_tgTh": "Task",
  "FoodB_20260130_bwfW_jXkh": "Effective Communication",
  "FoodB_list_Brand_Name_pGTc": "Brand Name",
  "Gattaran_transformation__IetC": "Create New Signatory",
  "Gattaran_optimization_dYfW_WtFS": "Completion",
  "Gattaran_management_LaXK_Gsyq": "My Visits",
  "FoodB_1106_LrXH_ibej": "Your AI summary is being generated. This may take 1–5 minutes. Closing this window will not end the process. Once complete, you can view it under the Follow-Up Information in the Lead Details page.",
  "FoodOpB_management_Actual_integral_xbDD": "Actual Points",
  "FoodB_revamp_ILMa_lOnw": "Metric Definition:",
  "Gattaran_optimation_Gchd_SmWz": "Skip",
  "FoodB_process_xaxm_WPYE": "Pending RTBO",
  "Gattaran_opt_dswD_GkVn": "Visit Info",
  "FoodB_v108_QiQv_BLcw": "Store Name",
  "Gattaran_Optimization_Gbsd_oiSb": "Store PK",
  "FoodC_202408_SXSA_LasS": "Add Mobile Number to Enjoy More Perks",
  "FoodB_0905__qppX": "{{number}} fewer orders than last period",
  "Gattaran_management_yrfV_Wxnn": "Expired Visit(s) · {{num}}",
  "FoodB_V3_XLPv_RMTE": "Handle Now",
  "FoodD_Name_December_Ykas": "Dec",
  "Gattaran_REGULAR_bTIM_MAXe": "Value cannot exceed 1000",
  "Internal_Tools_App2_ZJkV_KWsU": "Expired visit · {{num}}",
  "FoodB_process_xsHa_ISXI": "Rectified",
  "FoodB_opencheck_lCvT_CpyN": "Multi-Store Order Acceptance Configuration",
  "FoodB_score_dGue_AVfi": "No change from the previous period",
  "Gattaran_jumpnewstore_mLmx_PSph": "Complete New Store Boost task(s) to get extra traffic",
  "Gattaran_0516_bxzD_gtXp": "Associated Stores",
  "FoodB_20260130_HASZ_Gzyp": "Visit Outcomes",
  "FoodD_Compliance_About_to_fTcV": "Expires soon",
  "FoodD_Name_June_sECU": "Jun",
  "FoodB_in_sHcD_gWZN": "Take Photo",
  "Gattaran_opt_hEOr_vnKB": "Click here to edit basic lead information",
  "FoodB_in_gwvR_PqVc": "Please go to the mobile app to take a photo and upload it.",
  "Internal_Tools_0523_RFQp_wVYb": "Eligible",
  "FoodB_in_TaxL_JViY": "No check-in record. Visit time must be linked to a check-in record.",
  "FoodB_revamp_ibxC_nLBc": "Filter “Real-time”: Displays the estimated average order value in real time",
  "FoodB_opencheck_LMWw_Ntdr": "Not Completed",
  "FoodB_model20250116_dVSj_sFUN": "Awaiting review",
  "Gattaran_side__EEqj": "Saturday",
  "FoodB_page_FeSg_DGnj": "Transcript",
  "FoodB_opencheck_LuWf_IQwZ": "Please complete the call before confirming",
  "FoodB_page_DaRX_EbCh": "Auto-Fill Form",
  "Gattaran_Visit_jKcM_bAxG": "Close deals",
  "Gattaran_url_Myae_HenA": "{{Uber}} Menu Link Fetched by System",
  "Gattaran_Process20250815_FAmy_CJIx": "Commission rate request was not approved. You can edit and submit again",
  "Gattaran_0_Name_of_ZnnR": "Employee’s Name",
  "Gattaran_form_AEYH_GXlL": "Confirm Competitor Information",
  "Gattaran_management_pWnp_hrQt": "Summary",
  "FoodB_V1_DoLm_HYBb": "Not Started",
  "FoodB_opencheck_MGuv_oPMp": "Please check if the {{99store}} printer configuration is correct, if receipts can be printed, and if order notes are clear",
  "FoodB_V1_FPpu_unON": "Upload Dine-In Menu",
  "Gattaran_20240401_CGBK_NFyI": "Required Survey",
  "FoodOpB_Translation_Foreigner_hMcE": "CE-Carnet Extranjeria",
  "Gattaran_0_App_operators_aRSs": "App Operator’s Best Contact Time",
  "FoodB_20260130_SwZo_Vtxu": "Stage Rating: Commercial Conversation",
  "FoodB_1106_XQNm_orQN": "What are the key updates, customer needs, or critical issues?",
  "帮助中心": "Help Center",
  "Internal_Tools_App_ttnY_JnyP": "Primary Contact has been updated",
  "Gattaran_optimization_TyQA_JkkG": "Refresh",
  "FoodB_0919__RZJo": "Orders Completed",
  "FoodB_Optimization_alYq_lLkr": "Leads Storefront Photo",
  "Gattaran_form_JZlB_BGSo": "Enter actual reason",
  "Gattaran_feedback_IzpJ_EtUe": "Select Reason for Incomplete Task (Required)",
  "FoodC_web_Only_1_ZddK": "Limit 1 item",
  "FoodB_Optimization_YGkX_JqvJ": "The performance assessment for the month has not been configured in the system. Please contact the Commercial Planning team to learn the assessment results",
  "Gattaran_management_SBaW_IDnY": "Email Details",
  "soda-c-i18n---将赔付给您%s张免配送费券": "You get %s Free Delivery coupon",
  "FoodB_process_IUdd_MmbJ": "Appeal Successful",
  "FoodB_accompanyvisit_IwGb_xDta": "Did the BD conduct sufficient market research and ask targeted exploratory questions based on the partner’s actual situation?",
  "FoodB_1106_vAhW_qNLK": "Record Again",
  "FoodD_accept_vrSy_OJYX": "Auto Accept",
  "Gattaran_opt_SrLe_Wnrt": "{{change}} less than last period",
  "Gattaran_V2_aXUA_FYif": "Please enter the task name",
  "FoodB_opencheck_zmzr_ekYy": "Store Cover Photo",
  "Gattaran_202311_qwtt_tkJb": "Hotlist stores are shown. Please prioritize these stores for followup.",
  "Gattaran_address_WKng_Kgqu": "Same-Location Stores",
  "Gattaran_management_iAiq_CSuB": "A visit plan already exists for this time slot. Please edit and try again",
  "FoodD_Name_March_cqIc": "Mar",
  "Gattaran_form_UTaZ_WTAv": "You have unsaved information. Are you sure you want to leave?",
  "FoodB_opencheck_qYIq_JnQa": "Store Name",
  "FoodC_education_2_If_SoSk": "2. If a delivery dispute occurs because the courier did not follow our rules, we may hold the courier responsible",
  "FoodC_education__unk_aOCD": "{{delivery_type}} App Rules",
  "Gattaran_Visit_Please_choose_kUmR": "Please select person(s) accompanied",
  "FoodOpB_app_Need_for_inMl": "Additional meeting scheduled",
  "FoodB_calculator_UUgW_xBLd": "Item Count",
  "小费": "Tip",
  "Gattaran_V1__ccGl": "Last 30 days",
  "FoodB_Part1_Store_Name_jrHD": "Store Name",
  "Internal_Tools_App_rdCa_GHLw": "Latitude: {{lat}}",
  "sailing.crm-intl.普通": "General",
  "FoodC_education__2_jwSo": "(2) Leave at door (with note)",
  "FoodD_page_Manual_Accept_jCTW": "Manual Accept",
  "Internal_Tools_App2_VhOQ_uUiq": "Objective: {{objective}}",
  "Internal_Tools_CRM_hPLY_Zkpg": "Group",
  "FoodB_1106_EwXU_HfGg": "What work was completed?",
  "FoodB_Show_Subject_Information_RFOj": "Legal Representative/Proprietor Information",
  "FoodB_indicator_vrlT_COvu": "Data Range",
  "Gattaran_0__dPUc": "Up to {{amount}} stores can be loaded. Click to view more",
  "FoodB_v4_QCuD_iNCy": "Make sure the information of the person visited is filled out accurately after the visit",
  "Gattaran_opt2_aPIx_GJQw": "Operation Platform",
  "FoodB_accompanyvisit_nTXs_ubxz": "Please comment on how the BD prepared for the accompanying visit: Were the goals clearly defined, was the CRM system used effectively, and was strategic focus maintained during the visit?",
  "Gattaran_0_Remind_store_lgTS": "Remind restaurant to go online",
  "FoodB_0920__QnBO": "Diagnostics Rules Not Met",
  "Gattaran_transformation__LRHh": "Associate existing signatory",
  "Gattaran_opt_XUCE_CQDw": "Edit offline operations information",
  "FoodOpB_10_Order_volume_WNmq": "Orders",
  "FoodB_resivion_Skip_qpSD": "Skip",
  "Internal_Tools_App2_aAXv_aRlS": "Subregion {{number}}",
  "Internal_Tools_CRM_NNrK_cPfT": "Business Hours",
  "FoodB_model20250116_IADF_eXfa": "Check Out",
  "Gattaran_0_Promotional_materials_vvdT": "Marketing materials",
  "FoodOpB_CRM_Card_holder_NfIL": "Beneficiary ID number",
  "Internal_Tools_App_enKj_BRtS": "Price",
  "FoodB_20250414_qQjO_NTiY": "Timeline",
  "FoodB_Translation_CHLm_cImn": "Reason for Appeal",
  "FoodB_sob_tNpJ_cGze": "Tip: Once this mobile number is linked to {{shopname}}, stores can use it to sign in to SOB official website, find the store and continue to complete the onboarding process. Please note that, once linked, the mobile number cannot be edited",
  "FoodB_email_Lqnd_eyfn": "Agreements and comments",
  "Internal_Tools_App_oOXF_fLkh": "Confirm",
  "FoodB_process_URNV_nSAi": "Approved",
  "FoodC_202410_SiDC_Empm": "Order Now",
  "FoodB_20260130_hhVl_koul": "Strategic Preparation",
  "Gattaran_status_nmHO_eiGS": "Visited – No Positive Result",
  "FoodB_I_UlHM_KKLT": "Orders",
  "FoodC_optimization_RLDn_cLAQ": "Please Add Your Meeting Address",
  "FoodB_page_bAZB_UbSa": "Upload Audio File",
  "FoodB_APP_QiyP_UysU": "ASP",
  "FoodB_sob_ywDb_qwVV": "After linking the account, inform the store to use this mobile number to sign the contract on the SOB official website",
  "Gattaran_0__sGZg": "Feel free to share your feedback about Explorer with us.",
  "Internal_Tools_App2_TIxP_DqBp": "Remarks",
  "FoodB_Show_Aliens_Residence_creU": "Cédula de Residencia",
  "FoodC_sales_Condition_of_lnwg": "Was the item packaging sealed? (Required)",
  "Gattaran_Optimization_PLZM_XBgE": "Tap to view the store page on DiDi Food",
  "Internal_Tools_App_Mldc_EJhb": "More",
  "分钟": " min",
  "Internal_Tools_App_mKHz_CpID": "Get Coordinates",
  "FoodB_2_R_Burn_AyGL": "R burn/ GMV",
  "Gattaran_V1_MQcd_ixfe": "View All Eligible Stores",
  "FoodOpB_app_Need_to_eGSb": "Negotiating SUP",
  "FoodB_202204_Online_Rate_EQQU": "Online Rate",
  "FoodB_accompanyvisit_YSoL_pTLj": "Planning and Preparation",
  "FoodB_accompanyvisit_oTmI_wmHE": "Was the BD able to build genuine trust based on the restaurant’s situation and the decision-maker’s profile?",
  "FoodB_20260130_jmCn_dZjI": "The BD addresses doubts with empathy, technique, and clear arguments. Invites the restaurant to take the next step and always closes with a clear and concrete agreement that allows progress",
  "FoodC_202412_SxTA_sqKU": "Nearby Location",
  "Gattaran_REGULAR_luKX_QwKw": "Mexico Tax Input",
  "FoodB_0905__ccXH": "Diagnostics Period",
  "FoodC_remark_Enjoy_your_OvmD": "We hope you enjoy your meal",
  "Gattaran_0__XIOS": "Enter number of stores",
  "FoodB_score_DchG_OdBM": "Store Rankings",
  "Gattaran_form_zKmF_tGJc": "Confirm",
  "FoodB_opencheck_KYqZ_ipBk": "Please confirm that the store's business hours are reasonable and accurate. If the hours seem clearly incorrect, reconfirm with the store. Incorrect examples: operating not more than 2 hours per day or only during late-night hours (1:00–4:00)",
  "Gattaran_cancelation_CSTW_mefB": "Task Executed",
  "FoodB_20260130_ZUfZ_dQmW": "Uses tools such as C-app, B-app, and Explorer to support the pitch",
  "Gattaran_jumpnewstore_UjqV_XVxm": "New Store Boost",
  "Gattaran_202311_NpGG_CLsO": "Return results within {{distance}} of the store",
  "FoodC_reasons_Enter_a_Pnzg": "Please describe the issue in detail",
  "FoodB_V1_Yqgj_TuBe": "Expired",
  "Gattaran_optimation_shNo_Pflo": "Visit Form page exited unexpectedly. Tap “Reopen” to go back to the last page you were on.",
  "FoodB_calculator_hmWL_DEwB": "No",
  "FoodC_20240607_IbZr_cIyA": "Please check the store link and try again",
  "Internal_Tools_App_vOMm_KIrz": "Sign Out",
  "MRider_Version_payment_method_rQSI": "Payment Method",
  "FoodB_0617_Bibj_VmDq": "Competitor Platforms",
  "Gattaran_function__Comd": "Release Notes",
  "FoodB_Upload_qSTm_LkAc": "Dine-In Menu",
  "FoodC_education__4_QYXm": "(4) You refuse to pay for a cash order",
  "FoodB_V2_No_bank_plEI": "Missing bank account info",
  "FoodB_Show_Final_Tax_XQQi": "Definitive",
  "FoodB_opencheck_PWFs_yYqE": "Go Online & Order Acceptance",
  "FoodC_education__3_ltNM": "(3) Other factors outside of your control that cause the order to be cancelled, such as if we can’t find a courier to deliver the order, or some other issue on our end.",
  "FoodB_model20250116_QHad_xAWm": "Type of Visit",
  "FoodB_20260130_pTZf_mCnP": "Rarely",
  "Gattaran_jumpnewstore_WVcO_LmBU": "View Details",
  "Gattaran_add_XrAW_datb": "Available dishes >= 5",
  "FoodB_up20241218_ZADd_MrpU": "Please select between 1 and 5 items. Alcohol products and beverages cannot be selected.",
  "Gattaran_management_DvoF_BCCh": "Visit Tasks",
  "FoodB_revamp_fDsZ_yTgh": "Complete Now",
  "FoodOpB_CRM_Type_of_fbmW": "Beneficiary ID type",
  "Gattaran_status_NNzP_nKcZ": "Signed",
  "FoodB_Contract_YYIE_YBzS": "Yes",
  "Gattaran_Collection__YHYF": "Recommended",
  "FoodB_V2_Failure_to_sQaD": "Does not meet requirements",
  "FoodC_edit_fOqC_upyr": "Meet in lobby",
  "FoodB_accompanyvisit_ucKi_dFmF": "Please describe the BD’s attitude throughout the accompanying visit: Did they remain focused, proactive, and professional even when facing challenges?",
  "FoodOpB_management_Indicator_description_kePF": "KPI Description",
  "FoodB_20250612_vHLr_wHDi": "WhatsApp Number",
  "FoodB_Show_Tax_payment_Dbuz": "Local tax payment method",
  "Gattaran_transformation__PgJQ": "Legal Representative/Proprietor Information",
  "FoodC_202410_KMCG_kJBn": "Change",
  "FoodB_calculator_pQIn_LdhF": "Valid RFC?",
  "Internal_Tools_App_AsKa_smrq": "Select Product Type",
  "FoodOpB_Translation_BD_with_Jqpl": "Photo of BD with storefront",
  "Gattaran_20240902_AmRI_DoWJ": "Reason for rejection",
  "Internal_Tools_App_TwQH_yOgX": "Branch",
  "FoodC_all_No_reward_ocGJ": "No Rewards",
  "FoodB_0622_Contrast_jVys": "Compare",
  "FoodOpB_Translation_Enter_CCI_YyDK": "Enter CCI account",
  "FoodOpB_CRM_Taxpayer_full_tMpR": "Local Tax Payer Full Name",
  "Internal_Tools_App2_GYGq_FzxS": "There are over {{number}} offline visits planned for the day. The first {{number}} pending visit plans will be selected to generate a route.",
  "FoodB_communications_BCnM_evHy": "Store(s) have New Store Boost tasks due this week",
  "FoodB_APP_rOdA_ZxIz": "Smart Promotion",
  "Gattaran_v1_HLQw_cJDz": "Tap to show details about a store’s business hours",
  "FoodB_supplement_No_data_jUGB": "No data",
  "Gattaran_limit_NvlC_czdh": "Only the store’s BD can perform this action",
  "FoodB_Contract_fYLE_mfir": "Update Store Survey Information",
  "soda-c-i18n---联系商家": "Contact Store",
  "Gattaran_transformation__pglh": "Save and Go Back",
  "Gattaran_management_dWbz_DrVf": "In-person Visits Completed · {{month}}",
  "Internal_Tools_App_IadN_oKZj": "Bank Account Number",
  "FoodOpB_management_Weight_sGBg": "Weight",
  "FoodB_V1_pmrO_ZtzK": "Completed",
  "FoodC_edit_cKhP_xcTQ": "Meet at door to my home",
  "Internal_Tools_App2_ZTtV_pIEN": "Generate Route",
  "FoodC_202410_FxEp_LCxL": "Paying",
  "FoodOpB_CO_Provisional_Tax_ZpCx": "Provisional",
  "FoodC_edit_DOXu_EYnd": "Example: Please knock the door, don’t ring the doorbell. You can also upload pictures of your surroundings to help the courier deliver your order to the correct place.",
  "FoodB_process_HvCv_QDks": "To Be Rectified",
  "FoodB_accompanyvisit_hlno_QKSm": "Did they actively accept feedback during the accompanying visit and show a clear willingness to improve?",
  "Internal_Tools_App_uXeN_VtKY": "City",
  "FoodB_Side_cJSW_giyr": "Imperfect Orders",
  "Gattaran_V1__SttS": "Promotions",
  "Gattaran_V1_qsGI_Ulsk": "Loading data, please wait",
  "Gattaran_schedule_ajzu_twuj": "Limit Reached",
  "FoodB_opencheck_tUFp_hKlC": "There are no completed open check items",
  "Internal_Tools_App2_yIFi_UEbZ": "Mon",
  "FoodB_0926__pZyK": "No promotions in progress",
  "FoodB_Show_ID_Card_BrxO": "Cédula de Identidad",
  "FoodB_030_zOTR_tsWu": "My Target Area",
  "FoodB_1106_tybs_uREn": "Audio File Upload Failed",
  "Gattaran_withdraw_Ofwd_NgCY": "Once cancelled, this request process will end, and any subsequent signing request will need to be submitted again. Please exercise caution.",
  "Gattaran_merchantfee_Pqxr_WLCJ": "Entered value cannot exceed {{max}}",
  "Internal_Tools_App_SKgO_wHcV": "Financial Contact Phone Number",
  "Gattaran_V1_YDbp_akEe": "All valid promotions",
  "FoodB_0617_BYzk_fNiR": "Is there an exclusive contract with the competitor - R",
  "FoodB_202311_VkTS_OoIy": "Expired",
  "Internal_Tools_CRM_CJvi_BeaN": "ERP System",
  "FoodB_survey_eOXC_QSNG": "Loan Demand",
  "Gattaran_status_ojzr_GNwA": "Visited – Positive Result",
  "FoodB_revamp_rWFU_qICy": "Filter “Calendar Month”: Displays the store health score on the last day of the calendar month",
  "Internal_Tools_App_SvGD_UfGw": "Operations Data",
  "FoodD_payout_Company_Registration_zoVW": "Cédula Jurídica",
  "FoodB_indicator_lunF_LWgo": "Calculation",
  "FoodOpB_1_Visiting_Status_rbMX": "Status of Visit",
  "FoodB_audit_Distance_between_BRSw": "Distance between new and old stores",
  "FoodD_2_Income_Vqfp": "Earnings",
  "Others_boarding_City_choice_ryMd": "City Selection",
  "FoodB_record_HWEd_dEzy": "All",
  "FoodC_notice_fOyQ_lqIn": "Cash payment is unavailable. Please check whether the order amount exceeds your limit, or if you have another cash order in progress, then try again later.",
  "FoodB_Launch_DR_Foreigner_gXpW": "Cédula Extranjera",
  "FoodB_0617_bADA_vnGU": "Self-operated Order Service",
  "Gattaran_0__uLBv": "Enter number of orders",
  "FoodB_210811_No_tax_QkcN": "Missing tax document",
  "Internal_Tools_CRM_RyhE_fFHt": "Primary Contact Email",
  "Internal_Tools_App_ujvr_QghX": "Gas Station Images (Quantity Limit: {{amount}})",
  "Gattaran_V11_fscy_YDKX": "Requirements",
  "FoodC_20240607_wfRH_rTAa": "Store Info",
  "Gattaran_form_rnAn_flyZ": "Store rep’s phone number or photo(s) must be entered",
  "FoodB_collection_Taxpayer_Postal_guUo": "Taxpayer’s Postal Code (National)",
  "FoodB_1106_foqL_RTHY": "Please describe the following content via voice recording, audio upload, or text input:",
  "FoodC_202412_nXPk_kwtQ": "Address not found? Try different keywords",
  "Gattaran_20240401_LMVL_IKxX": "Exit App",
  "FoodB_1106_AyGO_yZLr": "Please ensure your network connection is stable and tap \"Analyze Again\". We will regenerate the AI summary.",
  "FoodOpB_tagging_You_chose_obli": "You chose to invalidate this lead for the following reason: “Ceased operation.” To do this, you must be within {{distance}} from the store. Please verify and try again.",
  "FoodB_management_Business_hours_VLnY": "Regular Business Hours",
  "FoodB_scenario_LpfM_MGER": "Other issues",
  "FoodC_edit_hDGv_arOT": "Meet in downstairs lobby",
  "Gattaran_Visit_Personal_Goals_FDcw": "Personal objective / Learning",
  "Internal_Tools_App_Hrci_mwCF": "Gas Station Address",
  "Gattaran_mgt_Search_Results_pFNV": "Search Results",
  "FoodB_420241024_mWia_Agjc": "Not achieved",
  "FoodC_education__1_mJTG": "(1) If the store has already confirmed and accepted the order, you can use the ‘Cancel Order’ feature to contact the store and ask to cancel the order. If the store does not agree to cancel the order because they have already finished preparing it, or other reasonable cause, you will not be able to cancel the order for free. If you insist on cancelling or refuse to accept all or part of the order, you will be responsible for paying all relevant order fees.",
  "Gattaran_mgt_Indicates_that_nHWP": "indicates “Not achieved”",
  "FoodB_APP_jedo_DJtn": "Promo Scenario",
  "Gattaran_V1__hUDQ": "Service",
  "FoodB_0_Please_upload_BZIQ": "Please upload a screenshot of the chat history",
  "FoodB_Show_Current_NJqK": "Current/Checking account",
  "Gattaran_0_Clerk_nZnx": "Employee",
  "FoodB_CL_power_of_KgHH": "Power of Attorney",
  "FoodC_edit_iuIV_BOva": "10 minutes",
  "Gattaran_mgt_Sort_QiOq": "Sort",
  "FoodB_list_KP_Phone_qQCQ": "Store Rep Phone",
  "FoodB_feedback_LxAh_DNGY": "History",
  "Gattaran_AlertV1_CYCs_NjzG": "Tap here to view store(s) that require your attention",
  "FoodB_Contract_wsvf_fSJn": "Dine-in price comparison in the agreement",
  "Gattaran_jumpnewstore_lspf_nNoN": "Tap here to open the New Store Boost module and view task details to help the store complete relevant task(s)",
  "FoodB_V2_dLkl_pbiF": "To perform this action, please update to the latest version of the app",
  "FoodB_1106_QRoy_iWHx": "Start Recording",
  "FoodB_opencheck_zqHl_BKuO": "Are you sure you want to mark this open check item as incomplete?",
  "FoodB_model20250116_innF_fIuu": "Checkout successful",
  "FoodB_management_Store_association_coYB": "Store Affiliation",
  "FoodC_202408_ksyj_sXlp": "About the Store",
  "Internal_Tools_App2_tYvt_cIHY": "Today",
  "Gattaran_store_ylep_UGpm": "Complete Contract Signing Through the Official Portal",
  "FoodC_202412_dCuL_VUFU": "Refresh",
  "Gattaran_0_Are_there_ouHJ": "It has more restaurants",
  "FoodC_202412_bolI_YXBT": "Saved Addresses",
  "FoodB_B86_Bhsy_ekdS": "Violation Management",
  "FoodD_Storefront_YFcS_cnUy": "DiDi Your Business",
  "Internal_Tools_App_WpuB_Tmys": "Yes",
  "FoodC_202412_Oant_EESB": "Next",
  "Gattaran_0_Edit_contacts_nCLZ": "Edit Contact Person",
  "Gattaran_20250610_qChL_aFTc": "Please contact the store to confirm the contract and complete RTBO",
  "Gattaran_function__fALF": "Cancel",
  "FoodB_method_hwZM_aUnb": "Download Explorer",
  "Gattaran_Feedback__urHD": "Low",
  "Internal_Tools_App2_NTbv_hmkk": "No visit information",
  "FoodB_management_Automatic_closing_xRSd": "Auto-Close Store",
  "Gattaran_opt2_UTsL_QVlH": "Others",
  "Gattaran_Visit_Total_score_iZIW": "Total GRADE",
  "Gattaran_202406_xlNL_HNSV": "We recommend uploading file type information on the GTR > Sales Task Management page",
  "FoodC_202408_RRtT_ZjIG": "Add Delivery Address",
  "FoodC_20240607_hhNB_mCBD": "Mobile Number",
  "FoodB_2_AOP_VVZV": "AOP",
  "FoodB_email_QTTk_ZllR": "Send Agreements to Brand",
  "FoodB_V1_raHO_jXSF": "R burn/GMV this month",
  "FoodB_20231012_GZve_uPZM": "Deadline calculation rules have been set for this task type. Please don’t enter them again.",
  "FoodB_diagnosis_Items_qQOR": "Item(s)",
  "FoodB_accompanyvisit_WLlY_tKoQ": "Accompanying Visit Plan, System, and Goals",
  "FoodB_field_No_need_hToz": "Not required",
  "FoodB_2__YqWB": "Reason for Declining",
  "FoodB_APP_rwZD_SFlh": "B2C + P2C burn / GMV",
  "FoodC_edit_Fyzp_tERt": "The courier will contact you when they arrive and wait at the agreed location for {{time}}. Please be ready to answer your phone",
  "Internal_Tools_CRM_nTMX_ElyI": "Exact Gas Station Location",
  "FoodOpB_Translation_Passport_jpaq": "Passport",
  "Gattaran_Visit_Pre_visit_NLpf": "GRADE FOR READINESS",
  "FoodB_opencheck_qJag_QHzZ": "Order Acceptance & Delivery Settings",
  "FoodB_requirement_uBiP_YocR": "Rate of Orders Not Prepared on Time",
  "Internal_Tools_App_RxZj_EZmI": "This week",
  "Gattaran_Visit_Tracking_KfAS": "Follow-up",
  "FoodB_calculator_CcKA_weRh": "For reference only: Final payment to stores may get deducted due to cancellations, after sales issues or other reasons.",
  "FoodC_202408_qGSr_IQoW": "Edit",
  "FoodB_APP_mDID_tHft": "Select Data Period",
  "FoodB_incomplete_hmSA_mNRv": "Mark as Incomplete",
  "Internal_Tools_App_QNzF_fvmK": "Contract Status",
  "Gattaran_add_MyGp_GdUb": "avatar",
  "FoodOpB_1_Visit_today_hLhX": "Today",
  "FoodB_20260130_BVCG_uZQW": "Formula = (Event 1 score / 5 + Event 2 score / 5 +...) / Number of valid scoring items * 100%",
  "soda-c-i18n---提交申请": "Request Cancellation",
  "FoodB_sob_FZWe_QYdT": "Mobile number {{num}} is linked. Please guide the store to use this number to sign in to the SOB official website and sign the contract.",
  "Gattaran_function__PRSL": "Download",
  "Internal_Tools_App2_drNi_CAgA": "Thu",
  "FoodB_page_ErfH_yeAb": "Please upload proof of the visit, e.g., screenshots of chats, online meetings, or emails",
  "Gattaran_0_Consistent_with_CiFN": "Same as menu",
  "FoodOpB_v2_Type_BpqS": "Type",
  "FoodB_1106_zLsQ_PVUN": "Follow‑up Method",
  "FoodB_1106_UWHB_lYiW": "Recording Transcription",
  "FoodB_1106_oEsa_BYuK": "What are the next steps?",
  "FoodC_202408_cjXm_VVcd": "After exiting, you won’t be able to view your order",
  "Gattaran_0_Buy_gifts_dbKh": "2x1, 3x2, 4x3, 5x4",
  "Gattaran_statusbar2_QzkZ_tHWY": "Draft",
  "FoodB_clockin_NbrI_oMtd": "Check In Time",
  "FoodB_opencheck_UtkB_sIJi": "Open Check Completed or Not",
  "Gattaran_0_No_match_Tgve": "Free Delivery",
  "Internal_Tools_App_UIXX_nKyD": "Data for up to 360 days is available",
  "Gattaran_visit_nNId_fOhX": "BD had a valid visit",
  "Gattaran_REGULAR_irYR_Bntt": "If you’re unsure whether your RFC is valid, please copy your tax ID and check it on the official website below:",
  "Gattaran_opt_ikuS_aRyl": "Visit Result",
  "FoodB_Contract_tvcI_RNvn": "Successfully upload the approved dine-in menu",
  "FoodC_revision_Less_meal_pHwq": "Item Issue",
  "FoodB_page_gpRd_UWVk": "Summary Generation Failed",
  "FoodB_task_HEvc_Emme": "{{X}} task(s) were executed during this visit",
  "Gattaran_Visit_Rating_after_lruO": "END OF THE DAY GRADE",
  "FoodB_1106_uIrJ_FVVL": "What are the key updates, customer needs, or critical issues?",
  "FoodB_communications_UOIk_QdZg": "Complete New Store Boost task(s) to get extra perks. Tasks expire in {{task_left_days}} day(s)",
  "FoodOpB_Translation_Please_add_mxTD": "Please upload any of the following three documents: Letter of Authorization of Legal Representative, Business Registration Certificate, Status Update Certificate",
  "FoodB_process_hZyR_OxLH": "Copy {{name}} Store Link",
  "FoodB_page_NuZX_bcTU": "Visit process and key updates to record",
  "FoodB_revamp_rHuI_wbds": "Filter “Yesterday” & “Last 7 Days” & “Calendar Month”: Displays the number of orders completed by the store during the selected period",
  "FoodB_Fields_CnCd_RzYS": "Under review",
  "FoodC_method_Wait_keAM": "Wait",
  "FoodOpB_management_Corresponding_fractions_QlGf": "Points",
  "FoodB_CL_Simple_company_JBRG": "Company (Simple)",
  "FoodC_edit_bxpb_udFq": "Example: Central Building, No. 88 Central Avenue",
  "FoodB_IV_Open_shop_xlhI": "Auto-Open Store",
  "Gattaran_visit_xnVQ_bENu": "Areas for improvement",
  "Gattaran_0_Package_fweo": "Combos",
  "FoodB_20260130_VCAk_tRtc": "Improve Visit Preparation and Strategy",
  "Internal_Tools_App_SruZ_Bhfa": "Exact Location",
  "FoodB_1106_eUGB_DZjs": "Key Updates",
  "Internal_Tools_Ops_ouPX_WYmu": "Gas Station ID",
  "FoodB_1106_oWun_aWqC": "No key updates at this time",
  "Internal_Tools_App2_laAj_weWi": "Continue",
  "Gattaran_Visit_After_a_ILbF": "End of the Day",
  "Gattaran_20240902_ahLx_jQSe": "The {{tasktype}} task you created for {{shopname}} was rejected. Please complete the task reference information based on the reason for rejection.",
  "FoodB_page_YAuh_BBZp": "Analysis Results",
  "FoodB_0622_Store_management_ztNB": "Store Operations",
  "FoodB_20250612_WpCB_xKZJ": "Others",
  "FoodB_202402_TFYh_dasm": "Others",
  "FoodB_revamp_yOZl_Jyez": "Average Order Value",
  "FoodB_2_phDI_Aept": "Upload Supporting Image",
  "Gattaran_202406_SQiw_AXZW": "Sales Task Management",
  "Gattaran_tag_mnOh_LlIQ": "Promo expiring",
  "Gattaran_V1__zewR": "Menu",
  "Gattaran_store_HrLF_aQuF": "Onboard",
  "Gattaran_Collection__twwL": "You can view the full visit log here",
  "FoodB_1106_grLB_GkRM": "If you leave the page during the upload, the current result will not be saved.",
  "FoodC_202408_tlOV_uOmJ": "Add your mobile number to enjoy order discounts",
  "FoodB_communications_hhCR_kEAh": "Store(s) have tasks due this week",
  "FoodB_FAQ_RQfm_qTIo": "Compared to yesterday:",
  "Gattaran_page_DWAi_yiXk": "Store Contract Signing",
  "Internal_Tools_App_pynL_unFB": "Merchant Type",
  "Gattaran_V11_DQdi_QRqK": "Not achieved",
  "Gattaran_mgt_Performance_data_ymwM": "Performance Data",
  "FoodB_field_Needs_IbzB": "Required",
  "Internal_Tools_CRM_APZA_BShD": "Basic Info",
  "Internal_Tools_App_NkMV_mnZQ": "Locate by Map",
  "FoodB_management_pBMo_Pdsx": "Copied to clipboard",
  "FoodB_Side_Etep_PIxp": "Turnaround Delay",
  "FoodB_1106_ACTr_mhVt": "Confirm",
  "Gattaran_0_Visit_Information_hzgb": "Visit Info",
  "Gattaran_opt_KdGX_oUmM": "Sign contract",
  "FoodB_survey_yEPf_ujZP": "Daily orders completed with the competitor – P",
  "FoodB_executors20241225_bYiY_UfOD": "Automatic Assignment Logic",
  "Gattaran_center__TkvV": "No messages",
  "soda-b-homepage-i18n---首位必须是1，必须输入11位": "The first digit must be 1 and 11 digits must be entered.",
  "Gattaran_Visit_APP_Review_nbGn": "App Review",
  "FoodOpB_Org_Add_at_nQez": "At least one KPI should be added. Please check and try again.",
  "FoodB_comparison_dRXO_qebt": "Adjust Price",
  "Gattaran_form_nFaJ_bcHw": "Contact Person",
  "FoodB_1106_jqDc_LmDv": "Your recording failed to upload. Please ensure your network is stable and try recording again.",
  "Groceries_1_MhVY_Etfm": "Item Changed",
  "Internal_Tools_App_AFZd_haQA": "Group",
  "FoodB_collection_Enter_idCIF_NeUD": "Enter idCIF",
  "Internal_Tools_App_XqPY_lOag": "Payment Methods",
  "FoodB_accompanyvisit_tcgk_TvAZ": "Did the BD skillfully use the CRM system to organize visits and plan follow-up tasks?",
  "FoodB_process_jvuI_tPXa": "Choose Main Item",
  "Gattaran_side__sOcs": "Tuesday",
  "Gattaran_REGULAR_OPsx_JMnf": "Calculate",
  "FoodB_opencheck_EdLx_RFyR": "Please check the go-online and order-accepting configurations on {{99store}}",
  "FoodB_scenario_YcnE_hnLK": "Order address is in an unsafe area",
  "FoodB_up20241218_VRuL_OZqJ": "Event Promotion Pre-registration",
  "FoodB_audit_The_strings_NPFx": "Clicking Confirm will initiate the “{{strings}}” review process. It’s not allowed to request contract signing until the review is completed. Continue?",
  "Gattaran_cancelation_divJ_nbOW": "Task Not Executed",
  "Gattaran_Mode_DJzU_JeyE": "Business Mode",
  "FoodB_revamp_tOYW_dwAT": "Filter “Real-time”: Displays the store's estimated real-time revenue",
  "FoodB_feedback_PCwL_NbGi": "Unable to Submit Feedback",
  "FoodC_1_dXUH_ThDd": "See more",
  "Gattaran_Visit_View_Visit_eZdF": "View Visitation Plan(s)",
  "FoodB_revamp_jEtx_GUqT": "Health Score",
  "FoodB_20260130_Czox_PUeI": "Objection handling and communication",
  "Gattaran_Process20250815_EISY_wPEZ": "Commission rate request is under review",
  "FoodB_ads_yERH_XMYy": "Is the promotion ads registration successful?",
  "GDriver_B_apbe_dntZ": "Gas Station Name",
  "Internal_Tools_App_lbMG_ilBX": "Service Facilities",
  "Gattaran_v1_guwq_yflY": "Tap to display event promotion details",
  "FoodB_governance_ireV_yxHO": "Task Deadline",
  "FoodC_edit_oOAR_FExH": "Office Building",
  "FoodC_202412_MrwA_fRUi": "This store is currently closed. Please visit again later",
  "FoodB_0707_Lifted_off_tnXl": "Unavailable",
  "Gattaran_ProgressManagement_ArNE_PsZi": "Assignee",
  "FoodB_email_qdfP_heFs": "Hi! We visited your store {{store_name}} and reviewed the following together with {{person_to_be_visited}}:",
  "FoodB_management_osog_jVEE": "Friend / Family Member of Store Owner",
  "FoodB_0113_ZcCF_NbjE": "You can add a visit plan here",
  "Gattaran_0__VQyB": "My stores",
  "FoodB_Show_Special_residence_ezfV": "Permiso Especial de Permanencia",
  "FoodC_202408_ajMC_lsta": "Store Closed",
  "FoodB_audit_Review_Opportunity_ZQHk": "Edited lead basic information review",
  "FoodB_Contract_ZLgE_qHzf": "Competitor price comparison in the agreement",
  "FoodC_202408_RTrU_hOhN": "Please enable location permissions. To do this, go to System Settings, select the app, then enable location permissions for the app",
  "FoodB_audit_Click_OK_Zfsf": "Tapping Confirm will trigger the",
  "Gattaran_V2_xKud_MVWh": "BD cannot register for stores",
  "FoodB_time_All_day_TIsU": "Closed All Day",
  "FoodC_page__iyoe": "Show Less",
  "FoodB_accompanyvisit_DoUc_ZSSY": "Was the BD able to clarify the next steps with decision-makers and accurately record tasks and plans for follow-up?",
  "FoodB_1106_PVUq_gUVg": "Voice Input",
  "soda-c-i18n---将赔付给您1张%s折扣券": "You get a %s off coupon",
  "FoodB_0622_Sales_KRCg": "Sales Volume",
  "FoodB_page_gnPj_beOZ": "Please clearly say the following:",
  "FoodB_0617_lXTk_DfVL": "Expiration date of the exclusive contract with the competitor - R",
  "Internal_Tools_CRM_MKcO_yldx": "Lead Source",
  "FoodB_20250612_nsLy_sirO": "Must enter 8–9 digits",
  "Gattaran_opt_JcLo_plhe": "Online Hours",
  "FoodOpB_1_Fill_in_QvuH": "Create Visitation Plan",
  "Internal_Tools_CRM_fHSX_VjzW": "Incorrect exact location. Please reselect",
  "FoodB_subsidy_xslH_mDaQ": "This Supplementary Agreement for Commission Reward will be signed under this store’s signatory. Currently, there are multiple stores already signed under this signatory, and they will also receive additional commission rewards. Do you want to continue signing?",
  "Gattaran_0_Increase_in_yvaq": "Increase Operating hours",
  "Gattaran_202406_wmja_Unkw": "Task Executor",
  "FoodB_score_Klld_iIZA": "New",
  "FoodB_page_zXlL_VKXp": "Create New Recording",
  "Internal_Tools_App_sOCx_HZNJ": "Today’s Business Hours",
  "FoodC_202412_PwIG_QPFY": "Enter an Address",
  "Gattaran_84_Khbi_virb": "Platform Detection Time",
  "Gattaran_opt_jfHC_vGTC": "Month to date Order",
  "FoodB_Tax_nKEQ_EIAC": "Company ISR Amount",
  "FoodB_20260130_TlfO_izWQ": "Asks open questions to understand the restaurant’s current situation, listens actively, and identifies their needs",
  "Internal_Tools_CRM_eqgV_MrAE": "Please enter valid longitude and latitude",
  "FoodC_202408_PJcq_SjqG": "Oops! No contact information is available for this store",
  "FoodB_20260130_XEUl_vhGH": "Time management",
  "Internal_Tools_App2_oKVZ_QNJf": "Visit plan created successfully",
  "FoodB_0322_gUpY_CIHG": "No stores found matching your filter criteria",
  "FoodB_list_Apply_for_RxQn": "Request Signature",
  "FoodB_field_Is_you_uNye": "Subject to national VAT payment?",
  "soda-c-i18n---延迟送达%s分钟以上": "%s+ minute delay",
  "Gattaran_invalid_Itxj_ruEf": "Invalid leads have been removed. To find them, please apply a filter or use the search feature.",
  "Internal_Tools_App_ROpA_rFNd": "Financial Contact Email",
  "Gattaran_0_Using_Store_khfo": "Device for B APP",
  "FoodB_calculator_hPAw_BZlP": "Guanajuato Cedular Tax Amount",
  "Gattaran_202406_rpdn_vXVr": "Remarks",
  "FoodB_clockin_guJt_eDVT": "Expired",
  "FoodB_accompanyvisit_YOaS_TWOq": "Did the BD clearly understand the goals of the accompanying visit (weekly goals and priorities) before starting work each day, and was the visit strategically planned (e.g., area, restaurant profile)?",
  "FoodB_process_tlsV_pFnp": "Confirm Match",
  "FoodC_homepage_Search_for_CiMZ": "Find Food",
  "FoodB_model20250116_wlQy_yyEp": "Visit Time",
  "Internal_Tools_CRM_hQxQ_PeNI": "Gas Station Type",
  "Gattaran_0_Full_gift_nhuV": "Spend X get Y",
  "FoodB_b_Source_of_qGPd": "Event Source",
  "FoodB_0_Please_upload_roTo": "Please upload a screenshot of the email history",
  "Gattaran_status_Gnih_zZzX": "RTBO",
  "FoodB_opencheck_BcIJ_lgZH": "Test Order",
  "FoodB_governance_Kygz_iFAW": "Rectification for Dine-in Price Comparison Completed or Not",
  "FoodB_email_NJBQ_LwUX": "There’s no email address for this contact, and emails cannot be sent to them. Please add an email address and select them again",
  "Gattaran_0_App_Operator_HJuu": "App Operator’s Number",
  "FoodB_202202_Minutes_tWiN": "min",
  "Gattaran_V2_XvaI_scMD": "Last Updated: {{update_time}}",
  "FoodB_revamp_VnXr_HYcX": "Filter “Real-time (Today)” & “Yesterday” & “Last 7 Days”: Displays the latest store health score data obtained in real time for the selected period",
  "FoodB_calculator_WFgZ_JmvX": "Payment Calculator",
  "FoodC_education_Principles_of_RKEk": "Rules for Handling Delivery Disputes",
  "Gattaran_mgt_Search_History_DIkw": "Search History",
  "Gattaran_center__IJmL": "Messages",
  "Gattaran_schedule_eLPM_Vdmp": "Continue",
  "Gattaran_visit_Zykg_WdpB": "BD was prepared for the visit",
  "FoodB_20260130_Fokt_VXiq": "Result orientation and proactivity",
  "FoodB_up20241218_WbCj_pCMp": "Pre-registration for New Store Sale Items Event Promotion",
  "Internal_Tools_App_xIAG_xcRt": "Maximum search is 30 days",
  "Gattaran_form_HAwV_aOvm": "Visit Result",
  "FoodB_opencheck_BEkt_nVNw": "Please confirm whether the store’s turnaround time is reasonable, as it affects delivery time",
  "FoodB_0617_tikP_Dusl": "Store Survey",
  "FoodB_process_PFDy_CuVh": "Under Review",
  "FoodB_20250612_ehqr_pgKz": "Store Manager",
  "FoodOpB_Translation_General_accounts_NeVu": "Savings account",
  "FoodB_accompanyvisit_lehr_PbIH": "Did the accompanying visit plan consider strategic criteria such as seller profiles, regional characteristics, and opportunities for advancement?",
  "FoodB_in_pQps_Boqn": "Retake",
  "FoodC_MVP_ASpO_MFfF": "Order Details",
  "Internal_Tools_App_wStM_yTkP": "Gas station location: {{Address}}",
  "FoodB_Translation_mIfp_fymE": "Resolve",
  "Gattaran_side__EgXn": "Monday",
  "FoodC_details_Refund_Details_sGIk": "Refund details",
  "Internal_Tools_App2_evQx_VnhU": "Gas Station Name / CNPJ",
  "FoodB_250430_GwJd_SQQB": "Store level",
  "FoodB_Translation_IfKE_iqmc": "Rectification Failed",
  "FoodOpB_CRM_Taxpayer_Address_ptqR": "Local Tax Payer Address",
  "Gattaran_Visit_Management_and_JkoC": "Management and Next Steps",
  "Gattaran_Visit_Select_a_YAtw": "Please select a date for the accompanying visit",
  "Gattaran_center__vsus": "Click for details",
  "FoodB_APP_wyiJ_mGlw": "Start Month",
  "FoodB_20250414_faym_bhsa": "Platform Rewards",
  "Gattaran_management_cYvq_XraB": "No visit info",
  "Gattaran_transformation__njrW": "Signatory Name",
  "Gattaran_Visit_New_escort_zHov": "Create an Accompanying Visit",
  "FoodB_calculator_tLev_cAgO": "Electronic Payment",
  "Gattaran_uikey_qCBF_mlck": "Commercial Offering",
  "FoodB_new1_Name_similarity_gepH": "Name Similarity",
  "Gattaran_V1_JVoT_DmFC": "View",
  "Gattaran_opt_qiBN_MCGQ": "Withdraw",
  "FoodB_page_tFIa_cbzN": "Please record or upload an audio clip. After submission, a visit summary will be automatically generated. Limitations: The recording can be up to 120 seconds, and the uploaded audio file must not exceed 50 MB.",
  "Gattaran_202311_xiHr_yFIi": "Recommended",
  "FoodB_20260130_WkaF_rdke": "If any module has a \"No Score\", that module will not be included in the overall score",
  "Gattaran_optimization_Tore_pnsp": "Your location appears to have changed. Want to refresh this page?",
  "Gattaran_form_hGfR_KtSN": "Add Visit Result",
  "Gattaran_management_gqoK_XBEn": "Today",
  "FoodB_20260130_eosk_tYnU": "Effective Visits {{effective_visit_percentage}}, Ineffective Visits {{ineffective_visit_percentage}}",
  "Gattaran_page_tcVj_BzPA": "Please assist the store in signing in to the Manager app to complete contract signing and RTBO",
  "FoodC_202408_sbmp_YFyl": "Current Location",
  "Gattaran_202406_TbgT_vOga": "Are you sure you want to submit? Once submitted, no modifications can be made.",
  "FoodB_accompanyvisit_TVci_lcvJ": "Did the BD properly handle follow-up tasks, including document collection, signing, downloads, test orders, and the restaurant onboarding process?",
  "FoodB_management_XyCn_tCtF": "Issued",
  "FoodB_Side_ZUeL_zYXD": "Cancelled Orders",
  "FoodB_Optimization_xyJu_XgOc": "Please enter 10 digits",
  "Gattaran_20240902_KYYY_BwXS": "Please describe the reason for rejecting the task",
  "FoodB_opencheck_XJFL_avly": "Confirm",
  "Gattaran_V1_IUgS_cyMV": "store(s) can register",
  "FoodD_problem_I_see_NhGG": "OK",
  "FoodB_optimization_Contract_No_GvBj": "Contract ID",
  "FoodB_list_Online_Inspection_rExT": "Shop Inspection",
  "FoodB_20250122_WEun_Whes": "Prerequisite for Task Assignment",
  "Gattaran_202406_lKot_vsVa": "Download file from the GTR system > Sales Task Management module",
  "FoodB_v12_iuCB_kwbr": "Is there a logistics integrator?",
  "Gattaran_function__DqfF": "Version Update",
  "FoodB_switch_yJQj_DSir": "Participating in 100% Sponsored Promos",
  "Groceries_brand_bqwY_mhhq": "Created successfully",
  "FoodC_sales_Supplementary_information_ihyk": "Additional Details",
  "FoodB_revamp_bLmK_xXBk": "Order Conversion",
  "FoodB_accompanyvisit_wPYQ_hebq": "Business Process and Results Orientation",
  "FoodB_2_Planned_bPON": "Planning",
  "Internal_Tools_App_dIhB_OKLN": "Set as Primary Contact?",
  "FoodB_accompanyvisit_QWRh_eKLI": "Does the BD have the practice of automatically recording visits and collecting RTBO data for immediate entry into the system?",
  "FoodB_1106_jWEH_dYMs": "Analyze Again",
  "FoodB_opencheck_ybHy_nAdV": "Store Phone Number",
  "FoodB_Wordings_iyFv_fDmW": "Additional Remarks",
  "FoodC_education_In_the_nIgD": "You will be responsible for a cancellation in the following situations:",
  "Gattaran_schedule_yPeR_CtMc": "There are more than {{number}} in-person visit plans for the selected day. The first {{number}} visit plans will be selected automatically to generate a route for you",
  "FoodC_202412_SJdc_Bwta": "Not a nearby location? Tap the button on the right to refresh your location.",
  "FoodC_dish_New_guest_bkGC": "New Users Only",
  "FoodC_202408_WiRK_SITI": "Add Address",
  "FoodB_in_kJaI_fOxY": "You have check-in(s) not checked out. Please check out first to link check-in time.",
  "FoodB_GTR_rBBn_RmKL": "Standard",
  "FoodOpB_Home_Mandate_vafk": "Tasks",
  "FoodC_education__2_KHhl": "(2) If you do not arrive at the delivery location by the specified time, or if you enter the wrong delivery address or phone number, refuse to answer a call from the courier, or refuse delivery in whole or in part without a valid reason, you will be required to pay for the order.",
  "FoodB_management_Queries_dawh": "Search",
  "Gattaran_V2_Vqiq_pMHI": "Task Description",
  "Gattaran_V2_Sjdp_HgTP": "Promotion ID",
  "FoodB_calculator_giVW_AULQ": "Platform Unit Price",
  "FoodC_education_If_you_RTIV": "If you paid for an order and need to cancel it, the following rules will apply:",
  "FoodB_1106_xaYu_lPMa": "Quick Follow-Up",
  "FoodB_calculator_EeIc_TwiG": "Company",
  "FoodB_optimization_Stimulate_contact_xSSH": "Preferred Contact Method",
  "Gattaran_20240918supplement_ISmP_qTmN": "Edit Task",
  "FoodB_B86_Kypx_nBHu": "Notes",
  "FSaaSB_Tool_qKkB_Pdhu": "Sign Up for an Account",
  "FoodB_0919__mVqa": "Turnaround Delays",
  "FoodB_opencheck_aDuZ_bepq": "Store Mobile App Download",
  "FoodC_receive__UdqW": "day(s)",
  "FoodB_420241024_FldG_feZL": "Target Value",
  "Internal_Tools_CRM_pWry_BgtM": "Please select",
  "Gattaran_202406_NcUB_dVhS": "Task Creation Time",
  "FoodOpB_center_Action_MexV": "Actions",
  "Internal_Tools_App_fTOH_ETfJ": "Please enter",
  "FoodB_Contract_tFOZ_SiQZ": "Successfully signed up for the promotion?",
  "FoodB_Analysis_Decline_gSax": "Down",
  "Gattaran_opt2_egxV_xfoW": "Imperfect Order Rate",
  "Gattaran_mgt_Display_content_IlcO": "Show Content",
  "Gattaran_0__BHKX": "Map",
  "Gattaran_tools_IbIT_QTXz": "Please enter a valid phone number",
  "Gattaran_management_IDJi_lZyx": "{{amount}} visit(s) planned today. View your schedule",
  "Internal_Tools_CRM_bNjK_DISV": "Preferred Visit Method",
  "FoodB_Show_Company_Registration_VcVV": "Cédula Jurídica",
  "FoodB_Contract_BRLH_nPAs": "Has First Online been completed?",
  "FoodB_0617_Cgpc_KwbS": "Please enter a value with 2 decimal places",
  "FoodB_scenario_FmAJ_xFEY": "Suspected fraud or prank",
  "FoodB_Contract_ywoA_Ojgz": "No",
  "FoodB_model2025011603_ztWt_rarX": "Please select visit method and type of visit first",
  "FoodB_management_dlEy_pgrv": "Issuer",
  "FoodC_202408_cktm_HTVV": "Got It",
  "FoodOpB_OpsTasks_Off_GCPV": "Close",
  "Gattaran_mgt_Gap_BnAE": "Gap",
  "Gattaran_20230803_WsGI_IIwM": "Target",
  "FoodB_SimbaSignup0331_qKdR_ELgg": "Lead Source",
  "Gattaran_20240401_LxEe_Ydha": "Survey",
  "Gattaran_0__tYzF": "There are no stores in the current area. Drag the map to load more",
  "Gattaran_84_xcpB_yRxH": "Signatory ID",
  "FoodB_scenario_tTcW_glIK": "Item sold out",
  "FoodB_20250414_BqXP_FPkP": "Repurchase Rate",
  "Gattaran_Visit_Objection_management_WIuV": "Objection Management",
  "Gattaran_cancelation_TYFD_JQzM": "{{N}} Task(s) Not Executed",
  "优惠券": "Voucher",
  "FoodB_250430_YTkG_lNTj": "Brand level",
  "FoodC_optimization_hksX_yevn": "Please add your meeting address so we can deliver your order to you",
  "FoodOpC_jiatalan_Deleted_successfully_GeGq": "Deleted successfully",
  "FoodB_1106_XZeN_ahHQ": "Once you have finished entering the content, an AI summary will be generated automatically.",
  "FoodB_calculator_cctL_sltb": "Order Total",
  "soda-c-i18n---订单实际送达时间晚于预计送达时间%s分钟以上、%s分钟以下，": " If your order is delivered %s–%s minutes after the estimated delivery time, ",
  "FoodB_collection_5_6_hFrc": "Must contain 5 or 6 digits without space",
  "Gattaran_opt_lDge_zZTn": "Click here to use map navigation; Click the phone icon for KP and store contact information",
  "Gattaran_management_icdH_hGfu": "Details",
  "Gattaran_0_Training_DM_ozrH": "Train DM or App Operator",
  "FoodB_email_WcaT_rLqN": "Visit result is incomplete. Please enter the visit result before proceeding with optimization",
  "FoodB_accompanyvisit_ugDE_XHAA": "Please describe how the BD positioned themselves during the engagement: Did they demonstrate confidence and empathy, and build a genuine connection with the client?",
  "Others_platform_Tax_documents_jEir": "Tax Documents",
  "Internal_Tools_App_sfLV_YhZV": "Exit",
  "FoodB_communications_udno_SENU": "Promotion(s) awaiting acceptance. Participating in promotions can help boost sales",
  "Gattaran_0_Maximum_number_pgYM": "Up to one person can be created for each role",
  "FoodB_opencheck_IVoR_xnHT": "Open Checklist Items",
  "FoodB_CL_Letter_of_EmKs": "Photo of Power of Attorney",
  "FoodB_0113_ELbg_zfBg": "You can view info about the store rep here",
  "FoodB_Analysis_Old_people_fwCy": "Returning Customers",
  "Gattaran_0__iUtr": "Email",
  "FoodOpB_Translation_Natural_persons_fVFa": "Natural person",
  "FoodB_0905__wwdP": "Sub-item Weight",
  "FoodC_edit_ldOR_SyHv": "Example: I’m wearing a patterned shirt and waiting on the street. You can also upload pictures of your surroundings to help the courier deliver your order to the correct place.",
  "FoodC_improve__ByLg": "Different than expected",
  "FoodOpB_Tool_Set_FrCO": "Not Configured",
  "FoodB_revamp_ifYi_sNyq": "Actual Store Revenue",
  "Gattaran_v1_fltf_eBMP": "Registered. Please view details on the Merchant App.",
  "Gattaran_0_Purpose_of_COzp": "Visit objective",
  "soda-c-i18n---超时赔付规则说明": "Coupon for Late Delivery",
  "FoodB_20260130_bbbs_MbgJ": "Visit Logging",
  "FoodB_page_SFRj_eGOy": "Visit Result",
  "FoodC_education__1_IIfh": "(1) You cancel before the store has accepted the order by using the ‘Cancel Order’ feature on the Order Details page.",
  "FoodB_0905__vMsv": "{{number}} more orders than last period",
  "FoodB_accompanyvisit_yIeT_NmXn": "Did they demonstrate confident and decisive negotiation skills, while clearly emphasizing the benefits and visibility that the promotional plans would bring to the restaurant?",
  "FoodB_Contract_cBzR_gTDZ": "Does the agreement include competitor price comparison?",
  "FoodD_messagemanagement_Mail_UMqH": "Email",
  "Gattaran_selection_TfHc_eCVN": "Uncompleted RTBO Checklist Items",
  "FoodOpB_Tool_Completed_MjfD": "Completed",
  "FoodB_20260130_wrHU_Ggnu": "Consultation and diagnostic skills",
  "FoodB_comparison_utxs_QFHY": "Confirm Match",
  "FoodOpB_1_Visit_tomorrow_ptjT": "Tomorrow",
  "FoodOpB_system_DiDi_ALAy": "DiDi Partnership",
  "FoodB_revamp_JpMI_mEoP": "Filter “Yesterday” & “Last 7 Days” & “Calendar Month”: Displays the store's actual revenue for the selected period",
  "Gattaran_202406_hoAo_HpXw": "Received ({{N}})",
  "Gattaran_0_KP_tendency_YwDf": "Store Rep’s Preferred Contact Method",
  "Gattaran_form_kNYI_bDuc": "This field must be confirmed",
  "FoodB_collection_Taxpayer_ID_zntM": "Taxpayer’s ID (CURP)",
  "FoodB_V2_No_store_ahBo": "Missing RFC",
  "FoodB_0617_pPbU_koUF": "Is there an exclusive contract with the competitor - U",
  "FoodC_202412_QwDD_sIOi": "Outside Delivery Area",
  "FoodB_subsidy_czaK_LuDh": "The BD App does not support contract signing for this store type. Please go to GTR to sign the contract.",
  "FoodB_tagging_You_have_ssrJ": "You chose to invalidate this lead for the following reason: “Not a retail store.” To do this, you must upload a photo or the Store Rep’s contact number.",
  "FoodB_20260130_BKrl_bwum": "Follow-up Date",
  "Gattaran_schedule_qPDb_CTYm": "Generate Route",
  "Gattaran_202311_JOTQ_efhW": "No recommended visits",
  "Gattaran_0_App_Operator_PFUQ": "App Operator’s Name",
  "FoodB_20250414_pQls_dkIZ": "Returning Customers",
  "FoodC_202410_UazG_LTwS": "No stores available",
  "FoodB_process_mpIE_dSWO": "Rectification Failed",
  "FoodB_governance_coYD_UvmL": "Cross-Platform Online Rectification Completed or Not",
  "FoodC_202410_hAya_NcZF": "Confirm ({{countdown}}s)",
  "FoodB_Show_Special_Tax_Eidl": "Special Tax ID",
  "FoodB_Contract_rrZL_POpC": "{{brand_name}} price is {{unit}} {{number}}% of dine-in price",
  "FoodB_accompanyvisit_zjgE_DCvu": "Professionalism, Adaptability, and Commitment",
  "Internal_Tools_App_SHoN_atyR": "Stations",
  "Internal_Tools_App2_gcDq_GLYj": "Cost Price Details",
  "Gattaran_0_Self_marketing_BQlO": "Autopromo",
  "FoodC_education__2_KZTZ": "(2) The courier is unable to contact you",
  "Gattaran_Optimization_VLZp_WhPs": "View Store Address",
  "FoodB_leads_KP_Phone_hCUe": "Store Rep Phone 2",
  "FoodOpB_APP_Visit_vdze": "Visit",
  "FoodB_Contract_PpIv_FHlg": "Does the agreement include commission reward?",
  "FoodB_Wordings_DKwT_wbfI": "Please specify why you selected this option. Your feedback is valuable and helps us improve!",
  "FoodB_new1_Similarity_ItET": "Similarity",
  "FoodB_V2_iZpC_KKcK": "Share Diagnosis Report with the Store",
  "FoodD_h5_Single_quantity_lrNq": "Orders Completed",
  "FoodOpB_1_New_Visiting_tIni": "Create Visitation Plan",
  "Internal_Tools_App_HdHN_rUqy": "Gas Station Services",
  "Gattaran_statusbar2_HKvC_dhsJ": "Signed",
  "Internal_Tools_App_yiaL_Hsph": "We recommend uploading photos of the gas station",
  "FoodC_20240607_qihL_obWb": "Store Not Found",
  "Gattaran_form_Iqrg_LVTe": "Please enter a number",
  "FoodC_202409_rOOL_Peyp": "Enter Mobile Number",
  "FoodB_v108_kOdQ_AxDe": "Store ID",
  "Internal_Tools_App_zYXv_Uwsb": "Operating Status",
  "FoodB_in_PTBa_SlOx": "Fill Visit Form",
  "FoodB_1106_rrpW_kMlP": "AI Summary",
  "FoodD_Name_July_RJXL": "Jul",
  "FoodB_email_Bwgs_muyN": "Employee",
  "FoodOpB_bill_Status_doqj": "Status",
  "FoodOpB_1_Closed_ieMb": "Closed",
  "Internal_Tools_CRM_uCms_fFPv": "Primary Contact Phone Number",
  "FoodC_check_HTib_sWqA": "Ordering",
  "FoodB_20250414_cwcj_LKFT": "P2",
  "Gattaran_V1__xaNO": "Cancel Rate",
  "FoodC_intostore_Store_Coupon_kHwh": "Store Coupons",
  "Gattaran_mgt_Filter_WuXS": "Filter",
  "Gattaran_REGULAR_xhms_NLbn": "Reset",
  "Internal_Tools_App2_TpmY_bfhb": "Visit",
  "FoodB_survey_wjGW_FMpe": "{{brand_name}} Financial Support",
  "Internal_Tools_App2_wcQW_nFJu": "The selected date is conflicting with an existing visit plan. Once submitted, the previous visit plan will be overwritten.",
  "Gattaran_promo_zwtN_ucNY": "This store does not support Smart Promotion configuration",
  "FoodC_homepage_Enter_delivery_IZAu": "Enter delivery address",
  "Gattaran_opt_nyES_OcBw": "Order",
  "FoodC_Card2_When_the_sFOa": "Open at",
  "FoodB_score_GUVa_rRtD": "Self-delivery store does not use use DAPP",
  "Gattaran_opt_slKF_FRuu": "time-out cancel",
  "FoodB_0905__dSOH": "Store Diagnostics",
  "Gattaran_opt_xozr_fXeD": "Month to date R Burn",
  "FoodB_collection_12_or_woYo": "Must contain 12 or 13 alphanumeric characters, all in capitals without space",
  "FoodB_Launch_DR_Military_Rxvi": "Cédula Militar",
  "FoodB_Contract_UTbX_JhBf": "Does the agreement include dine-in price comparison?",
  "GRider_dlp_Mjnq_pnxH": "Other Info",
  "Internal_Tools_App_BBZi_lqDC": "Save",
  "FoodOpB_CO_Store_official_VsRU": "Store's Official Website",
  "FoodC_202408_HkLu_Mwgv": "No Location Permissions",
  "FoodC_202408_QAer_OYaB": "Welcome!",
  "Gattaran_V2_JYDK_jtcb": "Promotion Registration Time",
  "soda-c-i18n---1、超时赔付服务是%s为您免费提供的服务，当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给您一定金额的优惠券，订单完成后可以在中查看。": "1. Compensating you for a late delivery is our way of making things right. If your order isn’t delivered by the estimated delivery time (excluding canceled orders), %s will give you one or more free coupons. You can view your coupons after your order is completed by going to ",
  "FoodC_edit_SkdG_WQKu": "Meet in hotel lobby",
  "FoodB_Contract_Jthe_YSbD": "Has the store survey information been updated?",
  "Gattaran_display_gAVa_nBnn": "Multiple Stores Per Location",
  "FoodB_20260130_RUfF_qIDg": "Stage Rating: Strategic Preparation",
  "FoodC_education_1_Customers_Gpbb": "1. Before placing an order, you will be asked to choose your preferred delivery option. The courier will then deliver your order to you using your selected option:",
  "Gattaran_Collection__oNFU": "Navigate with Google Maps",
  "Gattaran_20240401_iGPg_djYX": "Answer Now",
  "Gattaran_0__eeft": "All stores",
  "FoodB_1106_uAeK_oOBq": "Please describe the work you have done. What are the key updates, customer needs, or critical issues? What are the next steps?",
  "FoodD_Name_April_UHuR": "Apr",
  "FoodC_20240607_STdK_ZTMu": "Technical service provided by {{brand_name}}",
  "FoodB_opencheck_sdms_sZcq": "All open check items have been completed",
  "Gattaran_opt2_mgat_VXCg": "Conversion Funnel",
  "soda-c-i18n---将赔付给您1张%s优惠券": "You get a %s off coupon",
  "FoodB_page_hqXm_mrng": "Summary",
  "FoodC_20240607_Olbe_DAqS": "Unable to Load",
  "FoodB_20250414_oAyQ_liSz": "Final Discount",
  "FoodOpB_system_offline_ersI": "Offline",
  "FoodB_V1_pVrj_FQgt": "Project ID",
  "Internal_Tools_App_xBYh_JJGr": "Distance",
  "Gattaran_Grocery__pKzk": "Groceries",
  "FoodB_scenario_psNp_kSMI": "No couriers available at the store",
  "FoodC_sidebar_Scan_QR_ONzJ": "Please scan the QR code using your phone camera",
  "FoodB_20260130_Asip_cJgN": "Please enter a description of at least 15 characters.",
  "FoodB_in_qxwR_OBuC": "Store location inaccurate. Please report the correct location.",
  "FoodB_sob_ixDC_aXor": "Please enter the store’s mobile number",
  "FoodB_page_oZob_DASd": "Please ensure a stable internet connection and record again",
  "FoodOpB_systemV2_Corresponding_coefficient_nVdO": "Coefficient",
  "FoodD_Name_January_lhYr": "Jan",
  "FoodB_1106_wohA_bqJX": "AI is analyzing and summarizing. Please check back later.",
  "FoodB_1106_tdLw_uSLP": "All",
  "FoodB_score_lThf_wlQT": "Health Score",
  "Gattaran_opt_oUrr_YTIV": "Signing status bar",
  "FoodOpB_tool_Category_main_aHZl": "Main Item Categories",
  "FoodB_email_CuqE_WLmP": "Hi! We visited your brand {{brand_name}} and reviewed the following together with {{person_to_be_visited}}:",
  "Internal_Tools_App_YNFM_WUWd": "Filters",
  "FoodB_20250122_yAtY_FAOX": "Task Executors",
  "Internal_Tools_App_EMFl_vDCu": "State Registration Number",
  "FoodB_20250414_hanC_RXkJ": "P1*P2",
  "Gattaran_0_Role_QDBu": "Role",
  "Gattaran_V20__THMR": "R performance",
  "Gattaran_form_xJkV_MADh": "Notes",
  "FoodB_in_JvQz_jMAb": "Report Error",
  "FoodB_scenario_tWmb_Krny": "Not accepted by store in time",
  "Gattaran_0__ypdc": "Refresh",
  "FoodB_up20241218_Btbi_AOsy": "Submitted",
  "Gattaran_Gattaran_tXqW_GKCv": "In Progress",
  "Gattaran_REGULAR_TWeg_lFbm": "This field is required",
  "FoodB_governance_OZDM_JqJt": "Rectification for Competitor Price Comparison Completed or Not",
  "FoodB_indicator_IPAg_AyWR": "Data Calculation Period",
  "Gattaran_management_adiS_UvoW": "No visit tasks",
  "Gattaran_material_fvgd_sjhQ": "Rejected: Please update the form according to the rejection reason and resubmit for review",
  "FoodB_V1_hSCx_tzLn": "Project Name",
  "Gattaran_Page_Distance_jPzG": "Distance",
  "Gattaran_0_Menu_optimization_hWWT": "Menu development",
  "FoodC_202408_uMeD_ECQU": "Something went wrong. Please try again",
  "Gattaran_form_MLcA_tPgo": "This field is required",
  "FoodB_requirement_puhp_VPIQ": "Orders Not Prepared on Time",
  "FoodB_revamp_hvPo_TJaN": "Optimize Now",
  "FoodB_20250612_SduQ_XghF": "Must enter 1–10 digits",
  "Gattaran_202406_wGfZ_ewxp": "Task Execution Team",
  "FoodB_scenario_Essn_oVjW": "Questions about promotion or fees",
  "FoodB_APP_BKjc_PGqI": "Store Ad",
  "Internal_Tools_CRM_MiAT_UkNG": "Cancel",
  "FoodB_0905__zFVs": "Total Weight",
  "FoodC_education_Platform_Delivery_MJPQ": "Platform Delivery",
  "FoodB_management_Name_of_EjQd": "BDM account",
  "FoodB_accompanyvisit_JkOw_BlRX": "Was the BD able to analyze and discuss service KPIs (such as \"Online Hours\" and \"Cancel Rate\") with clients and propose practical solutions?",
  "Gattaran_mgt_Check_the_Zyhr": "View List of Evaluated Stores",
  "FoodC_202408_HNlI_lTpJ": "You haven’t added a tip yet",
  "FoodC_dish_Look_again_fJrp": "Not Now",
  "Gattaran_KPI_System_performance_cQiV": "Completion",
  "Gattaran_Visit_Change_2_mNNS": "SHIFT 2",
  "FoodB_accompanyvisit_dHvL_iRUP": "Before and during the accompanying visit, did the BD skillfully use the CRM system?",
  "FoodC_nonaffiliate_Courier_is_iunG": "The courier is heading to the store to place your order",
  "FoodB_20250414_dobD_hNij": "New User Rate",
  "FoodB_page_UURy_Lqdt": "A new visit summary has been generated",
  "Gattaran_Optimization_AFCF_zMMS": "Call Contact Persons",
  "FoodB_20260130_AmlG_nQAn": "Manage Operational and Foundational Aspects",
  "FoodC_202408_IBpM_TxlD": "Other",
  "必选": "Cannot disable",
  "FoodB_20250612_GGEs_TCgn": "Must enter 10 digits",
  "FoodB_20260130_jZbm_FSzF": "Capitalize on Environmental Opportunities (Business Focus)",
  "FoodB_0707_High_prices_fBsL": "Higher",
  "FoodB_process_kiMF_XkhA": "Pending Confirmation",
  "Gattaran_0_Select_Contact_UrRS": "Select Contact Person",
  "Internal_Tools_App_oLpX_dbCU": "Today",
  "FoodB_0921__isZD": "Qualified Item Rate",
  "Internal_Tools_CRM_yMUu_NPxu": "Please enter",
  "FoodB_1106_LmPI_RZuR": "Recording permission is disabled. Please enable it in Settings.",
  "FoodB_revamp_WRGU_uLfD": "Business Overview",
  "FoodC_202409_yzRW_xKLM": "This order is closed. To view details, please enter the mobile number of the requester",
  "Gattaran_feedback_Bkis_KqHN": "Feedback Submitted",
  "FoodB_20250414_faVK_FFkd": "Rate",
  "Gattaran_transformation__zjbG": "Signatory ID",
  "bill-manage---no_auth": "Missing Permission",
  "FoodB_Contract_nsIw_Gfzl": "{{brand_name}} price is {{unit}} {{number}}% of competitor price",
  "FoodB_Translation_kinT_foeX": "Please select the reason for unresolved status",
  "Internal_Tools_CRM_roQc_QSuD": "Phone Number",
  "FoodB_20260130_msue_tVrT": "Attitude and continuous learning",
  "FoodC_web_Application_Progress_UYtG": "Request Status",
  "Gattaran_202311_XTsd_OBZL": "{{distance}} from store",
  "FoodB_1106_qhrP_Bevz": "What work was done?",
  "Internal_Tools_App_OKLc_fuyL": "Last {{day}} days",
  "Gattaran_202406_PESn_Wyzj": "Reference Information",
  "FoodB_accompanyvisit_BDpV_dijH": "Did the BD clearly present the business proposal, emphasize {{99}}’s differentiating advantages compared to competitors, and effectively communicate our value proposition?",
  "Gattaran_display_SDiW_jcDc": "Other merchants registered at this location are as follows",
  "FoodB_in_hlDP_KYHy": "Unable to get location. Turn on location services in Settings and allow {{appname}} access.",
  "FoodC_edit_GeFS_ZPLW": "Building Name",
  "FoodB_feedback_KSnE_LLPJ": "We have received your feedback. Please monitor D-Chat messages and your email for the latest updates.",
  "Gattaran_form_wrkw_ybam": "Objective",
  "FoodB_audit_Similarity_check_cQEP": "Similarity Check",
  "FoodB_Translation_vZUg_djAJ": "Please Select the Resolution Outcome",
  "FoodC_202408_zoCD_Pszh": "Continue",
  "FoodC_supplement_Return_wVpv": "Back",
  "FoodOpB_CRM_Taxpayer_full_fzhk": "National Tax Payer Full Name",
  "FoodB_APP_kvLF_MMXl": "Daily Orders Completed",
  "FoodB_management_mULu_sEtq": "No Supplies to Be Issued for This Store",
  "FoodB_Website_tNXH_hTaL": "Please enter a valid mobile number",
  "FoodB_calculator_yiXt_NkiM": "Platform Commission Rate",
  "Internal_Tools_App_pdgP_UCoK": "Input Manually",
  "FoodB_management_OqJO_eKyB": "Please enter name",
  "FoodB_20231012_Usvn_HuCU": "Task created successfully. You can track progress in the My Tasks module",
  "FoodB_feedback_aPoO_fIUh": "Your feedback was not submitted successfully due to a system error. Please contact us directly using the email address provided below or via D-Chat.",
  "FoodB_20250122_cjEP_PzzB": "Task Creation Team",
  "FoodB_page_TMuL_Jndl": "Visit Purpose",
  "FoodB_5_Store_Delivery_PIyN": "Store Delivery",
  "FoodB_calculator_JGZb_tQiY": "Paid Price",
  "Internal_Tools_0523_djkV_XXks": "Registered Events List",
  "FoodB_indicators_DXHY_dobu": "Business Metrics",
  "FoodB_field_Do_you_mhOz": "Subject to local VAT payment?",
  "FoodB_B86_UdlE_SMWM": "Confirm",
  "Internal_Tools_App2_WfdX_XUIO": "Completed",
  "FoodB_calculator_pEyx_wJvY": "Yes",
  "FoodB_0820__bVDh": "High-priority Stores",
  "Gattaran_page_jeoa_zoNR": "The store has not been visited yet and cannot request contract signing. If it has been visited, please enter the visit information",
  "FoodB_in_hnnz_miyT": "Check-in Failed",
  "FoodB_20260130_BNSE_KtQJ": "Consistent Use of Management and Data Tools",
  "FoodC_education_5_Cash_zBuY": "5. If you place a cash order, ensure you have enough cash on hand to pay for the order before accepting delivery.",
  "Gattaran_0__ztLy": "Feedback",
  "FoodB_management_Role_yLYi": "Job Role",
  "FoodB_revamp_ivPr_tnHT": "Yesterday",
  "FoodB_CL_Traditional_companies_cQhK": "Company (Traditional)",
  "Internal_Tools_App_sneY_mCvo": "Financial Contact Name",
  "FoodB_accompanyvisit_PTCc_aqRn": "When facing objections from clients, did the BD demonstrate emotional control, reasoning skills, and persuasiveness?",
  "Gattaran_0__Auzn": "Drag the map to load more stores",
  "FoodB_B86_UDxy_zyJV": "This merchant has no violation records during the current period",
  "Internal_Tools_App_cbRv_idqO": "Lead Info",
  "FoodOpB_CRM_Taxpayer_Tax_xOmZ": "Local Tax ID Number",
  "FoodB_20260130_oTtg_HpPm": "Improve Understanding of Products and Business Proposals",
  "FoodC_202408_PvIX_VPCT": "Sign in to view offers and track order status",
  "FoodB_revamp_mlff_lGsn": "Filter “Yesterday” & “Last 7 Days” & “Calendar Month”: Displays the average order value for orders during the selected period",
  "Gattaran_Process20250815_RJzh_SzcB": "Request Again",
  "FoodOpB_Tool_Supplies_Vptd": "Supplies",
  "FoodB_1106_zQzq_GRVj": "This device does not support recording",
  "FoodB_20260130_yite_dEGG": "Next steps with commitment dates were established",
  "FoodB_accompanyvisit_tKym_AVNz": "Overall Feedback",
  "FoodD_Name_August_cjQS": "Aug",
  "FoodOpB_system_DiDi_XcUY": "DiDi Operations",
  "Internal_Tools_App2_fjLr_RvMk": "Limit Reached",
  "FoodB_calculator_VFoE_zsGK": "Item Cost",
  "FoodB_v12_EuTn_cOWR": "Integrator Information",
  "Gattaran_management_WjPM_jAvI": "Send agreements to store",
  "Internal_Tools_App2_QhIO_MwdW": "Search by gas station name / CNPJ",
  "FoodB_V1_daZW_gxxe": "Project Type",
  "Gattaran_84_pFOg_DKGB": "Violation Content",
  "FoodOpB_2_Activity_status_hKFd": "Campaign Status",
  "Gattaran_opt_klQH_BPVb": "Lead Info",
  "FoodB_v108_Qpgb_cAfC": "Project Name/ID",
  "FoodB_accompanyvisit_JAMs_lVxa": "Did the BD demonstrate core sales skills, such as emotional control, reasoning, persuasiveness, and precise articulation of solutions when facing objections?",
  "Gattaran_REGULAR_JVAQ_pbxi": "Basic Input",
  "Gattaran_statusbar2_HSiT_INfG": "Verified",
  "Gattaran_v2_meyK_ACyX": "Open on {{DiDi_Top}}",
  "Internal_Tools_App2_FAVe_GEuM": "Edit Plan",
  "Gattaran_20240902_XVee_UUPM": "This task was rejected by {{account}}. Reason: {{reason}}. Please sign in to the GTR Sales Task Management module to complete the reference information again, then submit it.",
  "FoodB_in_jXCJ_piNt": "Submit Photo?",
  "Gattaran_202406_lNdD_KvZI": "Store Tasks ({{N}})",
  "Gattaran_V1_HNYI_VwLG": "store(s) have not registered",
  "FoodB_collection_Tax_Classification_uJHT": "Tax Regime (National)",
  "Gattaran_202406_FRwK_cCbx": "My Task",
  "FoodB_APP_YjyK_hqYn": "Order",
  "FoodB_in_jecP_aEPa": "Not checked in",
  "FoodB_accompanyvisit_whTV_IRlg": "Throughout the accompanying visit, did they maintain a proactive work attitude and demonstrate strong organization and coordination skills, along with agility (staying focused and results-driven)?",
  "FoodB_Optimization_QsfU_elzm": "Please Select a Store Type",
  "Gattaran_20250610_cwrB_uBlH": "Please add the onboarding information and complete RTBO",
  "Internal_Tools_App_FCxp_ADxG": "Business Hours",
  "FoodB_calculator_AioF_coBc": "Individual VAT Amount",
  "Internal_Tools_App2_kfaK_CNAM": "Showing all cost prices recorded in the past year",
  "Gattaran_0_Marketing_activities_qANU": "Promotions",
  "FoodB_up20241218_hGVF_hBSj": "This store has no items that meet the requirements. We suggest contacting the store to upload items soon.",
  "Gattaran_Project1_HXjY_OZWN": "Commission Reward Conflict Alert",
  "FoodB_20260130_dqca_vtcE": "Follow-up and accountability",
  "FoodC_dish_Leaving_LwWJ": "Leave",
  "FoodB_CL_RUT_roUA": "RUT",
  "FoodC_202408_IfNx_VyNu": "Saved Addresses",
  "FoodB_optimization_Full_reduction_NlOa": "Spend X Save Y",
  "FoodC_dish_You_will_AXAT": "You can only enjoy the New User Deals on this page.",
  "Gattaran_add_WtmN_hzJP": "Connectivity > 60%",
  "FoodB_score_hdba_rkAT": "Data Time",
  "FoodB_v12_yorO_qIQQ": "Is there an order integrator?",
  "FoodC_edit_NwrE_OHgM": "Meet outside apartment building",
  "FoodB_data_End_mVwX": "End Time",
  "FoodB_20260130_VWIQ_JMLw": "Negotiation skills",
  "FoodB_0327_ZGTe_zcKH": "Tap here to switch city",
  "Gattaran_0__NAOt": "Please describe your problem or suggestion and send it to the mailbox below or contact us via D-Chat.",
  "Gattaran_visit_KjUG_kxHP": "BD listed promotional events or studied needs of the store",
  "FoodC_education_1_If_iWDm": "1. If you’re unable to meet the above requirements for accepting delivery, you may be held responsible in the event of a delivery dispute. This includes, but is not limited to, situations where:",
  "FoodB_opencheck_Lqbg_GbON": "Go to {{99app}}",
  "Gattaran_0509_PLgH_VDtS": "Top 10 Dishes",
  "Gattaran_optimization_deWd_ffjJ": "Final Performance Completion",
  "Gattaran_0_Decision_makers_uOOG": "DM(Store Rep)",
  "FoodB_V2_No_legal_QONX": "Missing legal rep's ID",
  "FoodB_20260130_fEgm_UwHu": "Coaching and Follow-up",
  "FoodB_Commision_Type_of_EIWZ": "Store Type",
  "Gattaran_mgt_Unqualified_Store_JeWr": "Stores with unmet goals",
  "FoodB_Overview_AasD_LvfW": "View More",
  "FoodB_NewStore_Status_HphC": "Status",
  "Gattaran_20240401_kuua_DPLO": "Ask Me Later",
  "FoodB_list_Store_Phone_tSWo": "Store Phone Number",
  "Gattaran_visit_KNGQ_NwUQ": "BD listed previous agreements or solutions",
  "Gattaran_opt2_kPIo_ZpuU": "Self Delivery Orders / Week",
  "FoodB_communications_mtxm_YcRA": "Store(s) have not completed New Store Boost tasks",
  "FoodB_V1_zSAb_YlGe": "{{num_days_left}} day(s) left",
  "Gattaran_84_BAfy_jvHS": "Violation ID",
  "FoodB_revamp_Ojty_dQGn": "Store Order Volume",
  "FoodB_20260130_JgHk_zEgk": "Increase Effectiveness in Merchant Engagement",
  "Gattaran_management_Associated_New_iDiy": "Associate New Store",
  "Gattaran_202406_HnXs_yYCh": "Task Status",
  "Gattaran_form_wuYy_lqzb": "Platform information",
  "FoodB_module_gRmW_pNjB": "Data Time: {{date}}",
  "Gattaran_management_HgTV_cHfW": "Add Plan",
  "Gattaran_B86_AJdW_BXRv": "Online Hours Rate in {{number}}",
  "Gattaran_jumppromo_ONbQ_nOEB": "Promo Data Portal",
  "FoodB_420241024_LTYv_GOfN": "Actual Value",
  "FoodB_optimization_Label_nzNw": "Tag",
  "FoodB_process_EHJE_CoxL": "Choose Sub-Item",
  "FoodB_P0_cNyW_HkyE": "Change in Orders Completed",
  "FoodC_edit_OVRs_CzUt": "Hotel",
  "FoodB_20230410_YNjt_xAWA": "DiDi Top",
  "FoodB_management_sSVO_Bizb": "Are you sure you want to delete the contact?",
  "Gattaran_optimization_MwZK_gJdn": "KPI Bonus",
  "FoodB_Side_YfKV_vTcN": "Peak-Time Online Rate",
  "Internal_Tools_App_tpZf_wbHM": "Primary contact",
  "FoodOpB_Tool_Visit_szxD": "Open Link",
  "FoodC_202408_leda_oOpl": "Track orders better",
  "FoodB_indicator_HwNu_RoHh": "B Duty Cancel Rate",
  "Internal_Tools_App2_XBvf_vJDB": "Check",
  "FoodB_V1_LADl_QUme": "Fill Form",
  "FoodB_list_Setting_Up_YlBy": "set_open_duration",
  "Gattaran_84_IIJR_tPfw": "Identification Method",
  "FoodB_1106_Boir_tlSu": "Your audio file failed to upload. Please ensure your network is stable and that the file is under 5MB and less than {{max_record_time}} seconds long.",
  "Gattaran_statusbar2_Pfzu_ihne": "Verifying",
  "Gattaran_opt_SsHX_vUuN": "sold-out cancel",
  "Gattaran_schedule_saMI_wHLe": "Tap here to generate an in-person visit route!",
  "sailing.d-api.common.页面获取失败，请稍后重试": "Unable to retrieve page. Try again later",
  "Gattaran_V2_TtYW_lonJ": "Current data time: {{update_time}}. Data will be updated with a delay of 1-2 hours.",
  "Internal_Tools_App2_bcHq_KppB": "To Be Visited",
  "Gattaran_0_Merchant_activities_wwGb": "Flagship",
  "FoodB_20260130_ifDg_nokH": "There was proper planning and preparation for the daily route",
  "Gattaran_Translation_Alien_ID_IMja": "Foreign ID",
  "soda-c-i18n---当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给您一定金额的优惠券，订单完成后可以在": "If an order isn’t delivered by the estimated delivery time (excluding canceled orders), %s will give you one or more coupons to help make things right. After your order is completed, you can view your coupons by going to ",
  "FoodB_20260130_oIxI_wIMq": "Mastery of the Commercial Pitch",
  "Internal_Tools_App_Prgi_JgdZ": "Confirm",
  "FoodB_APP_PJrW_uBye": "AOP/ASP",
  "FoodB_V1_CLCC_nUuk": "Create Visit",
  "FoodB_20260130_HkWX_ZAoO": "Active Listening and Adaptive Communication",
  "FoodB_I_Home_OrRo": "Home",
  "FoodB_collection_Taxpayer_Information_fQid": "Query Taxpayer Information",
  "FoodC_202408_GeGr_xwdt": "Communicate more easily",
  "Gattaran_202406_cPQJ_uCFE": "Task Type",
  "FoodB_comparison_FSKj_kcIf": "Comparison results are under review",
  "FoodOpB_information_The_selected_LyoI": "Settlement is not supported for the selected bank",
  "FoodD_Name_September_Ezci": "Sep",
  "FoodC_202408_xwYJ_IzdZ": "Continue",
  "Gattaran_V2_Vjbt_glNA": "Register for Promotion",
  "FoodC_web_Customer_Service_EBqf": "Customer Service",
  "FoodB_opencheck_GlFW_TclW": "View",
  "FoodB_0_Mail_SUKZ": "Email",
  "Internal_Tools_App_LlZj_XSVI": "Create Visit",
  "Gattaran_202406_ndOn_KPLE": "Task Details",
  "Gattaran_opt2_Nngy_DhyN": "Review status has expired and cannot be queried here. Please contact the relevant product supervisor for more info.",
  "FoodB_accompanyvisit_dhas_ATCp": "Did they use exploratory questions and active listening to understand the restaurant’s current situation and challenges?",
  "FoodB_calculator_VujK_GJbV": "Profit",
  "Gattaran_Visit_Accompanied_visitors_ZFNA": "Person(s) Accompanied",
  "Internal_Tools_App2_BEqX_EVvQ": "Fri",
  "FoodB_calculator_mTaD_pjZv": "Total Discount",
  "Gattaran_0_Improved_Cancellation_KpWF": "Improve cancellation rate",
  "Gattaran_V2_nmOG_KwMG": "Item Quantity Requirements for Promotion Registration",
  "FoodB_20260130_JGEK_zxII": "Adapts the speech recognizing {{brand_name}}’s value proposition and the key benefits of the current commercial offer",
  "Gattaran_Visit_Before_visiting_VHLe": "Beginning of the day",
  "Gattaran_mgt_Display_all_Yagb": "By default, all stores that did not achieve goals and their KPIs are displayed",
  "Gattaran_store_nPds_FcDF": "This page is not the official portal for contract signing. For your benefit and the security of your information, please complete contract signing through the official portal.",
  "FoodC_1_mnqk_AcOb": "Unable to copy",
  "FoodB_in_ZfQl_HqDL": "Checked in",
  "FoodB_CL_Amount_CLP_Tmnv": "Amount (CLP)",
  "Gattaran_84_fTVF_JwVK": "General Violation",
  "FoodC_202408_ZOBi_xjfW": "Search for a place like Building/Apt.",
  "FoodOpB_CO_Not_applicable_WuPn": "Not applicable",
  "FoodC_supplement_Modify_Mobile_ZJkT": "To modify your phone number or password, add an email address, or delete your account, please",
  "FoodC_address_gNYi_HdzX": "Unable to Save",
  "FoodD_supplement_Rules_RYAa": "Rules",
  "FoodB_email_qCka_NBMf": "Best Contact Time",
  "Internal_Tools_App_qybY_jcAh": "ERP System",
  "FoodB_tagging_You_chose_DSiT": "You chose to invalidate this lead for the following reason: “Ceased operation.” To do this, you must upload a photo or the Store Rep’s contact number.",
  "Gattaran_opt_cUSL_RSNr": "Map navigation & contact information",
  "Gattaran_form_YzJW_ggnb": "Store Operations Information",
  "FoodB_0919__YKYU": "No Promo",
  "FoodB_calculator_mdtN_KpDW": "Total Discount",
  "FoodB_20260130_YoXd_Ofsz": "Documents visit status correctly and manages outcomes in Explorer, ensuring that all agreed actions are sent to the restaurant",
  "Gattaran_202406_jIoA_BlIm": "Display",
  "FoodB_page_soIL_UjnD": "Try Again",
  "FoodB_survey_zzNV_gkFf": "Notes",
  "FoodD_up_DiDi_Delivery_FdmM": "DiDi Delivery",
  "FoodC_202408_pSzr_CJqz": "Save Address",
  "Gattaran_management_hCqr_uwez": "Edit Email",
  "FoodC_202412_JiED_bPrx": "No results. Enter a valid building, street & house number",
  "Gattaran_0_Operating_channels_upHR": "Daily orders",
  "FoodB_20250414_EVlU_bloy": "New Customers",
  "Gattaran_AlertV1_FkFa_EQiG": "No eligible stores",
  "FoodB_V1_BEKq_hBNG": "Selected filters: {{tag_name}}",
  "FoodB_accompanyvisit_mOOJ_zFjt": "Did they actively accept feedback during the accompanying visit and show a clear willingness to improve?",
  "FoodC_1_ScPa_MVPN": "Copied",
  "FoodB_management_ZwFz_QsoN": "Add Contact",
  "Gattaran_management_BjBQ_GVEr": "{{num1}}/{{num2}} In-person Visits Completed · {{month}}",
  "Gattaran_REGULAR_ezuA_ZuBN": "Tax ID",
  "FoodB_in_qJcB_oRfE": "You just checked in. Confirm check-out? It won’t affect your performance.",
  "FoodC_all_You_haven_lSmt": "You haven’t invited any friends yet. Try inviting someone",
  "FoodB_calculator_rMFF_EMXI": "Cash",
  "Internal_Tools_App2_MoBn_DHqJ": "Delete",
  "Gattaran_AlertV1_MmvI_acwe": "{{date}} day(s) remaining",
  "Gattaran_Process20250815_enQA_qfXI": "View Details",
  "FoodB_Translation_IcyT_qdIf": "To Be Rectified",
  "FoodB_scenario_PuLv_FhUL": "B-duty cancellation initiated by other parties",
  "Gattaran_mgt_Without_search_XVsz": "No results found. You may adjust filtering conditions and try again",
  "FoodB_20250414_WmJY_oZbB": "Funnel",
  "FoodB_calculator_HfHr_bkLf": "Platform Rewards Share of Discount",
  "FoodC_education__3_TDsa": "(3) You refuse to accept the order in whole or in part",
  "FoodB_B86_xkRX_bJPm": "Is the violation information accurate?",
  "Internal_Tools_App_GMMl_xksG": "Bank Name",
  "FoodB_1106_tTbZ_mKRW": "AI Analysis",
  "FoodB_Launch_DR_ID_AnVk": "Cédula Dominicana",
  "Gattaran_management_oCmv_JtTy": "Agreements from DiDi",
  "FoodB_CL_Vista_Account_QcOm": "Vsita account",
  "Gattaran_BDapp_Rvoe_RUHw": "BD Portal (Normal)",
  "FoodB_revamp_jrcY_dvmZ": "Filter “Real-time”: Displays the estimated number of orders completed in real time (excluding cancelled orders)",
  "FoodB_I_onwf_oaQH": "Sales",
  "FoodB_process_keoD_znIy": "No matching item found",
  "FoodB_indicator_gkdu_HwLc": "Key Business Metrics",
  "soda-c-i18n---订单实际送达时间晚于预计送达时间%s分钟以上，": "If your order is delivered over %s minutes after the estimated delivery time,",
  "soda-c-i18n---取消订单": "Cancel Order",
  "请选择支付方式": "Select Payment Method",
  "Internal_Tools_App_Qgai_eoNp": "Brand",
  "Gattaran_KPI_ioIq_fNJB": "First online date",
  "Gattaran_Feedback__dWQe": "Task Assignee",
  "FoodB_progress_ZdQT_mHfK": "Reset",
  "FoodB_calculator_Jryi_aded": "Tax Entity",
  "Internal_Tools_App_rOKe_yMwP": "ERP Status",
  "Gattaran_jumppromo_vqdm_KQKO": "Tap here to open the Promo Data Portal and view more detailed data",
  "FoodD_Optimization_ppct_mVEc": "Enter your mobile number",
  "Gattaran_url20250708_paYw_lmmU": "Menu Link Reference",
  "Internal_Tools_App_gUvZ_AiZQ": "Visit Info",
  "FoodB_0_Please_upload_dcPG": "Please upload a screenshot of the SMS history",
  "FoodC_dish_Are_you_TaUN": "Leave Promo Page?",
  "Gattaran_Dashboard_kkhw_LpMO": "vs. previous period:",
  "FoodB_20260130_XIop_NNlH": "Confirms that the DM understood the agreements and establishes next steps",
  "Internal_Tools_0510_DBOY_ADvH": "Holiday business hours not set",
  "FoodB_CL_Add_any_egRn": "Any of the following three document is acceptable:\nPoder del Representante Legal\nCertificado de Comercio de Registro de Santiago (o ciudad respectiva)\nCertificado de Estatuto Actualizado",
  "FoodB_20250612_jtyZ_DrEC": "Friend / Family Member of Store Owner",
  "FoodB_0617_rPjX_pvuu": "Does the restaurant accept orders via WhatsApp or phone?",
  "FoodB_scenario_FkIm_wbyt": "Store too busy to prepare order",
  "Internal_Tools_App2_lQcx_yrtq": "Add Plan",
  "Gattaran_form_FtqP_caNF": "Visit Objective",
  "FoodC_202412_aCvV_UNyj": "Add New Address",
  "Gattaran_Visit_Results_ftOU": "Result",
  "Gattaran_0_Improvement_of_TPKB": "Improve Bad reviews",
  "FoodC_web_Feedback_on_ookM": "Sorry, feedback cannot be submitted using the web version at this time. To submit feedback, please use the mobile app. If you have any questions, please contact Customer Service.",
  "FoodB_0830__wEQD": "Orders completed this month",
  "FoodB_in_mOVo_WHCx": "Please ensure both you and the store sign appear clearly and completely in the photo.",
  "FoodB_1106_OZBo_RTDB": "Customer Intent",
  "Gattaran_side__vcvR": "Sunday",
  "Gattaran_84_Uwcd_PIjN": "{{brand}} Price",
  "Internal_Tools_App_GiyX_Jwmf": "Add Visit Log",
  "Gattaran_opt_AGTs_VRUG": "{{change}} more than last period",
  "FoodB_APP_alxj_KuRF": "Ongoing Events",
  "Internal_Tools_CRM_qtMC_roJU": "Gas Station",
  "Gattaran_promo_RuGX_dOwC": "Ad Budget",
  "Internal_Tools_App_LMjQ_TQFW": "Current distance to gas station: {{Distance}}",
  "Gattaran_202406_iXbv_CcJq": "Basic Task Information",
  "Internal_Tools_App2_ZjjL_OoOa": "Details",
  "FoodB_email_FvUP_tJQT": "Name",
  "FoodB_CL_Maximum_amount_oflZ": "Maximum Single Charge (CLP)",
  "Gattaran_Visit_Date_of_TyAN": "Date of accompanying visit",
  "FoodC_popup_After_closing_ujoW": "If you leave this page, your item selections won’t be saved",
  "Gattaran_management_nGle_XtpC": "Store Email",
  "FoodB_opencheck_BEoy_GUyq": "Please check if the store has downloaded {{99Store}}",
  "Internal_Tools_App_vJec_vZqL": "SWIFT Code",
  "Internal_Tools_App_VzrE_Uvmn": "Gas Station Name",
  "Gattaran_Visit_Getting_ready_zDyf": "Readiness",
  "FoodB_20260130_LRgr_ZBuv": "Tool Mastery",
  "FoodOpB_management_Launching_HwsY": "Expand",
  "Gattaran_management_IEaM_OfwD": "Contact Name",
  "GDriver_trans_seconds_fFsz": "secs",
  "FoodB_I_QuSz_HsAZ": "Promo Discount %",
  "FoodB_sob_dQvJ_WRCM": "Link SOB Account",
  "Gattaran_mgt_No_performance_GzjE": "No performance data",
  "FoodB_accompanyvisit_WoFg_gLDx": "Were they able to adapt their language and communication style to the decision-maker’s profile in order to build genuine trust?",
  "Internal_Tools_App_FiXW_DMEF": "Acquiring",
  "Gattaran_0229_SpOD_JZZs": "This may be due to the mutually exclusive filtering conditions you selected in the DiDi Partnership, Offline and DiDi Operations.",
  "FoodB_audit_The_information_jxLV": "The information you submitted does not meet the",
  "FoodC_Notification_ZawA_BoKt": "View all ongoing orders",
  "FoodB_420241024_TFhQ_lSww": "Rejected successfully",
  "FoodB_optimizing_Duplicate_Store_aBYS": "Duplicate Store ID",
  "FoodB_report_DLbK_IWIH": "Incorrect address?",
  "Gattaran_202406_QyVz_DlrH": "Task Priority",
  "FoodC_202412_Afcx_fMwc": "Select Address",
  "Gattaran_V2_XHhz_OxUM": "Task Time",
  "FoodB_APP_eiHc_XFQQ": "Promo Percentages",
  "Gattaran_Visit_Visit_process_dZws": "During the visit",
  "FoodB_1106_Ezht_DXlH": "File size cannot exceed 5MB",
  "FoodB_page_LVCK_ZWBK": "Done",
  "FoodB_20260130_JUUM_TDMw": "Improvement Opportunities",
  "FoodB_process_ziFN_pEHW": "RTBO Progress as of Yesterday",
  "Internal_Tools_App2_ALgE_nywC": "Result: {{result}}",
  "FoodB_in_HOiz_LgJT": "Submit",
  "FoodB_V1_vKqg_VkFI": "Project List",
  "Gattaran_Top_gxPb_uTLM": "3. Once a store becomes a DiDi Top store, it will get some traffic perks which greatly enhance order volume, so try to help your store qualify for DiDi Top",
  "FoodB_survey_CEvs_qbnA": "Competitor’s Commission Rate – P",
  "FoodB_email_SHyg_fIzy": "Email address is missing. Please add this information to send the email",
  "FoodC_202412_enwa_nWfu": "This item is sold out. Try exploring other items in the store",
  "Internal_Tools_CRM_sYtz_hQDA": "Gas Station Name",
  "Gattaran_url_TmcA_KzBM": "{{Uber}} Menu Link",
  "Gattaran_material_javG_HxIv": "Tasks available with the current visit method",
  "Gattaran_transformation__sLrG": "The current signatory has a lead under review. The contract may be signed once the lead is approved.",
  "FoodOpB_1_There_may_scoc": "Looks like there might be a scheduling conflict. The plan for the selected date is:",
  "FoodB_sob_cDKJ_oFcF": "Linked successfully",
  "Internal_Tools_App_TDqq_hkdP": "Product Type",
  "Gattaran_0_Create_new_Faau": "Create Contact Person",
  "FoodOpB_1_Are_you_sLNY": "Are you sure you want to close this visit? After closing, the visit will be invalid, and data cannot be input",
  "FoodB_20260130_UEYG_BeRR": "Sense of urgency",
  "FoodC_edit_KDUB_nVRR": "Required",
  "FoodB_opencheck_XqjA_alBe": "Completed",
  "FoodB_Contract_adlR_lBNU": "Has the approved dine-in menu been successfully uploaded?",
  "Gattaran_V2_DwZk_joic": "Task Name",
  "FoodB_20260130_rYlT_MdwI": "Other",
  "Internal_Tools_0523_XvOO_ugWO": "Registered. View Details",
  "Gattaran_management_lLpT_dFdN": "Not Visited",
  "Gattaran_visit_jnPQ_METw": "Is store owner at the store?",
  "Gattaran_202406_CvwH_Obyc": "Task End Time",
  "FoodOpB_results_The_key_HHMa": "KP was not in the store",
  "Gattaran_Feedback__WUQR": "My Feedback",
  "FoodOpB_1_A_recent_LtIi": "One or more unfinished visitation plans already exist. Do you still want to input data?",
  "Internal_Tools_App_skNg_IIIe": "No",
  "Internal_Tools_App_qOUi_WmVg": "Latitude",
  "Gattaran_V20__eJGq": "Potential",
  "Gattaran_optimization_qReN_wCHB": "This month’s visit tasks were updated. View now",
  "FoodB_email_Zgsh_mNSy": "KP",
  "Gattaran_form_rWtU_nHko": "Please select",
  "FoodB_optimization_Special_Meal_YtqD": "Sale Items",
  "Gattaran_0_Prices_of_kkXs": "Prices in DiDi against physical menu",
  "FoodC_20240607_hfCf_kdpO": "Phone",
  "Internal_Tools_App_sXad_CZPU": "Region and Language",
  "FoodB_task_UZKM_xysG": "Current Value",
  "Gattaran_84_qedy_lUwd": "Violation Level",
  "Groceries_web__Ovnh": "Sorry! Grocery stores are only visible in the mobile app at this time",
  "FoodB_IGV_WGYF_kfvV": "IGV",
  "Gattaran_opt_AIBq_AcbH": "Edit lead information",
  "Gattaran_status_Ozec_ScYy": "Rejected",
  "FoodB_1106_dhXS_LAAs": "AI Summary Generation Failed",
  "Gattaran_form_MhMj_Wboc": "Add Platform Information",
  "已选择": "Selected",
  "FoodC_edit_stZr_IBeA": "Other",
  "FoodC_edit_AxtX_PAiY": "Example: 1118, Building C",
  "FoodB_20260130_uXlC_uqel": "Commercial Conversation",
  "FoodOpC_backend_Urban_hhdx": "City",
  "FoodOpB_app_Need_to_XZYr": "Requires physical visit",
  "Gattaran_opt_bWcH_ShAH": "Add Plan",
  "FoodB_Analysis_Yesterday_nearly_aBCt": "Yesterday",
  "FoodB_calculator_ULXU_HjOF": "VAT Rate",
  "Internal_Tools_App_cuvl_RIgb": "Confirm Exit",
  "FoodB_calculator_WKKD_DbHM": "Electronic Payment Taxable Amount",
  "FoodB_opencheck_ZCLB_lZeJ": "Menu & Pricing",
  "Gattaran_V2_CRUc_Yeyn": "Promotion Details",
  "FoodB_process_fSqQ_sYNN": "Enter item name",
  "FoodB_opencheck_JIkE_hhmG": "Address Information",
  "FoodD_Questionnaire_Finished_YvLk": "Done",
  "FoodB_030_fqBt_uzDV": "Missing permissions: {{City}}. Please request permissions in Gattaran",
  "FoodB_1106_Jvwt_cvqA": "Upload Audio File",
  "Gattaran_management_tfXo_jhuS": "Task Status",
  "Gattaran_V2_XzcI_uroK": "Promotion Name",
  "Gattaran_opt_CjOE_rGuI": "View More Visit Info",
  "Internal_Tools_CRM_lbMF_fwNr": "Primary Contact Name",
  "soda-c-i18n---早间：%s-%s": "Mornings: %s-%s",
  "FoodD_Orders_Can_not_fkHK": "Start time cannot be greater than or equal to end time.",
  "FoodB_data_Beginning_PbJC": "Start Time",
  "FoodOpB_Translation_Cash_accounts_fSLJ": "Checking account",
  "Fleet_tool_Search_sFMa": "Search",
  "FoodB_management_diEN_EjtS": "Store Manager",
  "FoodC_orderlist_Completed_Xuod": "Completed",
  "FoodB_B86_vHgx_eMOl": "Current Issues",
  "FoodOpB_tagging_Non_retail_JnDS": "Not a restaurant",
  "FoodB_scenario_DYVH_kYTv": "B Duty Cancellations in Last 7 Days",
  "Gattaran_0__diqD": "No stores",
  "Internal_Tools_CRM_VRWr_pCnt": "General Sales",
  "FoodB_1106_ZAuG_REFT": "Are you sure you want to close and exit? The recording will stop, and your content won’t be saved.",
  "Gattaran_Visit_Empathy_and_CvFh": "Empathy and Beginning of the Negotiation",
  "Gattaran_0_Clerk_call_fhnx": "Employee’s Number",
  "FoodB_scenario_iTKN_qRYT": "Order is outside delivery area",
  "Gattaran_20240409_JERr_RtyH": "View All Stores",
  "Gattaran_AlertV1_MVye_ihrr": "Current performance coefficient",
  "FoodB_1106_BLKp_thZN": "Follow-Up Information",
  "FoodB_opencheck_kRqA_FpQO": "Printer & Receipt",
  "FoodB_accompanyvisit_lUAu_lYme": "Professionalism and Engagement Approach",
  "FoodOpC_system_Business_hours_coEs": "Business Hours",
  "Gattaran_form_TTAw_lJPb": "Enter notes as supplementary information",
  "FoodB_calculator_HXix_qhAK": "Individual ISR Amount",
  "FoodB_page_cium_rzWL": "Tap to record and let AI automatically generate a visit summary",
  "FoodB_indicator_cGGf_oMTT": "Metric Value",
  "FoodC_202408_reKH_lclj": "Add delivery address",
  "Gattaran_cancelation_vqja_qihk": "Please select",
  "FoodB_scenario_cDgW_SOLZ": "B Duty Cancel Rate in Last 7 Days",
  "Gattaran_mgt_Achievement_GuwU": "Goals Met",
  "Gattaran_Visit_Business_feedback_Llza": "Business Feedback Conversation",
  "FoodB_phrase__PWcd": "There are no ended promotions to show",
  "GDriver_Rate_Mkpg_QdjY": "Take Rate Strategy",
  "FoodB_1106_bquQ_ajOd": "Text Input",
  "Gattaran_opt_ZCLf_SEBU": "Shop ID",
  "GDriver_demand__ILlE": "Delisted",
  "FoodB_optimization_Not_started_XTpL": "Not started",
  "FoodB_email_wMIf_SGNM": "Contact Name",
  "Internal_Tools_App2_bbEY_frCr": "Are you sure you want to delete this?",
  "Gattaran_20240902_YGUw_avxA": "Reject",
  "FoodC_replace_Clear_Filter_iwTY": "Clear filters",
  "FoodB_030_SQUQ_YDRS": "Not My Stores",
  "Gattaran_add_bXDc_IEuz": "Connectivity (Daily average) > 60%",
  "FoodB_governance_OCvE_wAPt": "Handle Now",
  "FoodB_Translation_JSTh_Vrzb": "Detailed Appeal Reason",
  "FoodB_management_csuF_MCdo": "Please enter a valid email address",
  "Gattaran_online_HStX_yFLt": "First online time",
  "FoodB_0622_Increase_store_kZfr": "Add Store Comparison",
  "FoodB_calculator_GdDU_bFgc": "Platform Rewards",
  "Gattaran_side__nJvf": "Wednesday",
  "FoodOpB_CRM_Party_B_BCQp": "Company ID No.",
  "Gattaran_REGULAR_XlOa_yzqB": "Output",
  "FoodOpB_crm_Business_model_wjXI": "Business Mode",
  "FoodB_indicator_nLPV_KIjh": "Current Score",
  "FoodB_calculator_BKfQ_ehtA": "Platform Commission",
  "FoodB_page_YwxF_xrtk": "Do not exit this page while uploading, or your upload will not be saved",
  "FoodB_email_SdUD_YAhg": "Information is missing. Please add this information to send the email",
  "FoodB_1106_XrIH_sjvu": "Sorry, the AI analysis of your record has failed.",
  "FoodB_0617_qTmE_PWeM": "How many in-store pickup orders does the restaurant handle each day?",
  "FoodB_process_vjLl_iVPp": "Rejected",
  "Internal_Tools_App_xWMr_AnaW": "Call",
  "FoodB_accompanyvisit_wQpj_fUwf": "Please evaluate how the BD conducted the sales process: Did they effectively identify pain points, clearly present the proposal, and confidently guide it toward closing the deal?",
  "FoodB_accompanyvisit_eQAg_imAj": "Did the BD demonstrate reliability, confidence, and professionalism when interacting with partners?",
  "FoodC_20240607_Upph_ldoj": "Purchase Reminder",
  "FoodB_calculator_VKAb_KHst": "Platform Reward Rate",
  "FoodD_Name_May_zYiz": "May",
  "FoodB_list_KP_Name_GQRs": "Store Rep Name",
  "Gattaran_statusbar2_zVad_yPpm": "Rejected",
  "Gattaran_20240409_cmyA_kTJa": "Registration Open ({{num}})",
  "Gattaran_jumpnewstore_kzko_qHFR": "Tap to view traffic data",
  "FoodB_communications_APfO_DcRl": "New Store Boost Task(s) Not Completed",
  "Gattaran_20240409_krBB_ZQnQ": "Not Started ({{num}})",
  "Gattaran_management_HNXE_vNoU": "Task ID",
  "Gattaran_status_pAhA_kENZ": "Verifying",
  "FoodC_edit_JdIz_uKvw": "Meet outside",
  "FoodC_education_In_order_SRIb": "This Cancellation Policy was formulated to help all users enjoy a fair and reliable experience when using {{brand_name}}.",
  "FoodB_Show_Taxpayer_Document_eadz": "Taxpayer Document Type (Local)",
  "FoodB_scenario_czrv_MZIJ": "Menu needs to be updated",
  "Gattaran_opt_Qotr_nHZK": "Store Report",
  "Gattaran_v1_pVFJ_UAfK": "Register Store for Event Promotion",
  "FoodC_202408_LBac_RLgP": "Please add your delivery address so the courier can deliver the order to you",
  "FoodOpB_center_Rejection_FiOu": "Reject",
  "Gattaran_management_SqSM_FwHJ": "Visited",
  "Gattaran_feedback_Xihz_dCuZ": "Incomplete Feedback",
  "Gattaran_statusbar2_QQFK_mEcw": "Verify",
  "FoodC_202408_BsWi_bWTi": "Edit Address",
  "FoodB_1106_hYOE_wfgV": "Preview Recognition Result",
  "FoodC_202408_LtuD_oTxz": "Cancel",
  "FoodB_V1_hqNE_fQDz": "projects",
  "FoodC_sales_If_the_TsPm": "If the package had seals (e.g., staples), please confirm if they were intact upon delivery. This helps us verify your issue with the store and courier, but won’t affect your case result.",
  "Internal_Tools_App_kPwc_tSpo": "Information not saved. Still exit?",
  "FoodB_Analysis_Nearly_7_wumh": "Last {{day}} days",
  "FoodB_2_During_the_QHhU": "Promotion Period",
  "Gattaran_202406_ODsG_JrEY": "task(s) to be completed",
  "Gattaran_Visit_Formula_item_xqos": "Formula = (Event 1 score / 4 + Event 2 score / 4 +...) / Number of events * 100%",
  "FoodB_process_WMCl_eXXl": "Appealing",
  "Gattaran_ES_ZfMz_IKyd": "Connectivity",
  "FoodC_education__2_uVUK": "(2) The store you ordered from is closed, an item is sold out, an accident occurs, or the order is cancelled by the store or courier for another reason, in which case you will receive a full refund.",
  "Gattaran_transformation__AByw": "Signatory Type",
  "FoodB_V1_VKlO_UPTE": "Project Description",
  "FoodB_orders_Select_Store_gtmG": "Select Stores",
  "Internal_Tools_App_iieD_DElO": "Tax ID: {{Tax_id}}",
  "FoodB_audit_Suspected_duplicate_ntLx": "Suspected Duplicate Store",
  "Internal_Tools_App_Qhjz_HpXk": "Longitude: {{lat}}",
  "FoodB_20260130_zsJf_PMwY": "Not Applicable",
  "FoodB_20260130_sqnQ_jioF": "Product mastery and commercial proposals",
  "Gattaran_202406_VqOU_hMFa": "Task Type Priority",
  "Gattaran_202406_CltK_IQGG": "Created ({{N}})",
  "FoodB_Optimization_LfPz_zDPq": "Complete RTBO",
  "Gattaran_AlertV1_yVMN_aZdo": "Store Alerts",
  "FoodB_Show_Taxpayer_Document_TFeg": "Taxpayer Document Type (National)",
  "Gattaran_0_App_Operator_ikIT": "App Operator",
  "Gattaran_202406_ztqf_jOPK": "Incomplete",
  "Gattaran_202406_dDeL_ULkW": "View",
  "FoodB_Contract_yBjK_Ngdm": "Is the agreement exclusive?",
  "Gattaran_function__vJQK": "You’re using the latest version",
  "Gattaran_cancelation_ytQo_VUhl": "{{N}} Task(s) Executed",
  "FoodB_1106_dvab_aMNJ": "Submit",
  "FoodB_management_BPgJ_auGY": "Issuance Time",
  "FoodB_report_CVHi_kjAP": "Store Location",
  "FoodB_accompanyvisit_QoJr_HduH": "Please evaluate how the BD executed the business process, including their ability to interpret KPIs, negotiation skills, and proficiency with tools.",
  "FoodB_opencheck_pkQS_Jxyo": "Open Check",
  "FoodB_2_UTCg_iJFB": "No store order was detected. Do you still want to complete the open check? (It will be manually reviewed after submission)",
  "Gattaran_visit_hZGE_sfuk": "Overall Feedback",
  "Gattaran_Optimization_SGMS_fnOQ": "To DiDi Food",
  "Gattaran_form_YnWW_YxTG": "Add Contact Person",
  "FoodB_2503_JeQk_FWxd": "Loading…",
  "FoodB_optimization_Buy_gifts_daUI": "Buy X Get Y Free",
  "Gattaran_material_DYNa_ciax": "Task Review Status",
  "Gattaran_opt_EFMf_fxMF": "Last Visit",
  "FoodC_update_The_expected_ZzFg": "The estimated delivery time is based on the latest estimated arrival time.",
  "FoodB_pt1_ofEk_bcpz": "Contact Email",
  "FoodC_202408_BTvL_umes": "Are you sure you want to exit?",
  "FoodB_B86_lRNJ_EMZv": "Accurate",
  "FoodB_management_BTeP_YljD": "Complete the task",
  "FoodB_v12_XWfx_gGrQ": "Order Integrator Name",
  "FoodOpB_CRM_Taxpayer_Information_Flde": "Local Tax ID Photo Attachment",
  "FoodC_202408_ReqK_LVas": "Confirm",
  "Gattaran_V2_NgaM_BsXe": "Promotion Summary",
  "Gattaran_opt_QCLu_UWmJ": "Cancelled Orders",
  "Gattaran_0_Can_t_zMtY": "Couldn’t be reached",
  "FoodB_model20250116_HPUj_zcce": "Location not found. Unable to check in or out. Please enable Location Services in your phone’s Settings and allow the BD app to access Location Services",
  "FoodB_clockin_GfHc_jTsX": "Checked in with No Visit Details Filled Out",
  "FoodB_420241024_rQXh_ONDO": "Achieved",
  "FoodB_2_R_Burn_CgKc": "R burn",
  "FoodB_system_Competition_NFPY": "Competitor",
  "Gattaran_84_yiob_OivQ": "Black",
  "Gattaran_statusbar2_UQFc_DODT": "Following up",
  "Gattaran_0_Publicity_cards_HSYt": "Stoppers",
  "Gattaran_management_fVhj_uFOo": "Please feel free to contact us. Thank you!",
  "FoodB_20260130_kPaF_pdwu": "Almost Never",
  "FoodB_management_Untied_tYEF": "Unbind",
  "Gattaran_form_mvdB_WqwR": "Add upcoming action",
  "Gattaran_visit_kYQA_ZYsK": "BD resolved store’s objections",
  "FoodB_20260130_WiZC_rYRd": "Never",
  "Gattaran_mgt_System_recommended_AeDM": "Recommended sorting",
  "FoodB_opencheck_nxrN_OKDp": "Please ensure the store phone number is correct and reachable, so couriers and customers can contact the store",
  "Gattaran_status_AuAL_dKPA": "No Visit Record",
  "FoodB_B86_AADM_isyE": "Cancel",
  "FoodC_education__1_qvVC": "(1) You don’t pick up your order in time",
  "soda-c-i18n---请告诉我们，帮助我们一起改善": "Let us know and help us improve",
  "FoodB_calculator_RWNx_Xkrf": "Individual",
  "Gattaran_optimation_QjMB_BOgo": "Accompanying Visit Form page exited unexpectedly. Tap “Reopen” to go back to the last page you were on.",
  "Gattaran_form_jbbp_rBPM": "Leave",
  "Gattaran_transformation__hYxT": "Associate Signatory",
  "Gattaran_Edition_oXdU_Hnsz": "We couldn’t find what you were looking for",
  "FoodB_process_nXaG_aweQ": "Match Details",
  "Internal_Tools_App_fEpS_WJta": "Longitude",
  "FoodB_V1_zPrX_zWoE": "Change in R burn/GMV",
  "FoodB_management_Sector_LRtz": "Department",
  "FoodB_0905__pNYF": "Orders are overlapped. Sum does not reflect the total orders completed each day",
  "FoodB_1106_SvnP_rxzP": "Done",
  "FoodC_202408_XlDL_LjiM": "Got It",
  "Gattaran_0_Price_management_rLvu": "Price Management",
  "FoodB_accompanyvisit_NWZA_xYGO": "Please comment on how the BD prepared for the accompanying visit: Were the goals clearly defined, was the CRM system used effectively, and was strategic focus maintained during the visit?",
  "FoodB_0623_Store_GZFE": "Store",
  "Gattaran_opt_BEjW_mzFb": "Data report can be viewed after first time online",
  "FoodOpB_results_No_store_ZJQG": "No valid contact information for the store",
  "FoodC_Website_DiDi_FoodDiDi_wtqn": "DiDi Food | DiDi Delivery. Enjoy Great Food Anytime, Anywhere",
  "Gattaran_0_If_you_xGEs": "One or more fields are empty. Please check and try again",
  "FoodC_edit_dECN_fkIy": "Meet outside office building",
  "FoodOpB_crm_Takeaway_mode_UxEG": "Food Mode",
  "FoodC_202408_tJIe_WbFo": "Cancel",
  "Gattaran_workstation_zYPi_OfrB": "Target Value",
  "FoodB_2__CkLu": "Same City",
  "FoodB_resivion_Inaccurate_information_dmRA": "Inaccurate information?",
  "FoodC_page__KWIm": "Got It",
  "FoodB_20260130_eQWh_Vvub": "Optimize Agenda and Route Management",
  "FoodB_subsidy_tVNZ_GHKr": "Reminder",
  "FoodB_0905__Uuug": "Diagnostics Rules",
  "FoodC_sidebar_Update_successfully_cuyI": "Updated successfully",
  "FoodB_process_eAKS_LYXf": "Rejected",
  "FoodC_20240607_RSyh_XJnN": "Please open the link on your mobile device",
  "Gattaran_Visit_VrZq_Dgvh": "Additional opportunities",
  "Gattaran_feedback_wHFC_wkFP": "Please enter the specific reason",
  "Internal_Tools_App_iCHw_cRVH": "Other",
  "Gattaran_0_Visit_Registration_AZYL": "Store Collect Info",
  "Gattaran_0_Increase_social_MxxK": "Add for Restaurant Social media",
  "FoodB_in_KrvJ_sgtQ": "You’re over {{distance}} meters away from {{storename}} and cannot check in. Take a photo with the store sign to complete it.",
  "FoodB_20260130_gEaG_lLwE": "Agreement and Objection Resolution",
  "FoodB_accompanyvisit_qeYs_vmCH": "Advantages",
  "FoodB_20260130_xZuv_HObe": "Strengthen Negotiation Skills",
  "FoodB_management_YBeV_ZPVJ": "The name cannot exceed 50 characters",
  "Internal_Tools_CRM_jrXd_olfC": "Best Time to Visit",
  "Internal_Tools_App_mzyX_fryx": "Select Time Range",
  "Gattaran_Optimization_IGsH_WCQM": "Open on DiDi Food",
  "FoodB_V1_toMO_YDdz": "Regular Tasks",
  "Gattaran_v2_LSlZ_XduF": "Tap to learn the rules and help the store become a {{DiDi_Top}} Store",
  "FoodB_0623_Indicators_auar": "KPI",
  "Gattaran_20250610_poQp_BBLe": "Pending Onboarding",
  "Gattaran_center__HcEx": "All messages have been marked as read",
  "Gattaran_page_zJGg_ZjcY": "Please complete the store credentials information and request contract signing",
  "FoodB_model20250116_GjAr_XZPC": "Check In",
  "FoodB_score_wfAf_crwP": "Ranking Logic:",
  "Gattaran_0__mpop": "Please open it in the App or search for \"Gattaran&Explorer feedback\" in D-Chat to enter the feedback group",
  "FoodB_APP_WsXR_yQpy": "Investments",
  "FoodOpB_Translation_Legal_persons_RduO": "Legal person",
  "FoodC_20240607_wWhy_deWR": "Please refresh the page and try again",
  "Gattaran_management_WVOf_JOti": "View",
  "Gattaran_material_WsIN_lrzh": "Under review: Once approved, the task will be automatically completed",
  "FoodB_1106_kpYX_BXVq": "Analyze",
  "Gattaran_optimation_MQrO_OvRt": "Want to recover this page?",
  "Gattaran_resivion_More_KTYU": "More",
  "Internal_Tools_App_iRIy_dqLi": "This month",
  "Gattaran_B86_AQDt_AMVU": "B Duty Cancel Rate in {{number}}",
  "FoodC_switch_TFwP_lxTd": "Default Tip Option",
  "FoodOpB_efficiency_Store_UpAc": "Signed Stores",
  "FoodB_tasktoteams_aXrr_bgrl": "Daily Orders Completed (Self-operated Order Service)",
  "Gattaran_V1_ZDXa_aTjw": "Valid Promotions List",
  "FoodB_0905__uatF": "Higher than {{number_or_rate}} of stores nearby",
  "FoodB_20260130_KYcL_KXQE": "Almost Always",
  "Internal_Tools_App2_UCNH_VaOP": "Today",
  "Gattaran_202406_IIUg_NlxT": "Store Info",
  "FoodB_management_ouRt_eARK": "Please select a role",
  "FoodC_edit_wBJW_yfSo": "Apartment",
  "Internal_Tools_App_BEnH_Yxgl": "Minimum search is 2 days",
  "FoodC_20240607_aOOB_RMKm": "Cash payment is temporarily unavailable",
  "FoodB_20250414_QcoH_HIDg": "Total Users",
  "Gattaran_202406_htDL_CJTB": "Task Creator",
  "FoodB_0905__kaPI": "Diagnostic Score",
  "FoodB_20260130_FbBo_MxTb": "The BD researched the current situation of the Rs to be visited (competition, metrics, pricing, etc.)",
  "Gattaran_0__tWkQ": "Sale Items",
  "FoodB_ads_WAjG_IoqX": "Ad",
  "Gattaran_Optimization_cVHJ_PCUb": "Tap to display the store’s business hours details",
  "soda-c-i18n---送您%s张免配送费券；": "we’ll give you %s Free Delivery coupon",
  "FoodB_supplement_Network_connection_RVcl": "Connection failed. Please check your network settings",
  "FoodB_tagging_You_chose_tIKm": "You chose to invalidate this lead for the following reason: “Store does not exist.” To do this, you must be within {{distance}} from the store. Please verify and try again.",
  "FoodB_task_idjV_gpOC": "Task Executed",
  "FoodB_accompanyvisit_qoYF_XrTD": "Did the BD demonstrate confidence, professional business communication, and a humble yet not arrogant presence?",
  "FoodB_opencheck_HmpM_qXXX": "For merchants operating multiple stores at one location, please verify the integration and order acceptance configuration on {{99store}} are correct",
  "Gattaran_add_xwYd_UfEG": "Logo",
  "FoodC_20240607_eLRx_hJRj": "Page Unavailable on Desktop",
  "Gattaran_Gattaran_wHVV_MQDY": "Plan Type",
  "FoodB_20260130_HUuq_fjkk": "No Score",
  "Gattaran_0_Contrast_the_YwEa": "Decrease prices from competitors",
  "FoodB_opencheck_azHm_SBan": "Please ensure the store name displayed on Customer app is correct",
  "FoodC_edit_Hxmm_vrkU": "Residential Building",
  "Gattaran_V1_gCzF_PJKj": "{{num}} promotion(s) to follow up",
  "FoodB_tasktoteams_FSIB_Lmdl": "{{Rappi}} Menu Link",
  "FoodB_communications_ZlRD_aGjm": "day(s) left",
  "Gattaran_opt_xawD_vBtI": "Daily Online Hours",
  "FoodB_20260130_dkze_tLMR": "The BD is clear about the objectives of the associated visits",
  "Internal_Tools_App_oOyW_tZKN": "Delisted",
  "FoodB_management_JCLV_lXux": "Contact Information",
  "FoodB_0617_UUYe_lgPA": "Competitor’s Commission Rate - R",
  "FoodOpB_1_Visit_dXVU": "Visit",
  "FoodB_0617_JNlE_tpzR": "Competitor’s Commission Rate - U",
  "Internal_Tools_CRM_ZxcL_MqnG": "Purchase Price",
  "FoodB_leads_The_relationship_jkYA": "Best contact time",
  "FoodB_accompanyvisit_GMeg_eJaf": "Throughout the accompanying visit, did they consistently maintain a proactive and organized work state, while effectively using time to optimize overall performance?",
  "Gattaran_form_KjAJ_bymE": "Visit Plan Details",
  "FoodB_20260130_gMyi_nxVp": "Effective closing",
  "FoodB_page_Sbrx_Otpv": "Are you sure you want to exit? If you exit, the analysis results will only be available through in‑app messages.",
  "Gattaran_BDapp_Pder_myCx": "BD Portal (CKA)",
  "Gattaran_feedback_tOgJ_GxDc": "Upload Image (Optional)",
  "FoodD_suspensionpage_In_the_zGEU": "No more results",
  "FoodC_202408_AFKG_hWIj": "Outside delivery area. Select another address",
  "FoodB_page_Ejhz_BIgP": "Register",
  "FoodOpB_StoreInput_Store_Information_mIjy": "Store Rep Info",
  "FoodB_20260130_YWCI_RTgg": "Improve Closing Effectiveness",
  "FoodB_APP_hvLT_iISi": "Daily Maximum Investment Amount",
  "FoodC_perception_Tip_exceeds_VSFf": "Tip amount exceeds limit",
  "FoodB_V2_Satisfied_with_YFEM": "Satisfied with status quo",
  "FoodB_Translation_vrHE_fstW": "Rectified",
  "Gattaran_84_eYqA_KQKL": "Violation Occurrence Time",
  "FoodB_revamp_JrnZ_UzZC": "Formula",
  "Gattaran_84_ipYl_XAMQ": "Signatory Name",
  "Gattaran_V2_tHSp_MfFU": "Days with Goal Met ≥",
  "FoodB_group0901_KjSA_JaMq": "Must-Have",
  "FoodB_accompanyvisit_csKl_ZhaN": "Attitude and Performance",
  "Gattaran_0915__UZgP": "Calculation Period: {{date1_date2}}",
  "FoodB_email_AhaC_FOft": "Other Contact",
  "FoodB_requirement_aAaC_nmQK": "Peak Hours Online",
  "FoodB_20260130_HZgt_YVcN": "Formula = (Strategic Preparation Score + Business Negotiation Score + Visit Outcomes Score) / 3 * 100%",
  "FoodB_Side_JVcJ_wJec": "Business Hours",
  "FoodB_tagging_You_chose_lWSH": "You chose to invalidate this lead for the following reason: “Not a retail store.” To do this, you must be within {{distance}} from the store. Please verify and try again.",
  "Gattaran_202406_JIgY_duWs": "Received",
  "Internal_Tools_0523_ZlFL_LzUJ": "Register",
  "FoodB_1106_UjEj_dsYG": "Cancel",
  "Gattaran_0_Not_willing_JFcK": "Not willing",
  "Internal_Tools_App_kYus_Rwmo": "Phone Number",
  "FoodB_model20250116_PRsL_yJEl": "Please select at least {{num_required_fields}}",
  "FoodB_20260130_iMSl_cUof": "KPI management and understanding of restaurant metrics",
  "FoodB_v12_zpim_qhxP": "Integrator Name",
  "Gattaran_84_SZSe_qxUU": "Serious Violation",
  "Gattaran_0__sDLK": "Click the Load button to view more stores",
  "FoodB_process_fmOQ_ZlAg": "No item found",
  "FoodB_calculator_QGtY_JOsw": "Store Investment Share of Discount",
  "Internal_Tools_App_giWs_FLQG": "Enter any additional notes here",
  "Internal_Tools_App2_HKlO_Ulnq": "Percentile",
  "FoodB_page_VcqY_DnGG": "Semantic analysis is expected to take 1–5 minutes. Please stay on this page. If you exit, you can check in-app messages for the analysis results.",
  "FoodC_education_Basic_requirements_hIbv": "Basic Delivery Rules for Customers",
  "支付方式": "Payment Method",
  "Gattaran_202311_WXzo_Yqns": "Add Valid Lead",
  "FoodOpB_Translation_Tax_ID_yEbh": "Tax ID",
  "Gattaran_form_HuGK_YufB": "Edit Visit Plan",
  "FoodB_20260130_GcFe_YDVN": "Action Plan",
  "FoodB_scenario_TNIB_LZav": "Store closed for the day",
  "FoodB_Launch_Illegal_import_jlOS": "Invalid input",
  "Gattaran_Collection__kwys": "Map page now supports navigation to stores",
  "FoodB_accompanyvisit_sotp_ppjT": "Areas for Improvement",
  "FoodD_Name_November_BcWL": "Nov",
  "FoodB_GTR_MOcd_Ludv": "KA",
  "Internal_Tools_CRM_zbxK_LqJo": "Tax ID",
  "FoodB_sob_rSPd_SAxs": "SOB Linked",
  "FoodB_1106_ocKT_vZHR": "Recording cannot exceed 2 minutes",
  "Gattaran_0_No_contacts_EeBR": "No contact person",
  "Internal_Tools_CRM_LzIy_MlTO": "Brand",
  "FoodB_accompanyvisit_HBWN_qmUt": "Engagement Approach and Trust Building",
  "FoodB_Wordings_MYHl_FXti": "Select a Reason",
  "Gattaran_opt_FWKd_AEaY": "Click here to enter offline operations information",
  "FoodD_Incentive_In_progress_GNvs": "In Progress",
  "Gattaran_84_VVSs_wTou": "Dine in",
  "FoodB_2_Visit_Records_LiJy": "Visit Log",
  "FoodC_edit_fLUx_wHAP": "Example: I’m wearing a patterned shirt. You can also upload pictures of your surroundings to help the courier deliver your order to the correct place.",
  "Internal_Tools_App_pcBI_HhnE": "Reset",
  "FoodB_202204_Order_eJXF": "Orders",
  "Gattaran_Visit_Fill_in_aFuS": "Enter an Accompanying Visit",
  "FoodC_202408_KYqe_yVZD": "Not Now",
  "FoodB_250430_kaeY_cgas": "Visit Level",
  "FoodC_edit_kzdk_yzVc": "Meet at door to my room",
  "FoodB_survey_IegO_JQod": "Credit Card Demand",
  "FoodC_edit_HEFc_Dppo": "Meet outside my residential building",
  "FoodB_store_Order_Coupon_zpSY": "Order Rebate Coupon",
  "FoodB_APP_RDdB_KQgY": "Filter Sales Promotions",
  "FoodB_1106_fIyR_ECeB": "Please enter content",
  "Gattaran_visit_opSF_XPmM": "BD had a clear objective for the visit",
  "FoodB_report_nayE_PYlR": "Please select the correct store location",
  "FoodB_calculator_Vzvw_WmgN": "Payment Method",
  "Gattaran_20240409_JmCU_vNnz": "days later, registration will start",
  "FoodC_202408_IDjR_CbbT": "OK",
  "FoodB_2_Call_visit_NGFu": "Phone",
  "FoodB_I_Cancelled_orders_XeVk": "Orders Cancelled",
  "FoodC_education_2_Receiving_gFZl": "2. You should ensure that the delivery address and contact method you provide are correct.",
  "FoodB_1__GxZN": "Data from last 30 days",
  "FoodB_B86_xxgH_gxNC": "Incorrect",
  "FoodC_202412_AIDx_XZgz": "Edit Address",
  "Gattaran_Feedback__amKQ": "High",
  "Gattaran_0_Is_it_uBZs": "Is it a Dark Kitchen?",
  "Gattaran_0_Price_of_cdsJ": "Prices in DiDi against other apps",
  "Gattaran_V2_hSoR_bteQ": "BD can register for stores",
  "FoodB_APP_oNMt_RYzY": "Set Up Now",
  "Gattaran_optimization__HjAa": "Click the Back button again to exit Explorer",
  "Internal_Tools_App2_zKCw_IMpc": "Sat",
  "Internal_Tools_CRM_CqzP_fbCc": "City",
  "Gattaran_form_MglG_FNNK": "Visit Time",
  "FoodOpB_Translation_ID_Card_jQZG": "ID Card",
  "FoodB_20260130_UPbX_zUEa": "Strengthen Communication and Confidence Projection",
  "Gattaran_management_JcWN_FRMj": "Agreement with Store",
  "FoodB_report_iSNH_AOiz": "Please provide the accurate store address or coordinates and resubmit",
  "FoodC_cash_WQNI_uYzC": "Add",
  "FoodB_opencheck_EgVo_aDIk": "Please check if the store has a test order",
  "FoodB_collection_625_System_iWnH": "625 - Regime of Income from Technological Platforms Business Activities",
  "FoodOpB_Org_Edit_Gphm": "Edit",
  "Gattaran_Optimization_ZhGy_ZlOk": "Add Business Hours Details",
  "FoodB_0919__CONM": "Items Unavailable",
  "FoodB_1106_CBkZ_uDVO": "What are the next steps?",
  "FoodB_scenario_HbKA_WhYt": "Cancelled due to customer issue",
  "FoodB_GTR_nRcI_TMWR": "CKA",
  "Gattaran_202406_EMkK_osti": "Store",
  "Internal_Tools_App_fJQz_FBzw": "Last {{month}} months",
  "Internal_Tools_App_XqAW_HtbS": "Real-time Price",
  "FoodOpB_1_Plan_Nfsn": "Planning",
  "FoodB_V1_GLnG_kpoL": "Project Tasks",
  "Internal_Tools_CRM_nvDw_fHdG": "Post Code",
  "Gattaran_form_HWQO_aSuK": "Tap to fill in the form",
  "FoodB_Commision_Cancel_wbtQ": "Cancel",
  "FoodC_education_4_Customers_laxR": "4. You should accept your order within 10 minutes of the courier’s arrival at the delivery location.",
  "FoodOpB_Management_You_can_aDLi": "To create your new store anyway, click Appeal. Please note that it may take up to 2 days to review an appeal.",
  "FoodC_shop__MWyO": "Purchase limit: {{num}}",
  "FoodB_Translation_ycvD_ntAQ": "Appeal",
  "FoodB_in_nOzs_ZRGC": "Check-in Successful",
  "FoodOpB_Org_Can_not_swrB": "Are you sure you want to delete this? This action cannot be undone.",
  "FoodC_2022__SEQk": "Enter Tip Amount",
  "FoodB_opencheck_fpzY_bDWB": "Please confirm the delivery method and payment method",
  "FoodB_0622_The_statistical_NUCJ": "Data is calculated based on T+1 and sorted according to item sales volume over the last 30 days",
  "Gattaran_opt_OIIn_XXkw": "Review Audit",
  "Gattaran_form_KvgC_Afkb": "Confirm Exit",
  "Gattaran_V1_ZkCf_UOay": "Clear",
  "FoodC_202410_OFhs_UnlA": "Explore",
  "Gattaran_Edition_mvmO_sigb": "The selected date is conflicting with an existing visit plan. Once submitted, the previous visit plan will be overwritten.",
  "FoodB_0921__iLXg": "Quantity",
  "Gattaran_20240401_iQeT_rFly": "Thanks for your feedback",
  "Internal_Tools_App_Bufi_ZBrZ": "Navigation",
  "soda-c-i18n---送您1张%s折扣券；": "we’ll give you a %s off coupon;",
  "FoodB_0919__etPs": "Multiple Promos",
  "FoodB_indicator_ONJL_riny": "Score",
  "FoodB_20260130_wKpl_lEGS": "Preparation and data analysis",
  "FoodC_edit_EqUG_FRvo": "Apartment Name / Floor / Room No.",
  "FoodB_calculator_lSyU_ySZI": "Store in Guanajuato?",
  "Gattaran_material_GlUh_BTci": "Task Form",
  "FoodB_feedback_uLgw_xDsP": "Feedback Submitted Successfully",
  "FoodOpB_management_Actual_value_dSKC": "Actual Value",
  "FoodB_202207_Default_BQmA": "Default",
  "FoodOpB_app_Collecting_documents_wTBe": "Sending docs",
  "FoodB_V2_DQvR_Redp": "Please use the share function in BD app.",
  "FoodC_optimization_knQx_VpIr": "Add",
  "Gattaran_V2_RfQR_GPmX": "Task Metric Description",
  "FoodB_up20241218_dJSA_yyZX": "Confirm",
  "Gattaran_202406_Rqhc_vORg": "Store Tasks",
  "FoodB_scenario_cPkp_BcjZ": "Courier never arrived at the store",
  "Gattaran_optimation_uLZP_VtyM": "Reopen",
  "FoodB_20260130_sAvF_Somd": "Stage Rating: Visit Outcomes",
  "FoodB_Translation_wHEO_FLQr": "Appeal Successful",
  "FoodB_page_ckUV_pmrw": "Generating Your Summary",
  "Gattaran_mgt_All_SSzR": "All",
  "Gattaran_202406_ObEK_ztcK": "Data calculation of this KPI hasn’t been completed. Please check back tomorrow",
  "Gattaran_form_pQiE_NLFe": "Visit objective(s) recommended based on store diagnostics result",
  "Gattaran_page_kbBm_zDwh": "If you sign the contract here, a new signatory will be created for this store by default, and you won’t receive a hard copy of the contract. If you need a hard copy or wish to link to an existing signatory for chain signing, please go to GTR > Customer Management > Signatory Management instead to sign the contract. Are you sure you want to sign the contract here?",
  "支付": "Pay",
  "Gattaran_REGULAR_KZHa_qJOa": "Please enter an integer",
  "FoodB_IV_Tips_DFOG": "Alert",
  "Gattaran_202406_kjmQ_Epeu": "Created",
  "Gattaran_0_What_are_AWJz": "What is the major opportunitty identified in the zone?",
  "FoodB_model20250116_pAHl_Vjqs": "Not approved",
  "FoodB_management_Exlz_JjpO": "Any Supplies to Be Issued?",
  "Gattaran_202406_NOiB_wJYW": "Create Task",
  "Internal_Tools_Optimization_KJgL_fWkX": "Today’s Business Hours",
  "FoodB_Analysis_Rise_decline_dZnP": "Up",
  "Gattaran_jumpnewstore_FJjw_JHRB": "New Store Boost Task(s) Completed",
  "FoodB_management_tvNC_ULVM": "WhatsApp Number",
  "Gattaran_Visit_Advantages_CSEp": "Strength",
  "FoodC_Storefront_Fzba_uHgH": "Unable to Join",
  "FoodC_education_In_the_MKeB": "You will not be responsible for a cancellation in the following situations:",
  "FoodB_20260130_HpAF_xVst": "Relationship building and empathy with the customer",
  "FoodC_improve__ovBF": "Small portions",
  "FoodB_accompanyvisit_ebrS_uKVQ": "Score Details",
  "FoodB_0617_RqaF_EHZE": "Expiration date of the exclusive contract with the competitor - U",
  "Gattaran_0__ytbk": "Priority",
  "FoodB_audit_New_and_yYux": "Difference between new and old store names",
  "Gattaran_Visit_Related_Visit_RGas": "Associate Visit Log(s)",
  "Gattaran_side__OvkZ": "Thursday",
  "FoodOpB_tagging_Store_does_sduq": "Store does not exist",
  "FoodC_education_In_order_AZCw": "These Delivery Rules were formulated to help all users enjoy a fair and reliable experience when using {{brand_name}}. In the event of a delivery related dispute, the following rules will apply",
  "FoodOpB_Gattaran_Reset_ILVf": "Reset",
  "FoodB_1106_ZsZM_gMYt": "Please Summarize Using the Structure Below",
  "Gattaran_transformation__QWlQ": "Please complete all required items",
  "Gattaran_0__jRoM": "Open D-chat",
  "FoodB_time_Business_hours_kRTs": "Holiday Business Hours",
  "Gattaran_cancelation_Rcqm_Vawt": "Task-Related Visit Log",
  "Gattaran_20250610_swWp_JIQH": "RTBO completed. Please contact the store to confirm the contract",
  "FoodB_1106_vIQn_DUwT": "You’ve reached the maximum recording time of {{max_record_time}} seconds. Start analyzing the data?",
  "Internal_Tools_App_phGO_IYRt": "Sort",
  "FoodB_management_zycc_XYgy": "Invalid input",
  "FoodB_0921__kEaD": "Burn%",
  "FoodB_20260130_OgUC_hHHH": "Always",
  "FoodC_education_Cancellation_Policy_fxrl": "Cancellation Policy",
  "FoodB_email_Cebi_VpDl": "Phone",
  "FoodB_Analysis_New_customers_vYDl": "New Customers",
  "FoodB_up250108_UapS_ZXgM": "View Now",
  "Fintech_Credit_2__TvDQ": "Reason for Cancellation",
  "FoodB_20260130_eCWS_Wotm": "Effective use of tools and technology",
  "Gattaran_202406_UOFx_ekzp": "Cancel",
  "FoodB_resivion_Overdue_visit_jTHW": "Expired Visits",
  "FoodB_calculator_TJJY_SkoH": "Store Investment",
  "FoodOpB_CRM_Taxpayer_Address_EBwy": "National Tax Payer Address",
  "FoodC_202408_YjqN_Yvyz": "Add address to view delivery fee and time",
  "FoodOpB_analysis_Performance_analysis_NMbA": "Performance Insights",
  "FoodOpB_set_Determination_wYFG": "OK",
  "FoodC_202408_IMjl_ywFc": "Update",
  "Gattaran_System_wrVY_PjDQ": "Plan Name",
  "FoodC_202410_pHYX_VjbD": "Close",
  "FoodB_model20250116_TRTm_agBI": "Back",
  "FoodB_calculator_ydSg_ejbp": "VAT",
  "FoodB_2__FNaI": "Same Target Area",
  "请输入XXXXX-XXX": "Enter XXXXX-XXX",
  "合同类型": "Contract Type",
  "回收完成": "Returned",
  "签约状态": "Signing Status",
  "正常经营": "Online",
  "合作拜访结果": "Partnership Visit Result",
  "执照照片": "Photo of Permit",
  "重复门店电话": "Duplicate Store Telephone",
  "暂无合作意愿": "No cooperation intention",
  "日常维护信息": "Routine Maintenance Info",
  "签字": "Signature",
  "请选择不合作原因": "Select reason for not partnering",
  "首次完单时间": "First Order Completion Time",
  "支行号": "Branch code",
  "暂无": "None",
  "获取商圈中...": "Getting target area data...",
  "周四": "Thu",
  "请在Gattaran上完成撤销申请！": "Please complete the cancellation request on Gattaran.",
  "输入有误": "Entered incorrectly",
  "设备信息": "Device Information",
  "申诉通道": "File Appeal",
  "目前营业中门店": "Currently Open",
  "店主（法人）": "Proprietor (Legal Rep)",
  "未达到任务完成的标准": "Task Completion Requirements Not Met",
  "授权书照片": "Photo of LOA",
  "证号": "Certificate No.",
  "法人CPF": "Legal representative's CPF",
  "工具": "Tools",
  "工商登记时间": "Business Registration Time",
  "未确定合作": "Cooperation not confirmed",
  "Curp号必须为18位字符": "CURP must be 18 characters long",
  "提交成功": "Submission successful",
  "公司": "Company",
  "驳回原因": "Reasons for non-acceptance",
  "城市": "City",
  "发放时间": "Assigned on",
  "商机转交": "Assign to another team",
  "保存并发邮件&短信": "Save and Send Email & SMS",
  "签约授权书": "Signature Authorization",
  "信息已完善": "Information complete",
  "上拉加载更多": "Pull up to load more",
  "支付验证未通过": "Payment Verification Failed",
  "等待原因": "Reason for waiting",
  "平台配送及自配送不允许同时选择不支持": "“Platform delivery” and “Self-delivery” cannot both be selected",
  "平台管控中": "Store closed by system control",
  "信心度A": "Confidence level A",
  "信心度B": "Confidence level B",
  "信心度C": "Confidence level C",
  "是": "Yes",
  "同意上线": "Agreed to go online",
  "查看更多": "More",
  "KP CPF": "KP's CPF",
  "评分": "Rating",
  "法人名片假名": "Legal person first Name Katakana",
  "我的拜访": "My visit log",
  "居民证明": "Resident Certificate",
  "确认签章": "Request Signature",
  "合作拜访": "Partnership Visit",
  "拜访记录": "Visit Information",
  "无合作意向": "Not interested in partnership",
  "PAD型号": "Pad Model",
  "乙方名称片假名": "Party B Name Katakana",
  "开户行": "Issuing Bank",
  "点击收起": "Collapse",
  "暂停营业中": "Store Temporary Closed",
  "周日": "Sun",
  "已关闭": "Closed",
  "CNPJ": "CNPJ",
  "KP姓片假名": "KP Last Name Katakana",
  "有效": "Yes",
  "CKA BD": "CKA BD",
  "确定删除吗？": "Confirm deletion?",
  "日常工具": "Daily Tools",
  "正常": "Normal",
  "掉线中": "Store Disconnected",
  "沟通经营问题（服务管控+店铺装修）": "Discuss Operating Issues (Service Control + Store Decoration)",
  "梅斯卡尔酒": "Mezcal",
  "帐户持有人CPF": "Account-holder CPF",
  "商户运营": "Engagement",
  "菜单照片": "Menu Photos",
  "去设置": "Setup",
  "跟进中": "Following up",
  "销量(单/周)：": "Sales(Orders/Week): ",
  "支持以下哪种支付方式": "What payment methods does the store accept?",
  "失败号": "Non-Approval No.",
  "谷歌地图": "google map",
  "打开浏览器失败": "Unable to open the browser",
  "银行卡号仅支持数字输入": "Bank card no. can only include numbers",
  "佣金补贴周期": "Commission reward cycle",
  "沟通新店保护设置": "Explain How to Set Up New Store Boost",
  "公共契约编号": "Public Contract No.",
  "首次完成开店检查时间": "First Store Check Completion Time",
  "已签约": "Signed",
  "商家概况": "Store overview",
  "执行团队": "Responsible Team",
  "未连接到服务器": "Unable to connect to server",
  "KP CPF照片": "KP CPF Photo",
  "自配送起送费": "Store Delivery Min Fee",
  "电话号码不对": "Wrong phone number",
  "我知道了": "Got it",
  "考虑中": "Considering it",
  "Curp号": "CURP No.",
  "已归档": "Archived",
  "是否需要pad": "is pad needed ",
  "点击校准": "Calibrate Coordinates",
  "附件照片": "Photo Attachment",
  "%s级": "%s Level",
  "人工标记平台：": "Annual: ",
  "审核通过商户数": "Verifying Store",
  "老版无Curp": "Old Version w/o CURP",
  "首页": "Home",
  "商机无效": "Invalid Lead",
  "未完成": "Not completed",
  "支付验证": "Payment Verification",
  "返回": "Back",
  "账号无法登陆": "Couldn't sign in",
  "纳税照片": "Photo Attachment",
  "建议拍摄店面照片": "Photos of storefront are recommended",
  "标题": "Title",
  "不承诺": "No promise",
  "不能超过%d字": "Cannot exceed %s characters",
  "佣金补贴比例": "Percentage of commission reward",
  "放弃": "Discard",
  "请选择营业天数": "Select Days of Operation",
  "KP名": "KP First Name",
  "单次最大扣费金额": "Maximum single-order charge",
  "持卡人姓": "Cardholder Last Name",
  "请输入门店ID": "Please enter the shop ID",
  "售卖时间": "Business Hours",
  "是否有异常标签": "With wrong labels?",
  "是否有违规记录": "Has a record of violations?",
  "审批通过": "Verified",
  "上传最大数量为%d张，图片上限为5MB": "Upload up to %d image(s), max file size 5MB",
  "银行代理number": "Banking Agency Number",
  "地区": "Region",
  "门店logo": "Store Logo",
  "商家不愿培训": "Store is unwilling to receive training",
  "审核中商户数": "Approved Store",
  "银行": "Bank",
  "已完成设置": "Completed configuration",
  "已添加": "Added",
  "复制成功": "Copy successful",
  "愿意改善": "Willing to make improvements",
  "首次有效上线时间": "First Valid Online Time",
  "My Number卡": "My Number Card",
  "设备回收": "Device Return",
  "补充照片": "Other Reference Photos",
  "再次尝试电话联系": "Try contacting the store again",
  "填写拜访": "Enter Details of Visitation",
  "门店POI不能为空": "Store Location cannot be left blank",
  "商机信息": "Lead Info",
  "Pad": "Pad",
  "经营状态": "Business status",
  "与KP完成沟通即视为有效拜访": "Visiting and speaking with the Store Rep was a productive",
  "快速拍摄": "Snapshot",
  "设备故障": "Device malfunctioned",
  "菜单信息": "Menu Info",
  "出生日期": "Date of Birth",
  "自配送费": "Store Delivery Fee",
  "（创建超级管理员账号）": "（Create Super Admin Account）",
  "请输入": "Please specify",
  "法人姓": "Legal person last Name",
  "朗姆酒": "Rum",
  "合同记录": "Contract Records",
  "待办任务": "To do list",
  "（商家接收邮件）": "（Store Email Address）",
  "已首次上线商户数": "First online cumulative of Rs",
  "不想使用外卖模式": "Doesn’t want to use food delivery mode",
  "一般酒精产品贩卖准证": "General Liquor Retail License",
  "请选择": "Please make a selection",
  "营业时间段不能重叠": "Business hours cannot overlap",
  "有特殊情况不能上线": "Unable to go online due to special circumstances",
  "门店PAD信息": "Store Pad Info",
  "商户调研": "Store Survey",
  "葡萄酒": "Wine",
  "推迟": "Pending",
  "再次申请": "Reapply",
  "自配送佣金比例": "Service Fee Rate for Self-Delivery",
  "门店地址": "Store Address",
  "推荐完成": "Suggested tasks to complete",
  "拜访内容": "Visit type",
  "活期": "Current",
  "创建时间": "Created at",
  "过期拜访": "Visit after expiration",
  "刷新成功": "Successfully refreshed",
  "解约": "Terminate Contract",
  "价格承诺": "Price promise",
  "电子合同": "E-contract",
  "KP电话": "Store Rep Phone ",
  "不愿配合": "Unwilling to cooperate",
  "银行流水单": "Bank Statement",
  "是否需要拍照": "Does a photo need to be taken?",
  "请输入13位有效数字": "Enter a valid 13-digit number",
  "LTE": "LTE",
  "PAD领取人": "Pad Recipient",
  "银行名称": "Beneficiary bank",
  "确定": "Confirm",
  "金额": "Total",
  "待领取": "Unclaimed",
  "停止营业": "Stop Operations",
  "合作谈判": "Business negotiations",
  "KP姓名:": "Store Rep Name",
  "商机详情": "Lead Details",
  "信息未完善": "Information incomplete",
  "CPF": "CPF",
  "查看": "View",
  "证件照片": "Photo of ID",
  "税号": "Tax No.",
  "促进商户首次上线": "Encourage Store to Go Online for First Time",
  "语言": "Language",
  "登录商户账号": "Sign in to store account",
  "未联系到关键目标": "Failed to reach key person(s)",
  "任务类型": "Task Type",
  "打款授权书": "Payment Authorization",
  "营业时间": "Business Hours",
  "电话培训": "Phone Training",
  "联系不上": "Couldn't be reached",
  "编辑商机": "Edit Leads",
  "拜访时间": "Date",
  "纸质合同": "Hard Copy",
  "保存草稿": "Save Draft",
  "账号": "Account number",
  "接收人": "Recipient",
  "円": "円",
  "无多余人力(过于繁忙)": "Not enough employees (too busy)",
  "预计参加：店铺配置": "Planning to participate: Configured by Store",
  "WIFI": "WIFI",
  "无效": "Not effective",
  "应上线商户数": "Should Online Store",
  "结算信息": "Settlement Info",
  "(R$)": "(R$)",
  "关于": "About",
  "设置": "Settings",
  "担心配送质量": "Concern about delivery quality",
  "数值只能是%s位小数": "Must be rounded to %s decimal place(s)",
  "CKA": "CKA",
  "录入合同基础信息": "Enter Basic Contract Info",
  "未见KP": "Can not contact KP",
  "不参加": "Won’t participate",
  "不保存": "Discard",
  "酒精销售许可证": "License for the Sale of Alcoholic Beverages",
  "手机号": "Mobile Number",
  "疑似KA": "Predicted KA",
  "是否有效拜访": "Was the visit productive?",
  "完成培训": "Completed training",
  "请输入有效的门店id": "Please enter a valid shopid",
  "持卡人姓名": "Cardholder Name",
  "系统标记平台：": "Auto: ",
  "其他": "Other",
  "人工标记平台": "Annual",
  "品牌名称": "Brand Name",
  "选择日期": "Select date",
  "必须为%d或%d字": "Must be %d or %d characters",
  "重复门店ID": "Duplicate Store ID",
  "工商登记注册地": "Business Registry Add.",
  "白兰地": "Brandy",
  "数据": "Data",
  "复制": "Copy",
  "商户签约": "Onboarding",
  "乙方邮箱": "Party B Mailbox",
  "无营业资质": "Missing business qualifications",
  "活跃程度": "active level",
  "找不到店": "Can't locate",
  "提交开店申请商户数": "Sign Request Store",
  "不合作原因": "Reason for not partnering",
  "关联品牌名称": "Related Brand Name",
  "门店距离": "Store Distance",
  "门店名称": "Store Name",
  "陪访人": "Person(s) accompanying DiDi Rep to visit",
  "银行账户digit": "Bank Account Digit",
  "营业时间不能重复设置": "Business hours cannot be set repeatedly",
  "纳税信息": "Tax Information",
  "完善以下": "Complete the following",
  "乙方联系人手机": "Second Party Phone",
  "30天后解约": "Contract terminated after 30 days",
  "上传照片不能超过%dMB，请重新上传": "Image file size cannot exceed %dMB, please upload again",
  "电话支持字符：数字、英文逗号，录入其他符号，不允许提交": "Supported characters for phone numbers: numbers and commas (any other character will prevent submission)",
  "您当前的网络环境不太好": "Your current network environment is not very good",
  "审核失败": "Rejected",
  "模式选择": "Select Contract Format",
  "商圈": "Target Area",
  "类型": "type",
  "启动费太高": "Start-up Fee is too high",
  "加价限制": "Max Markup",
  "获得初步意向": "Showed initial interest",
  "任务ID": "Task ID",
  "不确定合作意向": "Interest in cooperation is not confirmed",
  "添加营业时间": "Add Business Hours",
  "CNPJ号必须为14位数字": "CNPJ must be an 14-digit number",
  "请输入半角片假，不能超过48个字符": "Please enter half-width katakana, cannot exceed 48 characters",
  "回收pad": "Return pad",
  "商家信息": "Store Info",
  "自配送范围及时长": "Range & Time for Store Delivery",
  "市政经营许可证": "Municipal Operation License",
  "至": "to",
  "图片": "Image",
  "未完善": "Incomplete",
  "打烊中": "Store Closed",
  "菜单": "Menu",
  "下一步": "Next",
  "正式拜访": "Prearranged visit",
  "具备上线能力": "Ready Online",
  "金额(MX$)": "Total (MX$)",
  "平台配送最低服务费": "Minimum Service Fee",
  "系统标记平台": "Auto",
  "请选择无效拜访原因": "Why wasn't the visit productive?",
  "过于繁忙": "Too busy",
  "日本": "Japan",
  "若证件类型选择“老版无Curp”，需上传补充附件": "If the \"Old Version w/o CURP\" ID type is selected",
  "拜访方式": "Visitation Method",
  "选择城市": "Select city",
  "退出登录": "Sign Out",
  "日常提醒商家上线": "Routine Reminder for Store to Go Online",
  "回收未完成": "Not returned",
  "上传最大数量为1张，图片上限为5M": "Upload up to 1 image, max file size 5MB",
  "千": "Thousand",
  "签约%d周后": "%d week(s) after signing",
  "乙方联系人CPF": "Restaurant contact's CPF",
  "照片": "Photo",
  "法人姓名": "Legal Representative",
  "营业信息": "Business Info",
  "添加电话": "Add phone number",
  "打开地图失败": "Unable to open the map",
  "商家位置": "Store location",
  "开始扣费时间": "Deduction start time",
  "我负责的": "Supervised by Me",
  "平台配送": "Platform Delivery",
  "KP邮箱": "Store Rep Email",
  "封禁": "Suspension",
  "合同信息": "Contract Information",
  "卫生安全通知": "Operation Notice (Sanitation)",
  "账号名称": "Beneficiary name",
  "现金支付": "Cash Payment",
  "座机": "Landline",
  "乙方联系人CPF照片": "Photo of restaurant contact's CPF",
  "许可证有效期": "Permit validity period",
  "还在考虑，需要追客": "Still considering it, need to follow up with the client",
  "支行名称": "Branch",
  "门店ID": "Store ID",
  "提交材料": "Submit documents",
  "失败原因": "Reason for Non-Approval",
  "无法联系到KP": "Unable to contact KP",
  "授权人": "Name of Principal",
  "手机": "Phone",
  "请输入XXX-XXXX": "Please specify XXX-XXXX",
  "我的新增": "Recent",
  "KP名片假名": "KP First Name Katakana",
  "没联系到": "Couldn't be reached",
  "不需要": "No",
  "已拜访商机数": "Visited Store",
  "仅支持数字输入": "Can only include numbers",
  "铺设失败": "Fail",
  "任务完成": "Task Completed",
  "复制链接": "Copy Link",
  "已完成": "Completed",
  "草稿中": "Draft",
  "否": "No",
  "商户主体类型": "Corporate Information",
  "经营品类": "Item Type",
  "待定": "Undermined",
  "完单量": "Order Finished",
  "担心外卖模式(不想使用外卖模式)": "Worried about using food delivery mode (doesn’t want to use food delivery mode)",
  "乙方注册地址邮编": "Postal Code of Party B's Registered Address",
  "营业执照": "Business license",
  "账户余额：": "Account Amount: ",
  "结算信息照片": "Payment Photo",
  "价格信息": "Pricing Info",
  "证件类型": "INE/INF",
  "威士忌": "Whiskey",
  "在线": "Online",
  "销售姓名": "DiDi Rep",
  "合同照片": "Photo of Contract",
  "龙舌兰酒": "Tequila",
  "编辑商机成功": "Lead data successfully edited",
  "拜访对象": "Person to Be Visited",
  "营业中": "Store Opened",
  "请输入数字": "Can only include numbers",
  "全部": "All",
  "取消订单量": "Order Cancelled ",
  "电话": "Call",
  "请输入门店名称搜索": "Enter Store Name",
  "当前门店总数": "Total Store Reps",
  "已签约商户数": "Signed Store",
  "日常维护": "Routine Support",
  "合同版本": "Contract Version",
  "商机价值": "Leads Rank",
  "联系方式": "Contact information",
  "管控状态：": "Control Status: ",
  "审批中": "Verifying",
  "拜访目标": "Purpose of Visit",
  "门店类型": "Store Type",
  "创建成功": "Addition Successful",
  "账户类型": "Account Type",
  "KA BD": "KA BD",
  "门店名称片假名": "Store Name Katakana",
  "乙方注册地址片假名": "Second Party Registered Address Katakana",
  "对私": "Private",
  "个人企业": "Individual Entrepreneur",
  "订单均价": "Average Order Price",
  "需要完善": "Form is incomplete",
  "撤销申请": "Cancellation Request",
  "请先输入门店地址": "Please first enter store address",
  "默认": "Default",
  "请补全营业时间": "Add Business Hours",
  "校准POI": "Calibrate Coordinates",
  "全部门店": "All stores",
  "不支持": "No",
  "暂停经营": "Temporarily closed",
  "添加营业时间段": "Add Hours",
  "合同基础信息": "Basic Contract Info",
  "请输入5位有效数字": "Enter a valid 5-digit number",
  "提交审批后，在审批过程中信息不可修改，是否确认提交？": "Information cannot be modified after submitted for approval. Proceed with submission?",
  "证件号": "Document No.",
  "有限责任公司": "Company - Limited Liability Company",
  "长期有效": "Long-term validity",
  "乙方注册地址": "Second Party Registered Address",
  "饮料店期间限定酒品贩卖准证": "Liquor Retail License with time limit",
  "请录入关闭原因": "Please input the closing reason",
  "土地使用许可证": "Land Use Feasibility",
  "重复门店": "Duplicated",
  "普通商家": "General Store",
  "距离": "Distance",
  "不小于%d": " not less than %d",
  "不愿完成": "Not willing to complete it",
  "推迟发放": "Postponed issuance",
  "必须为%d字": "Must be %d characters",
  "担心外卖模式": "Mistrust on food delviery",
  "当该餐厅存在多个经营者时，此处必须填写合同签署人或授权合同签署人姓名": "If a restaurant has multiple operators, the names of all contract signatories or authorized agents must be filled in here.",
  "提交成功！": "Submission successful!",
  "未完成PAD发放": "Not finished issuing pad(s)",
  "有效商机数": "Effective Leads",
  "无相关信息": "No data available",
  "查看拜访记录": "View visit records",
  "抽佣：": "Commission: ",
  "删除": "Delete",
  "银行卡号": "Bank Account No.",
  "其他信息": "Other Information",
  "起始时间": "Start Date",
  "预计进行改善": "Planning to make improvements",
  "不愿改善": "Unwilling to make improvements",
  "签约数据": "Acquisition Data",
  "登记簿照片": "Register Photo",
  "电销团队": "Telemarketing Team",
  "完成时间": "Completed at",
  "放弃原因": "Reason for discarding",
  "KP电话:": "Store Rep Phone",
  "完成PAD发放": "Finished issuing pad(s)",
  "完成工作": "Complete work",
  "提交中": "In Progress",
  "营业时间段": "Business Hours",
  "任务完成标准": "Task Completion Requirements",
  "商户官网": "Store's Official Website",
  "门脸照片": "Photo of Storefront",
  "门店电话:": "Store Phone No.",
  "新建商机成功": "New lead successfully added",
  "添加拜访计划": "Add visit plan",
  "营业执照照片": "Business license Photo",
  "驾照": "Driver's License",
  "个人信息": "My Profile",
  "订单量": "Order Launched",
  "董事": "Director",
  "有效期": "Validity Period",
  "周三": "Wed",
  "高端饭店": "Concept",
  "是否已经加入其他外卖平台？": "Does the store work with another delivery platform?",
  "周一": "Mon",
  "点击查看原因": "View Details",
  "去修改": "Modify",
  "KP电话是店长账户": "KP phone is the manager account",
  "确认要清空搜索记录吗？": "Clear search history?",
  "状态机": "State Machine",
  "暂无数据": "No Data",
  "拜访详情": "Visit",
  "启动费": "Activation fee",
  "疑似CKA": "Predicted CKA",
  "选择职位": "Select Job Title",
  "提交人": "Submitter",
  "签约信息": "Contract Details",
  "审核中": "Verifying",
  "请输入半角片假名": "Please enter half-width katakana",
  "请选择无意愿原因": "Specify reason for lack of interest",
  "（多选）": "(Multiselect)",
  "上一步": "Previous",
  "周五": "Fri",
  "执行人": "Assigned to",
  "填写拜访备注可供后续跟进参考": "Add remarks; can include follow-up points from the visit",
  "扣费次数大于等于1": "Deduction times greater than or equal to 1",
  "线下": "In person",
  "效率": "Efficiency",
  "无效商机": "Invalid Lead",
  "拜访历史": "Visit Logs",
  "封禁中": "Suspended by platform",
  "原因": "Reason",
  "CPF号必须为11位数字": "CPF must be an 11-digit number",
  "周二": "Tue",
  "保存": "Save",
  "商户号": "Store No.",
  "参加": "Will Participate",
  "万": "Ten thousand",
  "乙方联系方式": "Second Party Phone",
  "加价限制（%）": "Max Markup",
  "上传交付照片": "Upload photo of tablet handover",
  "商户主体类型为公司时需提供此项内容": "Required if the store entity type is a company",
  "编辑经营信息": "Edit Ops Data",
  "开户公司CNPJ": "CNPJ of company opening account",
  "门店信息": "Store Info",
  "当前数据计算至:": "Current data updated to: ",
  "店长": "Store Manager",
  "已完成培训": "Training completed",
  "不限": "No limit",
  "品牌授权书": "Brand Authorization",
  "P1": "P1",
  "请输入3位有效数字": "Enter a valid 3-digit number",
  "P0": "P0",
  "P2": "P2",
  "转让": "Sold to others",
  "自入驻": "settle in",
  "老版有Curp": "Old Version w/ CURP",
  "店内环境": "Photo of Interior",
  "详细原因": "Detailed Reason",
  "金酒": "Gin",
  "请输入7位有效数字": "Enter a valid 7-digit number",
  "签字授权书": "Signature Authorization",
  "无效原因": "Reason for being invalid",
  "持卡人地址": "Cardholder Address",
  "拜访备注": "Visit Remarks",
  "标记问题门店": "Report Store Problem",
  "已完善": "Completed",
  "指定": "Determinate",
  "发起者": "Initiator",
  "抽佣问题": "Take rate issue",
  "合法代表": "Legal representative",
  "自定义": "Custom",
  "店铺主体类型是法人时必填（13位数，国税厅公布的法人号码）": "Required if the main body type of the store is a legal person (13 digits, legal person number announced by the National Tax Agency)",
  "单次最大扣费金额(MX$)": "Maximum single-order charge (MX$)",
  "重复门店名称": "Duplicate Store Name",
  "KP姓名": "Store Rep Name",
  "IMEI": "IMEI",
  "负责人表示不合作": "Person in charge indicated no interest in cooperation",
  "去升级": "UPGRADE NOW",
  "将本页截图发送至didi@didichuxing.com;总部进行人工线下校验，并在7日内反馈申诉结果;": "Send a screenshot of this page to didi@didichuxing.com; the Head Office will perform a manual inspection and respond to the appeal within 7 days.",
  "银行代理digit": "Banking Agency Digit",
  "巴西": "Brazil",
  "捡入": "Claim",
  "线上支付": "Online Payment",
  "竞品独家签约": "Exclusive contract with competitor",
  "总评价人数": "Number of Raters",
  "周六": "Sat",
  "门店电话": "Store Phone",
  "标红信息即可完成添加": "Complete all fields marked in red",
  "疑似CKA/KA": "Predicted CKA/KA",
  "执行者": "Assigned to",
  "法人CPF照片": "Photo of legal representative's CPF",
  "待办事项": "Remaining Tasks",
  "预计休业": "Planning to cease business operations",
  "其他筛选": "Other Filters",
  "是否自配送：": "Store Delivery: ",
  "当前定位失败": "Positioning failed",
  "优先级": "Priority",
  "任务来源": "Task Source",
  "可提现金额：": "Withdrawable Amount(MX): ",
  "自配送订单量（单/周）": "Self delivery daily Sold Number(Orders/Week)",
  "审核完成": "Verification completed",
  "店员": "Employee",
  "冻结金额：": "Funds Frozen(MX): ",
  "签约状态：": "Signing Status: ",
  "时间格式错误": "Time format error",
  "审批失败": "Rejected",
  "确定合作": "Cooperation confirmed",
  "啤酒": "Beer",
  "接收电子合同的邮箱": "Mailbox to receive electronic contract",
  "门店照片": "Store Photo",
  "电话预约": "Schedule a Visit",
  "选择商圈": "Select target area",
  "KA": "KA",
  "结束时间": "End Time",
  "确认银行卡号": "Confirm Bank Card No.",
  "在留卡": "Residence Card",
  "访谈&调研": "Interview & Survey",
  "承诺": "Promise",
  "实际上线商户数": "Actual Online Store",
  "暂不支持复制功能": "Copy feature unavailable",
  "不能为空": "cannot be left blank",
  "暂停营业": "Temporarily closed",
  "提案失败": "Pitch was unsuccessful",
  "经营信息": "Operations Data",
  "依据门店POI反解": "Based on store coordinates",
  "拜访结果": "Visit result",
  "乙方联系人姓": "Party B Contact last Name",
  "银行卡号必须为18位": "Bank card no. must be 18 digits",
  "储蓄": "Savings",
  "首位必须是1，必须输入11位": "The first digital must be 1 and must be in 11digital",
  "无银行账号": "No bank account",
  "KP所属部门": "KP Department",
  "成功留存": "Successfully retained",
  "伏特加": "Vodka",
  "暂时不愿上线": "Unwilling to go online at this time",
  "沟通经营问题": "Discuss Operating Issues",
  "支持": "Yes",
  "请输入正确的邮箱地址": "Please enter a valid email address",
  "确认要退出吗？": "Are you sure you want to sign out?",
  "乙方联系人": "Party B Contact",
  "公证编号和地区": "Notary Number and Region",
  "后续陌拜": "Subsequent cold call",
  "持卡人名": "Cardholder First Name",
  "通过时间": "Approval Time",
  "请输入银行名称或五十音": "Enter beneficiary bank",
  "指已签约并且上线接单的门店": "Refers to stores that have signed a contract and are currently accepting orders",
  "线下店铺菜单": "Menu Photos",
  "无多余人力": "Lack capacity",
  "格式错误": "Format Error",
  "合同生效日期": "Effective Date of Contract",
  "分发失败": "unable to assign",
  "使用此功能需升级至最新版本": "To access this feature, you’ll need to update to the latest version.",
  "任务分发": "Assign Task",
  "乙方联系人名片假名": "Party B Contact first Name Katakana",
  "ESC": "ESC",
  "无法获取手机定位，请检查": "Unable to retrieve phone location. Please check",
  "上传最大数量为3张，图片上限为5M": "Upload up to 3 image, max file size 5MB",
  "佣金审核证明": "Certificate of reward review",
  "范围": "Area",
  "公司公证": "Company Certificates",
  "审核通过": "Verified",
  "查看申请": "View Application",
  "未签约": "Not signed",
  "申请签约": "Request Signing",
  "已校准": "Coordinates saved",
  "审核结束": "Verification results",
  "具备上线能力商户数": "Ready Online Store",
  "邮编": "Zip Code",
  "手机和座机都只支持10位数字": "Mobile and landlines must be 10-digit numbers",
  "不允许特殊字符": "Cannot contain special characters",
  "KP姓": "KP Last Name",
  "店内桌数（桌）": "Table Count",
  "待提交": "To be submitted",
  "附件说明": "Description of Attachments",
  "查看示例": "View example",
  "工商登记号码": "Business Registry No.",
  "去填写": "Add Info",
  "待办理": "Unfinished",
  "账户状态：": "Account Status: ",
  "设备铺设结果": "Device Configuration Result",
  "上传失败，请重新上传": "Upload failed, please upload again",
  "支持上传附件，含关键信息页需单独拍照上传至【执照照片】": "Can upload attachments. Key Information page should be separately photographed and uploaded to [Photo of License].",
  "签约中": "In progress",
  "不需要pad": "Tablet not required",
  "高端饭店不做外卖": "High-end restaurant without take-away service",
  "最多%d个": "Max %d",
  "合同编号": "Contract No.",
  "门店POI": "Store Location",
  "开店信息": "Info for Opening Store",
  "商家开店检查": "Shop Inspection",
  "KP电话（仅支持手机）": "Store Rep Phone(Handphone only)",
  "关联签约主体名称": "Related Signatory’s Name",
  "法人姓片假名": "Legal person last Name Katakana",
  "成功": "Successful",
  "开始时间": "Start time",
  "审批邮件": "Approval Mail",
  "门店品类": "Store Categories",
  "运营数据": "Engagement Data",
  "新建商机": "Add New Lead",
  "任务基础信息": "Task Info",
  "食堂订单量（单/周）": "Dine-in Volume(Dine-in Volume)",
  "新版": "New version",
  "需要": "Yes",
  "佣金策略合同模板": "Contract with commission subsidy",
  "任务详情": "Task Details",
  "预计参加：DiDi配置": "Planning to participate: Configured by DiDi",
  "请选择等待原因": "Select reason for waiting",
  "信息尚未保存，是否保存？": "You have unsaved changes. Save now?",
  "请选择接收人": "Select recipient",
  "股份有限公司": "Company - Public Limited Company",
  "乙方联系人头衔": "Title",
  "处理时间": "Processed at",
  "打款": "Payment",
  "资质类型": "Type",
  "门店价值": "Store Value",
  "编辑": "Edit",
  "当前位置距商家": "Current location is",
  "商家是否在线：": "Online Status: ",
  "护照": "Passport",
  "发起验证申请": "Verify Payment Account",
  "银行账户number": "Bank Account Number",
  "请填写真实原因": "Specify the actual reason",
  "不能超过%d": "Cannot exceed %d",
  "公证日期": "Date of Notarization",
  "已签章": "Signed Contract",
  "商户留存措施": "Store Retention Measures",
  "自配送": "Store Delivery",
  "失败原因详情": "Reason for Non-Approval",
  "金额(円)": "Total(MX$)",
  "土地使用许可证执照照片": "Photo of Permit",
  "签约": "Sign Contract",
  "任务": "Task",
  "首次完成签约时间": "First Signature Time",
  "当前门店总数=未签约门店+签约中门店+已签约门店": "Total Number of Stores = Stores not yet signed + Stores currently signing + Stores with signed contracts",
  "上传最大数量为%d张，图片上限为%dM": "Upload up to %d image(s), max image size %dMB",
  "法人名": "Legal person first Name",
  "个人": "Individual",
  "确定合作，准备收集资料": "Cooperation confirmed, prepare to collect info",
  "上传最大数量为1张，图片上限为5MB": "Upload up to 1 image, max file size 5MB",
  "乙方联系方式是超级管理员账户": "Party B's contact information is a super administrator account",
  "乙方联系人名": "Party B Contact first Name",
  "乙方联系人姓片假名": "Party B Contact last Name Katakana",
  "有效在线商户数": "Effective Online Store",
  "歇业中": "Business Closed",
  "基础信息": "Basic Information",
  "销售电话": "DiDi Rep Phone",
  "重复门店与创建门店的距离": "Distance Between Duplicate Store and New Store",
  "门店": "Store",
  "全部区域": "All Regions",
  "拆迁": "Relocated",
  "请选择失败原因": "Specify reason for failure",
  "搜索记录": "Search History",
  "门店地址片假名": "Store Address Katakana",
  "未添加": "Not added",
  "加载中": "loading",
  "请输入12位有效数字": "Enter a valid 12-digit number",
  "不愿上线": "Unwilling to go online",
  "CKA/KA BD": "CKA/KA BD",
  "完成电话": "Completed calling",
  "乙方名称": "Party B Name",
  "更新时间": "Update time",
  "标准合同模板": "Standard Template Contract",
  "签约状态（多选）": "Contract Status (Multiselect)",
  "12位数，法人登记簿上的号码": "12 digits, the number on the legal person register",
  "请在Gattaran查看": "See more info on Gattaran",
  "被授权人证件照片": "Photo of Agent ID",
  "希望解约/回收pad": "Wants to terminate contract / return pad",
  "乙方联系方式（仅支持手机）": "Second Party Phone( Handphone only)",
  "附件类型": "Attachment Type",
  "计划完成设置": "Planning to complete configuration",
  "有合作意向": "Interested in partnership",
  "非餐饮": "Non-F&B",
  "附件文件": "Supplemental Documents",
  "法人信息": "Corporate Information",
  "点击上传": "Upload",
  "扣费次数": "Number of Deductions",
  "培训使用方法": "System training",
  "陌拜": "Cold calling",
  "已完成改善": "Improvements completed",
  "扣费比例": "Deduction proportion",
  "预定上线": "Planning to go online",
  "没有更多数据了": "No more data available",
  "未知": "unknown",
  "提交": "Submit",
  "填写拜访信息": "Briefly summarize the visit",
  "新功能培训": "Training for New Features/Functions",
  "详细录入规则": "View Format Rules",
  "不再发放": "Won't issue again",
  "门店详情": "Store Details",
  "提交时间": "Submitted on",
  "登记簿": "Register",
  "备注": "Remarks",
  "不在线": "Offline",
  "提交后将无法正常签约": "Normal signature process will be unavailable after submission",
  "铺设成功": "Success",
  "催促商家首次上线": "Remind store to go online for the first time",
  "对公": "Pulbic",
  "商户运营价值": "Shop Rank",
  "米": "m from the store",
  "创建失败": "Addition Failed",
  "已核准": "Approved",
  "确认签章时需上传合同附件，请在Gattaran完成确认！": "When verifying a signature, you must upload contract appendices. Please complete verification on Gattaran.",
  "提交至审批": "Submit for Approval",
  "在线状态：": "In business:",
  "资质信息": "Qualifications",
  "物料发放": "Issuance of Supplies",
  "姓名": "Name",
  "Opening Call": "Opening Call",
  "两次银行卡号不一致！": "Bank card numbers do not match!",
  "取消": "Cancel",
  "法人证件": "Photo of Corporate INE/IFE",
  "门店营业时间": "Store Hours",
  "无法获取应用版本信息": "App version info could not be retrieved",
  "商家位置为": "Store location",
  "Curp号必须为大写字母": "CURP must be in all uppercase letters",
  "活动招商": "Event Promotions",
  "墨西哥": "Mexico",
  "资料录入": "Input Data",
  "地区与语言": "Region and Language",
  "平台配送佣金比例": "Service Fee Rate for Platform Delivery",
  "待完成": "In Progress",
  "开户公司名": "Name of company opening account",
  "选项和输入框不能为空": "All required fields must be completed",
  "邮件&短信已发送给商家": "Email and SMS sent to store",
  "您提交的无效原因有误，请检查": "The invalid reason you submitted is wrong, please check",
  "本模块支持上传文件，可至PC端操作": "Documents can be uploaded via the PC version of the app",
  "确定要验证当前店铺的银行卡号？点击【确定】发起【支付验证】申请": "Are you sure you want to verify the current store's bank account? Tap 'OK' to verify",
  "发送邮件&短信": "Send Email & SMS",
  "正常门店": "Normal Store",
  "设备铺设": "Device Setup",
  "销售数据": "Sales Data",
  "请选择无效原因": "Select reason for being invalid"
}